import "@vanilla-extract/css";
import classNames from "classnames";
import * as React from "react";
import React__default, { forwardRef, useContext, isValidElement, cloneElement, Children, useState, createContext, useRef, useCallback, Suspense, useMemo, useEffect } from "react";
import ReactDOM, { createPortal } from "react-dom";
var skeletonAnimation = "commonStyles_skeletonAnimation__e0bve40";
var flexCenter = "commonStyles_flexCenter__e0bve41";
var scrollBar = "commonStyles_scrollBar__e0bve42";
const styles = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  flexCenter,
  scrollBar,
  skeletonAnimation
}, Symbol.toStringTag, { value: "Module" }));
const getPortalDomElement = () => document.querySelector("#storybook-portal-root") || document.querySelector("#d-portal-root") || document.body;
const Portal = ({ children }) => {
  const portalRoot = React__default.useMemo(() => {
    if (typeof document !== "undefined") {
      return getPortalDomElement();
    }
  });
  return portalRoot ? createPortal(children, portalRoot) : null;
};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function getAugmentedNamespace(n) {
  if (Object.prototype.hasOwnProperty.call(n, "__esModule")) return n;
  var f = n.default;
  if (typeof f == "function") {
    var a = function a2() {
      if (this instanceof a2) {
        return Reflect.construct(f, arguments, this.constructor);
      }
      return f.apply(this, arguments);
    };
    a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, "__esModule", { value: true });
  Object.keys(n).forEach(function(k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function() {
        return n[k];
      }
    });
  });
  return a;
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f = React__default, k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = { key: true, ref: true, __self: true, __source: true };
  function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for (b in a) m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for (b in a = c.defaultProps, a) void 0 === d[b] && (d[b] = a[b]);
    return { $$typeof: k, type: c, key: e, ref: h, props: d, _owner: n.current };
  }
  reactJsxRuntime_production_min.Fragment = l;
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  return reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var React2 = React__default;
      var REACT_ELEMENT_TYPE = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") {
          return null;
        }
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") {
          return maybeIterator;
        }
        return null;
      }
      var ReactSharedInternals = React2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error2(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format, args);
          }
        }
      }
      function printWarning(level, format, args) {
        {
          var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame2.getStackAddendum();
          if (stack !== "") {
            format += "%s";
            args = args.concat([stack]);
          }
          var argsWithFormat = args.map(function(item) {
            return String(item);
          });
          argsWithFormat.unshift("Warning: " + format);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }
      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }
      function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") {
          return true;
        }
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (typeof type === "object" && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) {
            return true;
          }
        }
        return false;
      }
      function getWrappedName2(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) {
          return displayName;
        }
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
      }
      function getContextName(type) {
        return type.displayName || "Context";
      }
      function getComponentNameFromType(type) {
        if (type == null) {
          return null;
        }
        {
          if (typeof type.tag === "number") {
            error2("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
          }
        }
        if (typeof type === "function") {
          return type.displayName || type.name || null;
        }
        if (typeof type === "string") {
          return type;
        }
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return "Fragment";
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_PROFILER_TYPE:
            return "Profiler";
          case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
          case REACT_SUSPENSE_TYPE:
            return "Suspense";
          case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
              return getWrappedName2(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;
              if (outerName !== null) {
                return outerName;
              }
              return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return getComponentNameFromType(init(payload));
              } catch (x) {
                return null;
              }
            }
          }
        }
        return null;
      }
      var assign2 = Object.assign;
      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;
      function disabledLog() {
      }
      disabledLog.__reactDisabledLog = true;
      function disableLogs() {
        {
          if (disabledDepth === 0) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            };
            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
          }
          disabledDepth++;
        }
      }
      function reenableLogs() {
        {
          disabledDepth--;
          if (disabledDepth === 0) {
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            };
            Object.defineProperties(console, {
              log: assign2({}, props, {
                value: prevLog
              }),
              info: assign2({}, props, {
                value: prevInfo
              }),
              warn: assign2({}, props, {
                value: prevWarn
              }),
              error: assign2({}, props, {
                value: prevError
              }),
              group: assign2({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign2({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign2({}, props, {
                value: prevGroupEnd
              })
            });
          }
          if (disabledDepth < 0) {
            error2("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
          }
        }
      }
      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix2;
      function describeBuiltInComponentFrame(name2, source, ownerFn) {
        {
          if (prefix2 === void 0) {
            try {
              throw Error();
            } catch (x) {
              var match2 = x.stack.trim().match(/\n( *(at )?)/);
              prefix2 = match2 && match2[1] || "";
            }
          }
          return "\n" + prefix2 + name2;
        }
      }
      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }
      function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) {
          return "";
        }
        {
          var frame = componentFrameCache.get(fn);
          if (frame !== void 0) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current;
          ReactCurrentDispatcher.current = null;
          disableLogs();
        }
        try {
          if (construct) {
            var Fake = function() {
              throw Error();
            };
            Object.defineProperty(Fake.prototype, "props", {
              set: function() {
                throw Error();
              }
            });
            if (typeof Reflect === "object" && Reflect.construct) {
              try {
                Reflect.construct(Fake, []);
              } catch (x) {
                control = x;
              }
              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x) {
                control = x;
              }
              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x) {
              control = x;
            }
            fn();
          }
        } catch (sample) {
          if (sample && control && typeof sample.stack === "string") {
            var sampleLines = sample.stack.split("\n");
            var controlLines = control.stack.split("\n");
            var s = sampleLines.length - 1;
            var c = controlLines.length - 1;
            while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
              c--;
            }
            for (; s >= 1 && c >= 0; s--, c--) {
              if (sampleLines[s] !== controlLines[c]) {
                if (s !== 1 || c !== 1) {
                  do {
                    s--;
                    c--;
                    if (c < 0 || sampleLines[s] !== controlLines[c]) {
                      var _frame = "\n" + sampleLines[s].replace(" at new ", " at ");
                      if (fn.displayName && _frame.includes("<anonymous>")) {
                        _frame = _frame.replace("<anonymous>", fn.displayName);
                      }
                      {
                        if (typeof fn === "function") {
                          componentFrameCache.set(fn, _frame);
                        }
                      }
                      return _frame;
                    }
                  } while (s >= 1 && c >= 0);
                }
                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        }
        var name2 = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name2 ? describeBuiltInComponentFrame(name2) : "";
        {
          if (typeof fn === "function") {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }
      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }
      function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }
      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return "";
        }
        if (typeof type === "function") {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }
        if (typeof type === "string") {
          return describeBuiltInComponentFrame(type);
        }
        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame("Suspense");
          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
              } catch (x) {
              }
            }
          }
        }
        return "";
      }
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }
      function checkPropTypes(typeSpecs, values2, location, componentName, element) {
        {
          var has2 = Function.call.bind(hasOwnProperty);
          for (var typeSpecName in typeSpecs) {
            if (has2(typeSpecs, typeSpecName)) {
              var error$12 = void 0;
              try {
                if (typeof typeSpecs[typeSpecName] !== "function") {
                  var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  err.name = "Invariant Violation";
                  throw err;
                }
                error$12 = typeSpecs[typeSpecName](values2, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ex) {
                error$12 = ex;
              }
              if (error$12 && !(error$12 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error2("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$12);
                setCurrentlyValidatingElement(null);
              }
              if (error$12 instanceof Error && !(error$12.message in loggedTypeFailures)) {
                loggedTypeFailures[error$12.message] = true;
                setCurrentlyValidatingElement(element);
                error2("Failed %s type: %s", location, error$12.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }
      var isArrayImpl = Array.isArray;
      function isArray(a) {
        return isArrayImpl(a);
      }
      function typeName(value2) {
        {
          var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
          var type = hasToStringTag && value2[Symbol.toStringTag] || value2.constructor.name || "Object";
          return type;
        }
      }
      function willCoercionThrow(value2) {
        {
          try {
            testStringCoercion(value2);
            return false;
          } catch (e) {
            return true;
          }
        }
      }
      function testStringCoercion(value2) {
        return "" + value2;
      }
      function checkKeyStringCoercion(value2) {
        {
          if (willCoercionThrow(value2)) {
            error2("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value2));
            return testStringCoercion(value2);
          }
        }
      }
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      function hasValidRef(config2) {
        {
          if (hasOwnProperty.call(config2, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config2, "ref").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config2.ref !== void 0;
      }
      function hasValidKey(config2) {
        {
          if (hasOwnProperty.call(config2, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config2, "key").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config2.key !== void 0;
      }
      function warnIfStringRefCannotBeAutoConverted(config2, self) {
        {
          if (typeof config2.ref === "string" && ReactCurrentOwner.current && self) ;
        }
      }
      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error2("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }
      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error2("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }
      var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type,
          key,
          ref,
          props,
          // Record the component responsible for creating this element.
          _owner: owner
        };
        {
          element._store = {};
          Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          });
          Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
          });
          Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });
          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };
      function jsxDEV(type, config2, maybeKey, source, self) {
        {
          var propName;
          var props = {};
          var key = null;
          var ref = null;
          if (maybeKey !== void 0) {
            {
              checkKeyStringCoercion(maybeKey);
            }
            key = "" + maybeKey;
          }
          if (hasValidKey(config2)) {
            {
              checkKeyStringCoercion(config2.key);
            }
            key = "" + config2.key;
          }
          if (hasValidRef(config2)) {
            ref = config2.ref;
            warnIfStringRefCannotBeAutoConverted(config2, self);
          }
          for (propName in config2) {
            if (hasOwnProperty.call(config2, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config2[propName];
            }
          }
          if (type && type.defaultProps) {
            var defaultProps2 = type.defaultProps;
            for (propName in defaultProps2) {
              if (props[propName] === void 0) {
                props[propName] = defaultProps2[propName];
              }
            }
          }
          if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }
            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }
          return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
        }
      }
      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }
      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      function isValidElement2(object) {
        {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
      }
      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name2 = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name2) {
              return "\n\nCheck the render method of `" + name2 + "`.";
            }
          }
          return "";
        }
      }
      function getSourceInfoErrorAddendum(source) {
        {
          return "";
        }
      }
      var ownerHasKeyUseWarning = {};
      function getCurrentComponentErrorInfo(parentType) {
        {
          var info2 = getDeclarationErrorAddendum();
          if (!info2) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) {
              info2 = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }
          return info2;
        }
      }
      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }
          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
          var childOwner = "";
          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
          }
          setCurrentlyValidatingElement$1(element);
          error2('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }
      function validateChildKeys(node2, parentType) {
        {
          if (typeof node2 !== "object") {
            return;
          }
          if (isArray(node2)) {
            for (var i = 0; i < node2.length; i++) {
              var child = node2[i];
              if (isValidElement2(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement2(node2)) {
            if (node2._store) {
              node2._store.validated = true;
            }
          } else if (node2) {
            var iteratorFn = getIteratorFn(node2);
            if (typeof iteratorFn === "function") {
              if (iteratorFn !== node2.entries) {
                var iterator = iteratorFn.call(node2);
                var step;
                while (!(step = iterator.next()).done) {
                  if (isValidElement2(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }
      function validatePropTypes(element) {
        {
          var type = element.type;
          if (type === null || type === void 0 || typeof type === "string") {
            return;
          }
          var propTypes2;
          if (typeof type === "function") {
            propTypes2 = type.propTypes;
          } else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes2 = type.propTypes;
          } else {
            return;
          }
          if (propTypes2) {
            var name2 = getComponentNameFromType(type);
            checkPropTypes(propTypes2, element.props, "prop", name2, element);
          } else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true;
            var _name = getComponentNameFromType(type);
            error2("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
          }
          if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) {
            error2("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
          }
        }
      }
      function validateFragmentProps(fragment) {
        {
          var keys = Object.keys(fragment.props);
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (key !== "children" && key !== "key") {
              setCurrentlyValidatingElement$1(fragment);
              error2("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }
          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error2("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
          }
        }
      }
      function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        {
          var validType = isValidElementType(type);
          if (!validType) {
            var info2 = "";
            if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
              info2 += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            }
            var sourceInfo = getSourceInfoErrorAddendum();
            if (sourceInfo) {
              info2 += sourceInfo;
            } else {
              info2 += getDeclarationErrorAddendum();
            }
            var typeString;
            if (type === null) {
              typeString = "null";
            } else if (isArray(type)) {
              typeString = "array";
            } else if (type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
              info2 = " Did you accidentally export a JSX literal instead of a component?";
            } else {
              typeString = typeof type;
            }
            error2("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info2);
          }
          var element = jsxDEV(type, props, key, source, self);
          if (element == null) {
            return element;
          }
          if (validType) {
            var children = props.children;
            if (children !== void 0) {
              if (isStaticChildren) {
                if (isArray(children)) {
                  for (var i = 0; i < children.length; i++) {
                    validateChildKeys(children[i], type);
                  }
                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error2("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }
          if (type === REACT_FRAGMENT_TYPE) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }
          return element;
        }
      }
      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }
      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }
      var jsx3 = jsxWithValidationDynamic;
      var jsxs = jsxWithValidationStatic;
      reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
      reactJsxRuntime_development.jsx = jsx3;
      reactJsxRuntime_development.jsxs = jsxs;
    })();
  }
  return reactJsxRuntime_development;
}
var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  if (hasRequiredJsxRuntime) return jsxRuntime.exports;
  hasRequiredJsxRuntime = 1;
  if (process.env.NODE_ENV === "production") {
    jsxRuntime.exports = requireReactJsxRuntime_production_min();
  } else {
    jsxRuntime.exports = requireReactJsxRuntime_development();
  }
  return jsxRuntime.exports;
}
var jsxRuntimeExports = requireJsxRuntime();
var fullWidth$1 = "button_fullWidth__rfql4s1";
var small$7 = "button_small__rfql4s2";
var regular = "button_regular__rfql4s3";
var primary = "button_primary__rfql4s4 button_defaultLayout__rfql4s0";
var secondary = "button_secondary__rfql4s5 button_defaultLayout__rfql4s0";
var tertiary = "button_tertiary__rfql4s6 button_defaultLayout__rfql4s0";
var fourth = "button_fourth__rfql4s7 button_defaultLayout__rfql4s0";
var plain = "button_plain__rfql4s8 button_defaultLayout__rfql4s0";
var destructive = "button_destructive__rfql4s9 button_defaultLayout__rfql4s0";
const variants$8 = {
  primary,
  secondary,
  tertiary,
  fourth,
  plain,
  destructive
};
const sizes$g = {
  small: small$7,
  regular
};
const Button$2 = ({
  className,
  children,
  variant = "primary",
  size = "regular",
  fullWidth: fullWidth2 = true,
  ...props
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "button",
  {
    ...props,
    className: classNames(variants$8[variant], sizes$g[size], { [fullWidth$1]: fullWidth2 }, className),
    children
  }
);
const common = {
  black: "#000",
  white: "#fff"
};
const red = {
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
};
const purple = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2"
};
const blue = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  700: "#1976d2",
  800: "#1565c0"
};
const lightBlue = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
};
const green = {
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
};
const orange = {
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
};
const grey = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
};
function formatMuiErrorMessage$1(code) {
  let url = "https://mui.com/production-error/?code=" + code;
  for (let i = 1; i < arguments.length; i += 1) {
    url += "&args[]=" + encodeURIComponent(arguments[i]);
  }
  return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
}
const formatMuiErrorMessage = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: formatMuiErrorMessage$1
}, Symbol.toStringTag, { value: "Module" }));
const THEME_ID = "$$material";
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
    }
    return n;
  }, _extends$1.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r2, e) {
  if (null == r2) return {};
  var t = {};
  for (var n in r2) if ({}.hasOwnProperty.call(r2, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r2[n];
  }
  return t;
}
function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }
  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  }
  return void 0;
}
function createStyleElement(options) {
  var tag = document.createElement("style");
  tag.setAttribute("data-emotion", options.key);
  if (options.nonce !== void 0) {
    tag.setAttribute("nonce", options.nonce);
  }
  tag.appendChild(document.createTextNode(""));
  tag.setAttribute("data-s", "");
  return tag;
}
var StyleSheet = /* @__PURE__ */ function() {
  function StyleSheet2(options) {
    var _this = this;
    this._insertTag = function(tag) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag, before);
      _this.tags.push(tag);
    };
    this.isSpeedy = options.speedy === void 0 ? true : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce;
    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet2.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert(rule) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    this.tags.forEach(function(tag) {
      var _tag$parentNode;
      return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };
  return StyleSheet2;
}();
var MS = "-ms-";
var MOZ = "-moz-";
var WEBKIT = "-webkit-";
var COMMENT = "comm";
var RULESET = "rule";
var DECLARATION = "decl";
var IMPORT = "@import";
var KEYFRAMES = "@keyframes";
var LAYER = "@layer";
var abs = Math.abs;
var from = String.fromCharCode;
var assign = Object.assign;
function hash(value2, length2) {
  return charat(value2, 0) ^ 45 ? (((length2 << 2 ^ charat(value2, 0)) << 2 ^ charat(value2, 1)) << 2 ^ charat(value2, 2)) << 2 ^ charat(value2, 3) : 0;
}
function trim(value2) {
  return value2.trim();
}
function match(value2, pattern) {
  return (value2 = pattern.exec(value2)) ? value2[0] : value2;
}
function replace(value2, pattern, replacement) {
  return value2.replace(pattern, replacement);
}
function indexof(value2, search) {
  return value2.indexOf(search);
}
function charat(value2, index) {
  return value2.charCodeAt(index) | 0;
}
function substr(value2, begin, end) {
  return value2.slice(begin, end);
}
function strlen(value2) {
  return value2.length;
}
function sizeof(value2) {
  return value2.length;
}
function append(value2, array) {
  return array.push(value2), value2;
}
function combine(array, callback) {
  return array.map(callback).join("");
}
var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = "";
function node(value2, root2, parent, type, props, children, length2) {
  return { value: value2, root: root2, parent, type, props, children, line, column, length: length2, return: "" };
}
function copy(root2, props) {
  return assign(node("", null, null, "", null, null, 0), root2, { length: -root2.length }, props);
}
function char() {
  return character;
}
function prev() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10)
    column = 1, line--;
  return character;
}
function next() {
  character = position < length ? charat(characters, position++) : 0;
  if (column++, character === 10)
    column = 1, line++;
  return character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(begin, end) {
  return substr(characters, begin, end);
}
function token(type) {
  switch (type) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(value2) {
  return line = column = 1, length = strlen(characters = value2), position = 0, [];
}
function dealloc(value2) {
  return characters = "", value2;
}
function delimit(type) {
  return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function whitespace(type) {
  while (character = peek())
    if (character < 33)
      next();
    else
      break;
  return token(type) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(index, count2) {
  while (--count2 && next())
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97)
      break;
  return slice(index, caret() + (count2 < 6 && peek() == 32 && next() == 32));
}
function delimiter(type) {
  while (next())
    switch (character) {
      // ] ) " '
      case type:
        return position;
      // " '
      case 34:
      case 39:
        if (type !== 34 && type !== 39)
          delimiter(character);
        break;
      // (
      case 40:
        if (type === 41)
          delimiter(type);
        break;
      // \
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(type, index) {
  while (next())
    if (type + character === 47 + 10)
      break;
    else if (type + character === 42 + 42 && peek() === 47)
      break;
  return "/*" + slice(index, position - 1) + "*" + from(type === 47 ? type : next());
}
function identifier(index) {
  while (!token(peek()))
    next();
  return slice(index, position);
}
function compile(value2) {
  return dealloc(parse("", null, null, null, [""], value2 = alloc(value2), 0, [0], value2));
}
function parse(value2, root2, parent, rule, rules, rulesets, pseudo, points, declarations) {
  var index = 0;
  var offset = 0;
  var length2 = pseudo;
  var atrule = 0;
  var property = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character2 = 0;
  var type = "";
  var props = rules;
  var children = rulesets;
  var reference = rule;
  var characters2 = type;
  while (scanning)
    switch (previous = character2, character2 = next()) {
      // (
      case 40:
        if (previous != 108 && charat(characters2, length2 - 1) == 58) {
          if (indexof(characters2 += replace(delimit(character2), "&", "&\f"), "&\f") != -1)
            ampersand = -1;
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        characters2 += delimit(character2);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        characters2 += whitespace(previous);
        break;
      // \
      case 92:
        characters2 += escaping(caret() - 1, 7);
        continue;
      // /
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), root2, parent), declarations);
            break;
          default:
            characters2 += "/";
        }
        break;
      // {
      case 123 * variable:
        points[index++] = strlen(characters2) * ampersand;
      // } ; \0
      case 125 * variable:
      case 59:
      case 0:
        switch (character2) {
          // \0 }
          case 0:
          case 125:
            scanning = 0;
          // ;
          case 59 + offset:
            if (ampersand == -1) characters2 = replace(characters2, /\f/g, "");
            if (property > 0 && strlen(characters2) - length2)
              append(property > 32 ? declaration(characters2 + ";", rule, parent, length2 - 1) : declaration(replace(characters2, " ", "") + ";", rule, parent, length2 - 2), declarations);
            break;
          // @ ;
          case 59:
            characters2 += ";";
          // { rule/at-rule
          default:
            append(reference = ruleset(characters2, root2, parent, index, offset, rules, points, type, props = [], children = [], length2), rulesets);
            if (character2 === 123)
              if (offset === 0)
                parse(characters2, root2, reference, reference, props, rulesets, length2, points, children);
              else
                switch (atrule === 99 && charat(characters2, 3) === 110 ? 100 : atrule) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse(value2, reference, reference, rule && append(ruleset(value2, reference, reference, 0, 0, rules, points, type, rules, props = [], length2), children), rules, children, length2, points, rule ? props : children);
                    break;
                  default:
                    parse(characters2, reference, reference, reference, [""], children, 0, points, children);
                }
        }
        index = offset = property = 0, variable = ampersand = 1, type = characters2 = "", length2 = pseudo;
        break;
      // :
      case 58:
        length2 = 1 + strlen(characters2), property = previous;
      default:
        if (variable < 1) {
          if (character2 == 123)
            --variable;
          else if (character2 == 125 && variable++ == 0 && prev() == 125)
            continue;
        }
        switch (characters2 += from(character2), character2 * variable) {
          // &
          case 38:
            ampersand = offset > 0 ? 1 : (characters2 += "\f", -1);
            break;
          // ,
          case 44:
            points[index++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
            break;
          // @
          case 64:
            if (peek() === 45)
              characters2 += delimit(next());
            atrule = peek(), offset = length2 = strlen(type = characters2 += identifier(caret())), character2++;
            break;
          // -
          case 45:
            if (previous === 45 && strlen(characters2) == 2)
              variable = 0;
        }
    }
  return rulesets;
}
function ruleset(value2, root2, parent, index, offset, rules, points, type, props, children, length2) {
  var post = offset - 1;
  var rule = offset === 0 ? rules : [""];
  var size = sizeof(rule);
  for (var i = 0, j = 0, k = 0; i < index; ++i)
    for (var x = 0, y = substr(value2, post + 1, post = abs(j = points[i])), z = value2; x < size; ++x)
      if (z = trim(j > 0 ? rule[x] + " " + y : replace(y, /&\f/g, rule[x])))
        props[k++] = z;
  return node(value2, root2, parent, offset === 0 ? RULESET : type, props, children, length2);
}
function comment(value2, root2, parent) {
  return node(value2, root2, parent, COMMENT, from(char()), substr(value2, 2, -2), 0);
}
function declaration(value2, root2, parent, length2) {
  return node(value2, root2, parent, DECLARATION, substr(value2, 0, length2), substr(value2, length2 + 1, -1), length2);
}
function serialize(children, callback) {
  var output = "";
  var length2 = sizeof(children);
  for (var i = 0; i < length2; i++)
    output += callback(children[i], i, children, callback) || "";
  return output;
}
function stringify(element, index, children, callback) {
  switch (element.type) {
    case LAYER:
      if (element.children.length) break;
    case IMPORT:
    case DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return element.return = element.value + "{" + serialize(element.children, callback) + "}";
    case RULESET:
      element.value = element.props.join(",");
  }
  return strlen(children = serialize(element.children, callback)) ? element.return = element.value + "{" + children + "}" : "";
}
function middleware(collection) {
  var length2 = sizeof(collection);
  return function(element, index, children, callback) {
    var output = "";
    for (var i = 0; i < length2; i++)
      output += collection[i](element, index, children, callback) || "";
    return output;
  };
}
function rulesheet(callback) {
  return function(element) {
    if (!element.root) {
      if (element = element.return)
        callback(element);
    }
  };
}
function memoize$1(fn) {
  var cache2 = /* @__PURE__ */ Object.create(null);
  return function(arg) {
    if (cache2[arg] === void 0) cache2[arg] = fn(arg);
    return cache2[arg];
  };
}
var identifierWithPointTracking = function identifierWithPointTracking2(begin, points, index) {
  var previous = 0;
  var character2 = 0;
  while (true) {
    previous = character2;
    character2 = peek();
    if (previous === 38 && character2 === 12) {
      points[index] = 1;
    }
    if (token(character2)) {
      break;
    }
    next();
  }
  return slice(begin, position);
};
var toRules = function toRules2(parsed, points) {
  var index = -1;
  var character2 = 44;
  do {
    switch (token(character2)) {
      case 0:
        if (character2 === 38 && peek() === 12) {
          points[index] = 1;
        }
        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;
      case 2:
        parsed[index] += delimit(character2);
        break;
      case 4:
        if (character2 === 44) {
          parsed[++index] = peek() === 58 ? "&\f" : "";
          points[index] = parsed[index].length;
          break;
        }
      // fallthrough
      default:
        parsed[index] += from(character2);
    }
  } while (character2 = next());
  return parsed;
};
var getRules = function getRules2(value2, points) {
  return dealloc(toRules(alloc(value2), points));
};
var fixedElements = /* @__PURE__ */ new WeakMap();
var compat = function compat2(element) {
  if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }
  var value2 = element.value;
  var parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;
  while (parent.type !== "rule") {
    parent = parent.parent;
    if (!parent) return;
  }
  if (element.props.length === 1 && value2.charCodeAt(0) !== 58 && !fixedElements.get(parent)) {
    return;
  }
  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value2, points);
  var parentRules = parent.props;
  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel2(element) {
  if (element.type === "decl") {
    var value2 = element.value;
    if (
      // charcode for l
      value2.charCodeAt(0) === 108 && // charcode for b
      value2.charCodeAt(2) === 98
    ) {
      element["return"] = "";
      element.value = "";
    }
  }
};
function prefix(value2, length2) {
  switch (hash(value2, length2)) {
    // color-adjust
    case 5103:
      return WEBKIT + "print-" + value2 + value2;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value2 + value2;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value2 + MOZ + value2 + MS + value2 + value2;
    // flex, flex-direction
    case 6828:
    case 4268:
      return WEBKIT + value2 + MS + value2 + value2;
    // order
    case 6165:
      return WEBKIT + value2 + MS + "flex-" + value2 + value2;
    // align-items
    case 5187:
      return WEBKIT + value2 + replace(value2, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + value2;
    // align-self
    case 5443:
      return WEBKIT + value2 + MS + "flex-item-" + replace(value2, /flex-|-self/, "") + value2;
    // align-content
    case 4675:
      return WEBKIT + value2 + MS + "flex-line-pack" + replace(value2, /align-content|flex-|-self/, "") + value2;
    // flex-shrink
    case 5548:
      return WEBKIT + value2 + MS + replace(value2, "shrink", "negative") + value2;
    // flex-basis
    case 5292:
      return WEBKIT + value2 + MS + replace(value2, "basis", "preferred-size") + value2;
    // flex-grow
    case 6060:
      return WEBKIT + "box-" + replace(value2, "-grow", "") + WEBKIT + value2 + MS + replace(value2, "grow", "positive") + value2;
    // transition
    case 4554:
      return WEBKIT + replace(value2, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + value2;
    // cursor
    case 6187:
      return replace(replace(replace(value2, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), value2, "") + value2;
    // background, background-image
    case 5495:
    case 3959:
      return replace(value2, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    // justify-content
    case 4968:
      return replace(replace(value2, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + value2 + value2;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value2, /(.+)-inline(.+)/, WEBKIT + "$1$2") + value2;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(value2) - 1 - length2 > 6) switch (charat(value2, length2 + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (charat(value2, length2 + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return replace(value2, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(value2, length2 + 3) == 108 ? "$3" : "$2-$3")) + value2;
        // (s)tretch
        case 115:
          return ~indexof(value2, "stretch") ? prefix(replace(value2, "stretch", "fill-available"), length2) + value2 : value2;
      }
      break;
    // position: sticky
    case 4949:
      if (charat(value2, length2 + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (charat(value2, strlen(value2) - 3 - (~indexof(value2, "!important") && 10))) {
        // stic(k)y
        case 107:
          return replace(value2, ":", ":" + WEBKIT) + value2;
        // (inline-)?fl(e)x
        case 101:
          return replace(value2, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(value2, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + value2;
      }
      break;
    // writing-mode
    case 5936:
      switch (charat(value2, length2 + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + value2 + MS + replace(value2, /[svh]\w+-[tblr]{2}/, "tb") + value2;
        // vertical-r(l)
        case 108:
          return WEBKIT + value2 + MS + replace(value2, /[svh]\w+-[tblr]{2}/, "tb-rl") + value2;
        // horizontal(-)tb
        case 45:
          return WEBKIT + value2 + MS + replace(value2, /[svh]\w+-[tblr]{2}/, "lr") + value2;
      }
      return WEBKIT + value2 + MS + value2 + value2;
  }
  return value2;
}
var prefixer = function prefixer2(element, index, children, callback) {
  if (element.length > -1) {
    if (!element["return"]) switch (element.type) {
      case DECLARATION:
        element["return"] = prefix(element.value, element.length);
        break;
      case KEYFRAMES:
        return serialize([copy(element, {
          value: replace(element.value, "@", "@" + WEBKIT)
        })], callback);
      case RULESET:
        if (element.length) return combine(element.props, function(value2) {
          switch (match(value2, /(::plac\w+|:read-\w+)/)) {
            // :read-(only|write)
            case ":read-only":
            case ":read-write":
              return serialize([copy(element, {
                props: [replace(value2, /:(read-\w+)/, ":" + MOZ + "$1")]
              })], callback);
            // :placeholder
            case "::placeholder":
              return serialize([copy(element, {
                props: [replace(value2, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
              }), copy(element, {
                props: [replace(value2, /:(plac\w+)/, ":" + MOZ + "$1")]
              }), copy(element, {
                props: [replace(value2, /:(plac\w+)/, MS + "input-$1")]
              })], callback);
          }
          return "";
        });
    }
  }
};
var defaultStylisPlugins = [prefixer];
var createCache = function createCache2(options) {
  var key = options.key;
  if (key === "css") {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(ssrStyles, function(node2) {
      var dataEmotionAttribute = node2.getAttribute("data-emotion");
      if (dataEmotionAttribute.indexOf(" ") === -1) {
        return;
      }
      document.head.appendChild(node2);
      node2.setAttribute("data-s", "");
    });
  }
  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
  var inserted = {};
  var container2;
  var nodesToHydrate = [];
  {
    container2 = options.container || document.head;
    Array.prototype.forEach.call(
      // this means we will ignore elements which don't have a space in them which
      // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
      document.querySelectorAll('style[data-emotion^="' + key + ' "]'),
      function(node2) {
        var attrib = node2.getAttribute("data-emotion").split(" ");
        for (var i = 1; i < attrib.length; i++) {
          inserted[attrib[i]] = true;
        }
        nodesToHydrate.push(node2);
      }
    );
  }
  var _insert;
  var omnipresentPlugins = [compat, removeLabel];
  {
    var currentSheet;
    var finalizingPlugins = [stringify, rulesheet(function(rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis2(styles2) {
      return serialize(compile(styles2), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache2.inserted[serialized.name] = true;
      }
    };
  }
  var cache2 = {
    key,
    sheet: new StyleSheet({
      key,
      container: container2,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted,
    registered: {},
    insert: _insert
  };
  cache2.sheet.hydrate(nodesToHydrate);
  return cache2;
};
var reactIs$3 = { exports: {} };
var reactIs_production_min$1 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r2 = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r2:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min$1.AsyncMode = l;
  reactIs_production_min$1.ConcurrentMode = m;
  reactIs_production_min$1.ContextConsumer = k;
  reactIs_production_min$1.ContextProvider = h;
  reactIs_production_min$1.Element = c;
  reactIs_production_min$1.ForwardRef = n;
  reactIs_production_min$1.Fragment = e;
  reactIs_production_min$1.Lazy = t;
  reactIs_production_min$1.Memo = r2;
  reactIs_production_min$1.Portal = d;
  reactIs_production_min$1.Profiler = g;
  reactIs_production_min$1.StrictMode = f;
  reactIs_production_min$1.Suspense = p;
  reactIs_production_min$1.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min$1.isConcurrentMode = A;
  reactIs_production_min$1.isContextConsumer = function(a) {
    return z(a) === k;
  };
  reactIs_production_min$1.isContextProvider = function(a) {
    return z(a) === h;
  };
  reactIs_production_min$1.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min$1.isForwardRef = function(a) {
    return z(a) === n;
  };
  reactIs_production_min$1.isFragment = function(a) {
    return z(a) === e;
  };
  reactIs_production_min$1.isLazy = function(a) {
    return z(a) === t;
  };
  reactIs_production_min$1.isMemo = function(a) {
    return z(a) === r2;
  };
  reactIs_production_min$1.isPortal = function(a) {
    return z(a) === d;
  };
  reactIs_production_min$1.isProfiler = function(a) {
    return z(a) === g;
  };
  reactIs_production_min$1.isStrictMode = function(a) {
    return z(a) === f;
  };
  reactIs_production_min$1.isSuspense = function(a) {
    return z(a) === p;
  };
  reactIs_production_min$1.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r2 || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min$1.typeOf = z;
  return reactIs_production_min$1;
}
var reactIs_development$3 = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$3;
function requireReactIs_development$3() {
  if (hasRequiredReactIs_development$3) return reactIs_development$3;
  hasRequiredReactIs_development$3 = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol2 = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol2 ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol2 ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol2 ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol2 ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol2 ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol2 ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol2 ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol2 ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol2 ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol2 ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol2 ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol2 ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol2 ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol2 ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol2 ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol2 ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol2 ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol2 ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === "object" && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal2 = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense2 = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development$3.AsyncMode = AsyncMode;
      reactIs_development$3.ConcurrentMode = ConcurrentMode;
      reactIs_development$3.ContextConsumer = ContextConsumer;
      reactIs_development$3.ContextProvider = ContextProvider;
      reactIs_development$3.Element = Element2;
      reactIs_development$3.ForwardRef = ForwardRef;
      reactIs_development$3.Fragment = Fragment;
      reactIs_development$3.Lazy = Lazy;
      reactIs_development$3.Memo = Memo;
      reactIs_development$3.Portal = Portal2;
      reactIs_development$3.Profiler = Profiler;
      reactIs_development$3.StrictMode = StrictMode;
      reactIs_development$3.Suspense = Suspense2;
      reactIs_development$3.isAsyncMode = isAsyncMode;
      reactIs_development$3.isConcurrentMode = isConcurrentMode;
      reactIs_development$3.isContextConsumer = isContextConsumer;
      reactIs_development$3.isContextProvider = isContextProvider;
      reactIs_development$3.isElement = isElement;
      reactIs_development$3.isForwardRef = isForwardRef;
      reactIs_development$3.isFragment = isFragment;
      reactIs_development$3.isLazy = isLazy;
      reactIs_development$3.isMemo = isMemo;
      reactIs_development$3.isPortal = isPortal;
      reactIs_development$3.isProfiler = isProfiler;
      reactIs_development$3.isStrictMode = isStrictMode;
      reactIs_development$3.isSuspense = isSuspense;
      reactIs_development$3.isValidElementType = isValidElementType;
      reactIs_development$3.typeOf = typeOf;
    })();
  }
  return reactIs_development$3;
}
var hasRequiredReactIs$3;
function requireReactIs$3() {
  if (hasRequiredReactIs$3) return reactIs$3.exports;
  hasRequiredReactIs$3 = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs$3.exports = requireReactIs_production_min$1();
  } else {
    reactIs$3.exports = requireReactIs_development$3();
  }
  return reactIs$3.exports;
}
var hoistNonReactStatics_cjs;
var hasRequiredHoistNonReactStatics_cjs;
function requireHoistNonReactStatics_cjs() {
  if (hasRequiredHoistNonReactStatics_cjs) return hoistNonReactStatics_cjs;
  hasRequiredHoistNonReactStatics_cjs = 1;
  var reactIs2 = requireReactIs$3();
  var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
  };
  var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
  };
  var FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
  };
  var MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
  };
  var TYPE_STATICS = {};
  TYPE_STATICS[reactIs2.ForwardRef] = FORWARD_REF_STATICS;
  TYPE_STATICS[reactIs2.Memo] = MEMO_STATICS;
  function getStatics(component) {
    if (reactIs2.isMemo(component)) {
      return MEMO_STATICS;
    }
    return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
  }
  var defineProperty = Object.defineProperty;
  var getOwnPropertyNames = Object.getOwnPropertyNames;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var getPrototypeOf = Object.getPrototypeOf;
  var objectPrototype = Object.prototype;
  function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
      if (objectPrototype) {
        var inheritedComponent = getPrototypeOf(sourceComponent);
        if (inheritedComponent && inheritedComponent !== objectPrototype) {
          hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
      }
      var keys = getOwnPropertyNames(sourceComponent);
      if (getOwnPropertySymbols) {
        keys = keys.concat(getOwnPropertySymbols(sourceComponent));
      }
      var targetStatics = getStatics(targetComponent);
      var sourceStatics = getStatics(sourceComponent);
      for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
          var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
          try {
            defineProperty(targetComponent, key, descriptor);
          } catch (e) {
          }
        }
      }
    }
    return targetComponent;
  }
  hoistNonReactStatics_cjs = hoistNonReactStatics;
  return hoistNonReactStatics_cjs;
}
requireHoistNonReactStatics_cjs();
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames2) {
  var rawClassName = "";
  classNames2.split(" ").forEach(function(className) {
    if (registered[className] !== void 0) {
      registeredStyles.push(registered[className] + ";");
    } else if (className) {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles2(cache2, serialized, isStringTag) {
  var className = cache2.key + "-" + serialized.name;
  if (
    // we only need to add the styles to the registered cache if the
    // class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false) && cache2.registered[className] === void 0
  ) {
    cache2.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles2(cache2, serialized, isStringTag) {
  registerStyles(cache2, serialized, isStringTag);
  var className = cache2.key + "-" + serialized.name;
  if (cache2.inserted[serialized.name] === void 0) {
    var current = serialized;
    do {
      cache2.insert(serialized === current ? "." + className : "", current, cache2.sheet, true);
      current = current.next;
    } while (current !== void 0);
  }
};
function murmur2(str) {
  var h = 0;
  var k, i = 0, len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24;
    k = /* Math.imul(k, m): */
    (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16);
    k ^= /* k >>> r: */
    k >>> 24;
    h = /* Math.imul(k, m): */
    (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 255) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 255) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 255;
      h = /* Math.imul(h, m): */
      (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  }
  h ^= h >>> 13;
  h = /* Math.imul(h, m): */
  (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty2(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue2(value2) {
  return value2 != null && typeof value2 !== "boolean";
};
var processStyleName = /* @__PURE__ */ memoize$1(function(styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue2(key, value2) {
  switch (key) {
    case "animation":
    case "animationName": {
      if (typeof value2 === "string") {
        return value2.replace(animationRegex, function(match2, p1, p2) {
          cursor = {
            name: p1,
            styles: p2,
            next: cursor
          };
          return p1;
        });
      }
    }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value2 === "number" && value2 !== 0) {
    return value2 + "px";
  }
  return value2;
};
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return "";
  }
  var componentSelector = interpolation;
  if (componentSelector.__emotion_styles !== void 0) {
    return componentSelector;
  }
  switch (typeof interpolation) {
    case "boolean": {
      return "";
    }
    case "object": {
      var keyframes2 = interpolation;
      if (keyframes2.anim === 1) {
        cursor = {
          name: keyframes2.name,
          styles: keyframes2.styles,
          next: cursor
        };
        return keyframes2.name;
      }
      var serializedStyles = interpolation;
      if (serializedStyles.styles !== void 0) {
        var next2 = serializedStyles.next;
        if (next2 !== void 0) {
          while (next2 !== void 0) {
            cursor = {
              name: next2.name,
              styles: next2.styles,
              next: cursor
            };
            next2 = next2.next;
          }
        }
        var styles2 = serializedStyles.styles + ";";
        return styles2;
      }
      return createStringFromObject(mergedProps, registered, interpolation);
    }
    case "function": {
      if (mergedProps !== void 0) {
        var previousCursor = cursor;
        var result = interpolation(mergedProps);
        cursor = previousCursor;
        return handleInterpolation(mergedProps, registered, result);
      }
      break;
    }
  }
  var asString = interpolation;
  if (registered == null) {
    return asString;
  }
  var cached = registered[asString];
  return cached !== void 0 ? cached : asString;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = "";
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var key in obj) {
      var value2 = obj[key];
      if (typeof value2 !== "object") {
        var asString = value2;
        if (registered != null && registered[asString] !== void 0) {
          string += key + "{" + registered[asString] + "}";
        } else if (isProcessableValue(asString)) {
          string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        }
      } else {
        if (Array.isArray(value2) && typeof value2[0] === "string" && (registered == null || registered[value2[0]] === void 0)) {
          for (var _i = 0; _i < value2.length; _i++) {
            if (isProcessableValue(value2[_i])) {
              string += processStyleName(key) + ":" + processStyleValue(key, value2[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value2);
          switch (key) {
            case "animation":
            case "animationName": {
              string += processStyleName(key) + ":" + interpolated + ";";
              break;
            }
            default: {
              string += key + "{" + interpolated + "}";
            }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
var cursor;
function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
    return args[0];
  }
  var stringMode = true;
  var styles2 = "";
  cursor = void 0;
  var strings = args[0];
  if (strings == null || strings.raw === void 0) {
    stringMode = false;
    styles2 += handleInterpolation(mergedProps, registered, strings);
  } else {
    var asTemplateStringsArr = strings;
    styles2 += asTemplateStringsArr[0];
  }
  for (var i = 1; i < args.length; i++) {
    styles2 += handleInterpolation(mergedProps, registered, args[i]);
    if (stringMode) {
      var templateStringsArr = strings;
      styles2 += templateStringsArr[i];
    }
  }
  labelPattern.lastIndex = 0;
  var identifierName = "";
  var match2;
  while ((match2 = labelPattern.exec(styles2)) !== null) {
    identifierName += "-" + match2[1];
  }
  var name2 = murmur2(styles2) + identifierName;
  return {
    name: name2,
    styles: styles2,
    next: cursor
  };
}
var syncFallback = function syncFallback2(create) {
  return create();
};
var useInsertionEffect = React["useInsertionEffect"] ? React["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || React.useLayoutEffect;
var EmotionCacheContext = /* @__PURE__ */ React.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement !== "undefined" ? /* @__PURE__ */ createCache({
    key: "css"
  }) : null
);
var CacheProvider = EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache2(func) {
  return /* @__PURE__ */ forwardRef(function(props, ref) {
    var cache2 = useContext(EmotionCacheContext);
    return func(props, cache2, ref);
  });
};
var ThemeContext$1 = /* @__PURE__ */ React.createContext({});
var hasOwn = {}.hasOwnProperty;
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var createEmotionProps = function createEmotionProps2(type, props) {
  var newProps = {};
  for (var _key in props) {
    if (hasOwn.call(props, _key)) {
      newProps[_key] = props[_key];
    }
  }
  newProps[typePropName] = type;
  return newProps;
};
var Insertion$1 = function Insertion(_ref) {
  var cache2 = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
  registerStyles(cache2, serialized, isStringTag);
  useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(cache2, serialized, isStringTag);
  });
  return null;
};
var Emotion = /* @__PURE__ */ withEmotionCache(function(props, cache2, ref) {
  var cssProp = props.css;
  if (typeof cssProp === "string" && cache2.registered[cssProp] !== void 0) {
    cssProp = cache2.registered[cssProp];
  }
  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = "";
  if (typeof props.className === "string") {
    className = getRegisteredStyles(cache2.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }
  var serialized = serializeStyles(registeredStyles, void 0, React.useContext(ThemeContext$1));
  className += cache2.key + "-" + serialized.name;
  var newProps = {};
  for (var _key2 in props) {
    if (hasOwn.call(props, _key2) && _key2 !== "css" && _key2 !== typePropName && true) {
      newProps[_key2] = props[_key2];
    }
  }
  newProps.className = className;
  if (ref) {
    newProps.ref = ref;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion$1, {
    cache: cache2,
    serialized,
    isStringTag: typeof WrappedComponent === "string"
  }), /* @__PURE__ */ React.createElement(WrappedComponent, newProps));
});
var Emotion$1 = Emotion;
var jsx = function jsx2(type, props) {
  var args = arguments;
  if (props == null || !hasOwn.call(props, "css")) {
    return React.createElement.apply(void 0, args);
  }
  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion$1;
  createElementArgArray[1] = createEmotionProps(type, props);
  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  }
  return React.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
  var JSX;
  /* @__PURE__ */ (function(_JSX) {
  })(JSX || (JSX = _jsx.JSX || (_jsx.JSX = {})));
})(jsx || (jsx = {}));
var Global = /* @__PURE__ */ withEmotionCache(function(props, cache2) {
  var styles2 = props.styles;
  var serialized = serializeStyles([styles2], void 0, React.useContext(ThemeContext$1));
  var sheetRef = React.useRef();
  useInsertionEffectWithLayoutFallback(function() {
    var key = cache2.key + "-global";
    var sheet = new cache2.sheet.constructor({
      key,
      nonce: cache2.sheet.nonce,
      container: cache2.sheet.container,
      speedy: cache2.sheet.isSpeedy
    });
    var rehydrating = false;
    var node2 = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
    if (cache2.sheet.tags.length) {
      sheet.before = cache2.sheet.tags[0];
    }
    if (node2 !== null) {
      rehydrating = true;
      node2.setAttribute("data-emotion", key);
      sheet.hydrate([node2]);
    }
    sheetRef.current = [sheet, rehydrating];
    return function() {
      sheet.flush();
    };
  }, [cache2]);
  useInsertionEffectWithLayoutFallback(function() {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }
    if (serialized.next !== void 0) {
      insertStyles(cache2, serialized.next, true);
    }
    if (sheet.tags.length) {
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }
    cache2.insert("", serialized, sheet, false);
  }, [cache2, serialized.name]);
  return null;
});
function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return serializeStyles(args);
}
function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name2 = "animation-" + insertable.name;
  return {
    name: name2,
    styles: "@keyframes " + name2 + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
var isPropValid = /* @__PURE__ */ memoize$1(
  function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
  }
  /* Z+1 */
);
var testOmitPropsOnStringTag = isPropValid;
var testOmitPropsOnComponent = function testOmitPropsOnComponent2(key) {
  return key !== "theme";
};
var getDefaultShouldForwardProp = function getDefaultShouldForwardProp2(tag) {
  return typeof tag === "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps2(tag, options, isReal) {
  var shouldForwardProp;
  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }
  if (typeof shouldForwardProp !== "function" && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }
  return shouldForwardProp;
};
var Insertion2 = function Insertion3(_ref) {
  var cache2 = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
  registerStyles(cache2, serialized, isStringTag);
  useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(cache2, serialized, isStringTag);
  });
  return null;
};
var createStyled$2 = function createStyled(tag, options) {
  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;
  if (options !== void 0) {
    identifierName = options.label;
    targetClassName = options.target;
  }
  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp("as");
  return function() {
    var args = arguments;
    var styles2 = isReal && tag.__emotion_styles !== void 0 ? tag.__emotion_styles.slice(0) : [];
    if (identifierName !== void 0) {
      styles2.push("label:" + identifierName + ";");
    }
    if (args[0] == null || args[0].raw === void 0) {
      styles2.push.apply(styles2, args);
    } else {
      var templateStringsArr = args[0];
      styles2.push(templateStringsArr[0]);
      var len = args.length;
      var i = 1;
      for (; i < len; i++) {
        styles2.push(args[i], templateStringsArr[i]);
      }
    }
    var Styled = withEmotionCache(function(props, cache2, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = "";
      var classInterpolations = [];
      var mergedProps = props;
      if (props.theme == null) {
        mergedProps = {};
        for (var key in props) {
          mergedProps[key] = props[key];
        }
        mergedProps.theme = React.useContext(ThemeContext$1);
      }
      if (typeof props.className === "string") {
        className = getRegisteredStyles(cache2.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }
      var serialized = serializeStyles(styles2.concat(classInterpolations), cache2.registered, mergedProps);
      className += cache2.key + "-" + serialized.name;
      if (targetClassName !== void 0) {
        className += " " + targetClassName;
      }
      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === void 0 ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};
      for (var _key in props) {
        if (shouldUseAs && _key === "as") continue;
        if (finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }
      newProps.className = className;
      if (ref) {
        newProps.ref = ref;
      }
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion2, {
        cache: cache2,
        serialized,
        isStringTag: typeof FinalTag === "string"
      }), /* @__PURE__ */ React.createElement(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== void 0 ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles2;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, "toString", {
      value: function value2() {
        return "." + targetClassName;
      }
    });
    Styled.withComponent = function(nextTag, nextOptions) {
      var newStyled2 = createStyled(nextTag, _extends$1({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      }));
      return newStyled2.apply(void 0, styles2);
    };
    return Styled;
  };
};
var tags = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
];
var newStyled = createStyled$2.bind(null);
tags.forEach(function(tagName) {
  newStyled[tagName] = newStyled(tagName);
});
var propTypes = { exports: {} };
var reactIs$2 = { exports: {} };
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r2 = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r2:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m;
  reactIs_production_min.ContextConsumer = k;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t;
  reactIs_production_min.Memo = r2;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function(a) {
    return z(a) === k;
  };
  reactIs_production_min.isContextProvider = function(a) {
    return z(a) === h;
  };
  reactIs_production_min.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function(a) {
    return z(a) === n;
  };
  reactIs_production_min.isFragment = function(a) {
    return z(a) === e;
  };
  reactIs_production_min.isLazy = function(a) {
    return z(a) === t;
  };
  reactIs_production_min.isMemo = function(a) {
    return z(a) === r2;
  };
  reactIs_production_min.isPortal = function(a) {
    return z(a) === d;
  };
  reactIs_production_min.isProfiler = function(a) {
    return z(a) === g;
  };
  reactIs_production_min.isStrictMode = function(a) {
    return z(a) === f;
  };
  reactIs_production_min.isSuspense = function(a) {
    return z(a) === p;
  };
  reactIs_production_min.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r2 || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}
var reactIs_development$2 = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$2;
function requireReactIs_development$2() {
  if (hasRequiredReactIs_development$2) return reactIs_development$2;
  hasRequiredReactIs_development$2 = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol2 = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol2 ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol2 ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol2 ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol2 ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol2 ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol2 ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol2 ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol2 ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol2 ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol2 ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol2 ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol2 ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol2 ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol2 ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol2 ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol2 ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol2 ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol2 ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === "object" && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal2 = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense2 = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development$2.AsyncMode = AsyncMode;
      reactIs_development$2.ConcurrentMode = ConcurrentMode;
      reactIs_development$2.ContextConsumer = ContextConsumer;
      reactIs_development$2.ContextProvider = ContextProvider;
      reactIs_development$2.Element = Element2;
      reactIs_development$2.ForwardRef = ForwardRef;
      reactIs_development$2.Fragment = Fragment;
      reactIs_development$2.Lazy = Lazy;
      reactIs_development$2.Memo = Memo;
      reactIs_development$2.Portal = Portal2;
      reactIs_development$2.Profiler = Profiler;
      reactIs_development$2.StrictMode = StrictMode;
      reactIs_development$2.Suspense = Suspense2;
      reactIs_development$2.isAsyncMode = isAsyncMode;
      reactIs_development$2.isConcurrentMode = isConcurrentMode;
      reactIs_development$2.isContextConsumer = isContextConsumer;
      reactIs_development$2.isContextProvider = isContextProvider;
      reactIs_development$2.isElement = isElement;
      reactIs_development$2.isForwardRef = isForwardRef;
      reactIs_development$2.isFragment = isFragment;
      reactIs_development$2.isLazy = isLazy;
      reactIs_development$2.isMemo = isMemo;
      reactIs_development$2.isPortal = isPortal;
      reactIs_development$2.isProfiler = isProfiler;
      reactIs_development$2.isStrictMode = isStrictMode;
      reactIs_development$2.isSuspense = isSuspense;
      reactIs_development$2.isValidElementType = isValidElementType;
      reactIs_development$2.typeOf = typeOf;
    })();
  }
  return reactIs_development$2;
}
var hasRequiredReactIs$2;
function requireReactIs$2() {
  if (hasRequiredReactIs$2) return reactIs$2.exports;
  hasRequiredReactIs$2 = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs$2.exports = requireReactIs_production_min();
  } else {
    reactIs$2.exports = requireReactIs_development$2();
  }
  return reactIs$2.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2["_" + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
        return test2[n];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from2;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
      from2 = Object(arguments[s]);
      for (var key in from2) {
        if (hasOwnProperty.call(from2, key)) {
          to[key] = from2[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from2);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from2, symbols[i])) {
            to[symbols[i]] = from2[symbols[i]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas) return has;
  hasRequiredHas = 1;
  has = Function.call.bind(Object.prototype.hasOwnProperty);
  return has;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = /* @__PURE__ */ requireHas();
    printWarning = function(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values2, location, componentName, getStack) {
    if (process.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error2;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error(
                (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              err.name = "Invariant Violation";
              throw err;
            }
            error2 = typeSpecs[typeSpecName](values2, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error2 = ex;
          }
          if (error2 && !(error2 instanceof Error)) {
            printWarning(
              (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error2 + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            );
          }
          if (error2 instanceof Error && !(error2.message in loggedTypeFailures)) {
            loggedTypeFailures[error2.message] = true;
            var stack = getStack ? getStack() : "";
            printWarning(
              "Failed " + location + " type: " + error2.message + (stack != null ? stack : "")
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs$2();
  var assign2 = /* @__PURE__ */ requireObjectAssign();
  var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
  var has2 = /* @__PURE__ */ requireHas();
  var checkPropTypes = /* @__PURE__ */ requireCheckPropTypes();
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    printWarning = function(text) {
      var message = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function(isValidElement2, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is(x, y) {
      if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
      } else {
        return x !== x && y !== y;
      }
    }
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && typeof data === "object" ? data : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            err.name = "Invariant Violation";
            throw err;
          } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey = componentName + ":" + propName;
            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning(
                "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error2 = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
          if (error2 instanceof Error) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement2(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning(
              "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
            );
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value2) {
          var type = getPreciseType(value2);
          if (type === "symbol") {
            return String(value2);
          }
          return value2;
        });
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key in propValue) {
          if (has2(propValue, key)) {
            var error2 = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error2 instanceof Error) {
              return error2;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== "function") {
          printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
          var checker2 = arrayOfTypeCheckers[i2];
          var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error2 = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error2) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign2({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has2(shapeTypes, key) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          }
          var error2 = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error2) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement2(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value2) {
      var type = getPreciseType(value2);
      switch (type) {
        case "array":
        case "object":
          return "an " + type;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type;
        default:
          return type;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = /* @__PURE__ */ requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim.isRequired = shim;
    function getShim() {
      return shim;
    }
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
var hasRequiredPropTypes;
function requirePropTypes() {
  if (hasRequiredPropTypes) return propTypes.exports;
  hasRequiredPropTypes = 1;
  if (process.env.NODE_ENV !== "production") {
    var ReactIs = requireReactIs$2();
    var throwOnDirectAccess = true;
    propTypes.exports = /* @__PURE__ */ requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
  } else {
    propTypes.exports = /* @__PURE__ */ requireFactoryWithThrowingShims()();
  }
  return propTypes.exports;
}
var propTypesExports = /* @__PURE__ */ requirePropTypes();
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
let cache;
if (typeof document === "object") {
  cache = createCache({
    key: "css",
    prepend: true
  });
}
function StyledEngineProvider(props) {
  const {
    injectFirst,
    children
  } = props;
  return injectFirst && cache ? /* @__PURE__ */ jsxRuntimeExports.jsx(CacheProvider, {
    value: cache,
    children
  }) : children;
}
process.env.NODE_ENV !== "production" ? StyledEngineProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: PropTypes.bool
} : void 0;
function isEmpty(obj) {
  return obj === void 0 || obj === null || Object.keys(obj).length === 0;
}
function GlobalStyles(props) {
  const {
    styles: styles2,
    defaultTheme: defaultTheme2 = {}
  } = props;
  const globalStyles = typeof styles2 === "function" ? (themeInput) => styles2(isEmpty(themeInput) ? defaultTheme2 : themeInput) : styles2;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Global, {
    styles: globalStyles
  });
}
process.env.NODE_ENV !== "production" ? GlobalStyles.propTypes = {
  defaultTheme: PropTypes.object,
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object, PropTypes.func])
} : void 0;
/**
 * @mui/styled-engine v5.16.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function styled$1(tag, options) {
  const stylesFactory = newStyled(tag, options);
  if (process.env.NODE_ENV !== "production") {
    return (...styles2) => {
      const component = typeof tag === "string" ? `"${tag}"` : "component";
      if (styles2.length === 0) {
        console.error([`MUI: Seems like you called \`styled(${component})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join("\n"));
      } else if (styles2.some((style2) => style2 === void 0)) {
        console.error(`MUI: the styled(${component})(...args) API requires all its args to be defined.`);
      }
      return stylesFactory(...styles2);
    };
  }
  return stylesFactory;
}
const internal_processStyles = (tag, processor) => {
  if (Array.isArray(tag.__emotion_styles)) {
    tag.__emotion_styles = processor(tag.__emotion_styles);
  }
};
const styledEngine = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GlobalStyles,
  StyledEngineProvider,
  ThemeContext: ThemeContext$1,
  css,
  default: styled$1,
  internal_processStyles,
  keyframes
}, Symbol.toStringTag, { value: "Module" }));
function isPlainObject(item) {
  if (typeof item !== "object" || item === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(item);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function deepClone(source) {
  if (/* @__PURE__ */ React.isValidElement(source) || !isPlainObject(source)) {
    return source;
  }
  const output = {};
  Object.keys(source).forEach((key) => {
    output[key] = deepClone(source[key]);
  });
  return output;
}
function deepmerge$1(target, source, options = {
  clone: true
}) {
  const output = options.clone ? _extends$1({}, target) : target;
  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach((key) => {
      if (/* @__PURE__ */ React.isValidElement(source[key])) {
        output[key] = source[key];
      } else if (isPlainObject(source[key]) && // Avoid prototype pollution
      Object.prototype.hasOwnProperty.call(target, key) && isPlainObject(target[key])) {
        output[key] = deepmerge$1(target[key], source[key], options);
      } else if (options.clone) {
        output[key] = isPlainObject(source[key]) ? deepClone(source[key]) : source[key];
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}
const deepmerge = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: deepmerge$1,
  isPlainObject
}, Symbol.toStringTag, { value: "Module" }));
const _excluded$h = ["values", "unit", "step"];
const sortBreakpointsValues = (values2) => {
  const breakpointsAsArray = Object.keys(values2).map((key) => ({
    key,
    val: values2[key]
  })) || [];
  breakpointsAsArray.sort((breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val);
  return breakpointsAsArray.reduce((acc, obj) => {
    return _extends$1({}, acc, {
      [obj.key]: obj.val
    });
  }, {});
};
function createBreakpoints(breakpoints2) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: values2 = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit = "px",
    step = 5
  } = breakpoints2, other = _objectWithoutPropertiesLoose(breakpoints2, _excluded$h);
  const sortedValues = sortBreakpointsValues(values2);
  const keys = Object.keys(sortedValues);
  function up(key) {
    const value2 = typeof values2[key] === "number" ? values2[key] : key;
    return `@media (min-width:${value2}${unit})`;
  }
  function down(key) {
    const value2 = typeof values2[key] === "number" ? values2[key] : key;
    return `@media (max-width:${value2 - step / 100}${unit})`;
  }
  function between(start, end) {
    const endIndex = keys.indexOf(end);
    return `@media (min-width:${typeof values2[start] === "number" ? values2[start] : start}${unit}) and (max-width:${(endIndex !== -1 && typeof values2[keys[endIndex]] === "number" ? values2[keys[endIndex]] : end) - step / 100}${unit})`;
  }
  function only(key) {
    if (keys.indexOf(key) + 1 < keys.length) {
      return between(key, keys[keys.indexOf(key) + 1]);
    }
    return up(key);
  }
  function not(key) {
    const keyIndex = keys.indexOf(key);
    if (keyIndex === 0) {
      return up(keys[1]);
    }
    if (keyIndex === keys.length - 1) {
      return down(keys[keyIndex]);
    }
    return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
  }
  return _extends$1({
    keys,
    values: sortedValues,
    up,
    down,
    between,
    only,
    not,
    unit
  }, other);
}
const shape = {
  borderRadius: 4
};
const responsivePropType = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
function merge(acc, item) {
  if (!item) {
    return acc;
  }
  return deepmerge$1(acc, item, {
    clone: false
    // No need to clone deep, it's way faster.
  });
}
const values$1 = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
};
const defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (key) => `@media (min-width:${values$1[key]}px)`
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  const theme = props.theme || {};
  if (Array.isArray(propValue)) {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return propValue.reduce((acc, item, index) => {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }
  if (typeof propValue === "object") {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce((acc, breakpoint) => {
      if (Object.keys(themeBreakpoints.values || values$1).indexOf(breakpoint) !== -1) {
        const mediaKey = themeBreakpoints.up(breakpoint);
        acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
      } else {
        const cssKey = breakpoint;
        acc[cssKey] = propValue[cssKey];
      }
      return acc;
    }, {});
  }
  const output = styleFromPropValue(propValue);
  return output;
}
function createEmptyBreakpointObject(breakpointsInput = {}) {
  var _breakpointsInput$key;
  const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key) => {
    const breakpointStyleKey = breakpointsInput.up(key);
    acc[breakpointStyleKey] = {};
    return acc;
  }, {});
  return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style2) {
  return breakpointKeys.reduce((acc, key) => {
    const breakpointOutput = acc[key];
    const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
    if (isBreakpointUnused) {
      delete acc[key];
    }
    return acc;
  }, style2);
}
function capitalize$1(string) {
  if (typeof string !== "string") {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: \`capitalize(string)\` expects a string argument.` : formatMuiErrorMessage$1(7));
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}
const capitalize = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: capitalize$1
}, Symbol.toStringTag, { value: "Module" }));
function getPath(obj, path, checkVars = true) {
  if (!path || typeof path !== "string") {
    return null;
  }
  if (obj && obj.vars && checkVars) {
    const val = `vars.${path}`.split(".").reduce((acc, item) => acc && acc[item] ? acc[item] : null, obj);
    if (val != null) {
      return val;
    }
  }
  return path.split(".").reduce((acc, item) => {
    if (acc && acc[item] != null) {
      return acc[item];
    }
    return null;
  }, obj);
}
function getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
  let value2;
  if (typeof themeMapping === "function") {
    value2 = themeMapping(propValueFinal);
  } else if (Array.isArray(themeMapping)) {
    value2 = themeMapping[propValueFinal] || userValue;
  } else {
    value2 = getPath(themeMapping, propValueFinal) || userValue;
  }
  if (transform) {
    value2 = transform(value2, userValue, themeMapping);
  }
  return value2;
}
function style$1(options) {
  const {
    prop,
    cssProperty = options.prop,
    themeKey,
    transform
  } = options;
  const fn = (props) => {
    if (props[prop] == null) {
      return null;
    }
    const propValue = props[prop];
    const theme = props.theme;
    const themeMapping = getPath(theme, themeKey) || {};
    const styleFromPropValue = (propValueFinal) => {
      let value2 = getStyleValue(themeMapping, transform, propValueFinal);
      if (propValueFinal === value2 && typeof propValueFinal === "string") {
        value2 = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : capitalize$1(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value2;
      }
      return {
        [cssProperty]: value2
      };
    };
    return handleBreakpoints(props, propValue, styleFromPropValue);
  };
  fn.propTypes = process.env.NODE_ENV !== "production" ? {
    [prop]: responsivePropType
  } : {};
  fn.filterProps = [prop];
  return fn;
}
function memoize(fn) {
  const cache2 = {};
  return (arg) => {
    if (cache2[arg] === void 0) {
      cache2[arg] = fn(arg);
    }
    return cache2[arg];
  };
}
const properties = {
  m: "margin",
  p: "padding"
};
const directions = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
};
const aliases = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
};
const getCssProperties = memoize((prop) => {
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }
  const [a, b] = prop.split("");
  const property = properties[a];
  const direction = directions[b] || "";
  return Array.isArray(direction) ? direction.map((dir) => property + dir) : [property + direction];
});
const marginKeys = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"];
const paddingKeys = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"];
const spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
  var _getPath;
  const themeSpacing = (_getPath = getPath(theme, themeKey, false)) != null ? _getPath : defaultValue;
  if (typeof themeSpacing === "number") {
    return (abs2) => {
      if (typeof abs2 === "string") {
        return abs2;
      }
      if (process.env.NODE_ENV !== "production") {
        if (typeof abs2 !== "number") {
          console.error(`MUI: Expected ${propName} argument to be a number or a string, got ${abs2}.`);
        }
      }
      return themeSpacing * abs2;
    };
  }
  if (Array.isArray(themeSpacing)) {
    return (abs2) => {
      if (typeof abs2 === "string") {
        return abs2;
      }
      if (process.env.NODE_ENV !== "production") {
        if (!Number.isInteger(abs2)) {
          console.error([`MUI: The \`theme.${themeKey}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${themeKey}\` as a number.`].join("\n"));
        } else if (abs2 > themeSpacing.length - 1) {
          console.error([`MUI: The value provided (${abs2}) overflows.`, `The supported values are: ${JSON.stringify(themeSpacing)}.`, `${abs2} > ${themeSpacing.length - 1}, you need to add the missing values.`].join("\n"));
        }
      }
      return themeSpacing[abs2];
    };
  }
  if (typeof themeSpacing === "function") {
    return themeSpacing;
  }
  if (process.env.NODE_ENV !== "production") {
    console.error([`MUI: The \`theme.${themeKey}\` value (${themeSpacing}) is invalid.`, "It should be a number, an array or a function."].join("\n"));
  }
  return () => void 0;
}
function createUnarySpacing(theme) {
  return createUnaryUnit(theme, "spacing", 8, "spacing");
}
function getValue(transformer, propValue) {
  if (typeof propValue === "string" || propValue == null) {
    return propValue;
  }
  const abs2 = Math.abs(propValue);
  const transformed = transformer(abs2);
  if (propValue >= 0) {
    return transformed;
  }
  if (typeof transformed === "number") {
    return -transformed;
  }
  return `-${transformed}`;
}
function getStyleFromPropValue(cssProperties, transformer) {
  return (propValue) => cssProperties.reduce((acc, cssProperty) => {
    acc[cssProperty] = getValue(transformer, propValue);
    return acc;
  }, {});
}
function resolveCssProperty(props, keys, prop, transformer) {
  if (keys.indexOf(prop) === -1) {
    return null;
  }
  const cssProperties = getCssProperties(prop);
  const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
  const propValue = props[prop];
  return handleBreakpoints(props, propValue, styleFromPropValue);
}
function style(props, keys) {
  const transformer = createUnarySpacing(props.theme);
  return Object.keys(props).map((prop) => resolveCssProperty(props, keys, prop, transformer)).reduce(merge, {});
}
function margin(props) {
  return style(props, marginKeys);
}
margin.propTypes = process.env.NODE_ENV !== "production" ? marginKeys.reduce((obj, key) => {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
margin.filterProps = marginKeys;
function padding(props) {
  return style(props, paddingKeys);
}
padding.propTypes = process.env.NODE_ENV !== "production" ? paddingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
padding.filterProps = paddingKeys;
process.env.NODE_ENV !== "production" ? spacingKeys.reduce((obj, key) => {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
function createSpacing(spacingInput = 8) {
  if (spacingInput.mui) {
    return spacingInput;
  }
  const transform = createUnarySpacing({
    spacing: spacingInput
  });
  const spacing = (...argsInput) => {
    if (process.env.NODE_ENV !== "production") {
      if (!(argsInput.length <= 4)) {
        console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${argsInput.length}`);
      }
    }
    const args = argsInput.length === 0 ? [1] : argsInput;
    return args.map((argument) => {
      const output = transform(argument);
      return typeof output === "number" ? `${output}px` : output;
    }).join(" ");
  };
  spacing.mui = true;
  return spacing;
}
function compose(...styles2) {
  const handlers = styles2.reduce((acc, style2) => {
    style2.filterProps.forEach((prop) => {
      acc[prop] = style2;
    });
    return acc;
  }, {});
  const fn = (props) => {
    return Object.keys(props).reduce((acc, prop) => {
      if (handlers[prop]) {
        return merge(acc, handlers[prop](props));
      }
      return acc;
    }, {});
  };
  fn.propTypes = process.env.NODE_ENV !== "production" ? styles2.reduce((acc, style2) => Object.assign(acc, style2.propTypes), {}) : {};
  fn.filterProps = styles2.reduce((acc, style2) => acc.concat(style2.filterProps), []);
  return fn;
}
function borderTransform(value2) {
  if (typeof value2 !== "number") {
    return value2;
  }
  return `${value2}px solid`;
}
function createBorderStyle(prop, transform) {
  return style$1({
    prop,
    themeKey: "borders",
    transform
  });
}
const border = createBorderStyle("border", borderTransform);
const borderTop = createBorderStyle("borderTop", borderTransform);
const borderRight = createBorderStyle("borderRight", borderTransform);
const borderBottom = createBorderStyle("borderBottom", borderTransform);
const borderLeft = createBorderStyle("borderLeft", borderTransform);
const borderColor = createBorderStyle("borderColor");
const borderTopColor = createBorderStyle("borderTopColor");
const borderRightColor = createBorderStyle("borderRightColor");
const borderBottomColor = createBorderStyle("borderBottomColor");
const borderLeftColor = createBorderStyle("borderLeftColor");
const outline = createBorderStyle("outline", borderTransform);
const outlineColor = createBorderStyle("outlineColor");
const borderRadius = (props) => {
  if (props.borderRadius !== void 0 && props.borderRadius !== null) {
    const transformer = createUnaryUnit(props.theme, "shape.borderRadius", 4, "borderRadius");
    const styleFromPropValue = (propValue) => ({
      borderRadius: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.borderRadius, styleFromPropValue);
  }
  return null;
};
borderRadius.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: responsivePropType
} : {};
borderRadius.filterProps = ["borderRadius"];
compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);
const gap = (props) => {
  if (props.gap !== void 0 && props.gap !== null) {
    const transformer = createUnaryUnit(props.theme, "spacing", 8, "gap");
    const styleFromPropValue = (propValue) => ({
      gap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.gap, styleFromPropValue);
  }
  return null;
};
gap.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: responsivePropType
} : {};
gap.filterProps = ["gap"];
const columnGap = (props) => {
  if (props.columnGap !== void 0 && props.columnGap !== null) {
    const transformer = createUnaryUnit(props.theme, "spacing", 8, "columnGap");
    const styleFromPropValue = (propValue) => ({
      columnGap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.columnGap, styleFromPropValue);
  }
  return null;
};
columnGap.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: responsivePropType
} : {};
columnGap.filterProps = ["columnGap"];
const rowGap = (props) => {
  if (props.rowGap !== void 0 && props.rowGap !== null) {
    const transformer = createUnaryUnit(props.theme, "spacing", 8, "rowGap");
    const styleFromPropValue = (propValue) => ({
      rowGap: getValue(transformer, propValue)
    });
    return handleBreakpoints(props, props.rowGap, styleFromPropValue);
  }
  return null;
};
rowGap.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: responsivePropType
} : {};
rowGap.filterProps = ["rowGap"];
const gridColumn = style$1({
  prop: "gridColumn"
});
const gridRow = style$1({
  prop: "gridRow"
});
const gridAutoFlow = style$1({
  prop: "gridAutoFlow"
});
const gridAutoColumns = style$1({
  prop: "gridAutoColumns"
});
const gridAutoRows = style$1({
  prop: "gridAutoRows"
});
const gridTemplateColumns = style$1({
  prop: "gridTemplateColumns"
});
const gridTemplateRows = style$1({
  prop: "gridTemplateRows"
});
const gridTemplateAreas = style$1({
  prop: "gridTemplateAreas"
});
const gridArea = style$1({
  prop: "gridArea"
});
compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
function paletteTransform(value2, userValue) {
  if (userValue === "grey") {
    return userValue;
  }
  return value2;
}
const color = style$1({
  prop: "color",
  themeKey: "palette",
  transform: paletteTransform
});
const bgcolor = style$1({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
});
const backgroundColor = style$1({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
});
compose(color, bgcolor, backgroundColor);
function sizingTransform(value2) {
  return value2 <= 1 && value2 !== 0 ? `${value2 * 100}%` : value2;
}
const width = style$1({
  prop: "width",
  transform: sizingTransform
});
const maxWidth = (props) => {
  if (props.maxWidth !== void 0 && props.maxWidth !== null) {
    const styleFromPropValue = (propValue) => {
      var _props$theme, _props$theme2;
      const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || values$1[propValue];
      if (!breakpoint) {
        return {
          maxWidth: sizingTransform(propValue)
        };
      }
      if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") {
        return {
          maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
        };
      }
      return {
        maxWidth: breakpoint
      };
    };
    return handleBreakpoints(props, props.maxWidth, styleFromPropValue);
  }
  return null;
};
maxWidth.filterProps = ["maxWidth"];
const minWidth = style$1({
  prop: "minWidth",
  transform: sizingTransform
});
const height = style$1({
  prop: "height",
  transform: sizingTransform
});
const maxHeight = style$1({
  prop: "maxHeight",
  transform: sizingTransform
});
const minHeight = style$1({
  prop: "minHeight",
  transform: sizingTransform
});
style$1({
  prop: "size",
  cssProperty: "width",
  transform: sizingTransform
});
style$1({
  prop: "size",
  cssProperty: "height",
  transform: sizingTransform
});
const boxSizing = style$1({
  prop: "boxSizing"
});
compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
const defaultSxConfig = {
  // borders
  border: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderTop: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderRight: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderBottom: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderLeft: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: borderTransform
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: borderRadius
  },
  // palette
  color: {
    themeKey: "palette",
    transform: paletteTransform
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: paletteTransform
  },
  backgroundColor: {
    themeKey: "palette",
    transform: paletteTransform
  },
  // spacing
  p: {
    style: padding
  },
  pt: {
    style: padding
  },
  pr: {
    style: padding
  },
  pb: {
    style: padding
  },
  pl: {
    style: padding
  },
  px: {
    style: padding
  },
  py: {
    style: padding
  },
  padding: {
    style: padding
  },
  paddingTop: {
    style: padding
  },
  paddingRight: {
    style: padding
  },
  paddingBottom: {
    style: padding
  },
  paddingLeft: {
    style: padding
  },
  paddingX: {
    style: padding
  },
  paddingY: {
    style: padding
  },
  paddingInline: {
    style: padding
  },
  paddingInlineStart: {
    style: padding
  },
  paddingInlineEnd: {
    style: padding
  },
  paddingBlock: {
    style: padding
  },
  paddingBlockStart: {
    style: padding
  },
  paddingBlockEnd: {
    style: padding
  },
  m: {
    style: margin
  },
  mt: {
    style: margin
  },
  mr: {
    style: margin
  },
  mb: {
    style: margin
  },
  ml: {
    style: margin
  },
  mx: {
    style: margin
  },
  my: {
    style: margin
  },
  margin: {
    style: margin
  },
  marginTop: {
    style: margin
  },
  marginRight: {
    style: margin
  },
  marginBottom: {
    style: margin
  },
  marginLeft: {
    style: margin
  },
  marginX: {
    style: margin
  },
  marginY: {
    style: margin
  },
  marginInline: {
    style: margin
  },
  marginInlineStart: {
    style: margin
  },
  marginInlineEnd: {
    style: margin
  },
  marginBlock: {
    style: margin
  },
  marginBlockStart: {
    style: margin
  },
  marginBlockEnd: {
    style: margin
  },
  // display
  displayPrint: {
    cssProperty: false,
    transform: (value2) => ({
      "@media print": {
        display: value2
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: gap
  },
  rowGap: {
    style: rowGap
  },
  columnGap: {
    style: columnGap
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: sizingTransform
  },
  maxWidth: {
    style: maxWidth
  },
  minWidth: {
    transform: sizingTransform
  },
  height: {
    transform: sizingTransform
  },
  maxHeight: {
    transform: sizingTransform
  },
  minHeight: {
    transform: sizingTransform
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: false,
    themeKey: "typography"
  }
};
function objectsHaveSameKeys(...objects) {
  const allKeys = objects.reduce((keys, object) => keys.concat(Object.keys(object)), []);
  const union = new Set(allKeys);
  return objects.every((object) => union.size === Object.keys(object).length);
}
function callIfFn(maybeFn, arg) {
  return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function unstable_createStyleFunctionSx() {
  function getThemeValue(prop, val, theme, config2) {
    const props = {
      [prop]: val,
      theme
    };
    const options = config2[prop];
    if (!options) {
      return {
        [prop]: val
      };
    }
    const {
      cssProperty = prop,
      themeKey,
      transform,
      style: style2
    } = options;
    if (val == null) {
      return null;
    }
    if (themeKey === "typography" && val === "inherit") {
      return {
        [prop]: val
      };
    }
    const themeMapping = getPath(theme, themeKey) || {};
    if (style2) {
      return style2(props);
    }
    const styleFromPropValue = (propValueFinal) => {
      let value2 = getStyleValue(themeMapping, transform, propValueFinal);
      if (propValueFinal === value2 && typeof propValueFinal === "string") {
        value2 = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : capitalize$1(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value2;
      }
      return {
        [cssProperty]: value2
      };
    };
    return handleBreakpoints(props, val, styleFromPropValue);
  }
  function styleFunctionSx2(props) {
    var _theme$unstable_sxCon;
    const {
      sx,
      theme = {}
    } = props || {};
    if (!sx) {
      return null;
    }
    const config2 = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : defaultSxConfig;
    function traverse(sxInput) {
      let sxObject = sxInput;
      if (typeof sxInput === "function") {
        sxObject = sxInput(theme);
      } else if (typeof sxInput !== "object") {
        return sxInput;
      }
      if (!sxObject) {
        return null;
      }
      const emptyBreakpoints = createEmptyBreakpointObject(theme.breakpoints);
      const breakpointsKeys = Object.keys(emptyBreakpoints);
      let css2 = emptyBreakpoints;
      Object.keys(sxObject).forEach((styleKey) => {
        const value2 = callIfFn(sxObject[styleKey], theme);
        if (value2 !== null && value2 !== void 0) {
          if (typeof value2 === "object") {
            if (config2[styleKey]) {
              css2 = merge(css2, getThemeValue(styleKey, value2, theme, config2));
            } else {
              const breakpointsValues = handleBreakpoints({
                theme
              }, value2, (x) => ({
                [styleKey]: x
              }));
              if (objectsHaveSameKeys(breakpointsValues, value2)) {
                css2[styleKey] = styleFunctionSx2({
                  sx: value2,
                  theme
                });
              } else {
                css2 = merge(css2, breakpointsValues);
              }
            }
          } else {
            css2 = merge(css2, getThemeValue(styleKey, value2, theme, config2));
          }
        }
      });
      return removeUnusedBreakpoints(breakpointsKeys, css2);
    }
    return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
  }
  return styleFunctionSx2;
}
const styleFunctionSx$1 = unstable_createStyleFunctionSx();
styleFunctionSx$1.filterProps = ["sx"];
function applyStyles(key, styles2) {
  const theme = this;
  if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
    const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
    return {
      [selector]: styles2
    };
  }
  if (theme.palette.mode === key) {
    return styles2;
  }
  return {};
}
const _excluded$g = ["breakpoints", "palette", "spacing", "shape"];
function createTheme$2(options = {}, ...args) {
  const {
    breakpoints: breakpointsInput = {},
    palette: paletteInput = {},
    spacing: spacingInput,
    shape: shapeInput = {}
  } = options, other = _objectWithoutPropertiesLoose(options, _excluded$g);
  const breakpoints2 = createBreakpoints(breakpointsInput);
  const spacing = createSpacing(spacingInput);
  let muiTheme = deepmerge$1({
    breakpoints: breakpoints2,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: _extends$1({
      mode: "light"
    }, paletteInput),
    spacing,
    shape: _extends$1({}, shape, shapeInput)
  }, other);
  muiTheme.applyStyles = applyStyles;
  muiTheme = args.reduce((acc, argument) => deepmerge$1(acc, argument), muiTheme);
  muiTheme.unstable_sxConfig = _extends$1({}, defaultSxConfig, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return styleFunctionSx$1({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}
const createTheme$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: createTheme$2,
  private_createBreakpoints: createBreakpoints,
  unstable_applyStyles: applyStyles
}, Symbol.toStringTag, { value: "Module" }));
function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function useTheme$3(defaultTheme2 = null) {
  const contextTheme = React.useContext(ThemeContext$1);
  return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme2 : contextTheme;
}
const systemDefaultTheme = createTheme$2();
function useTheme$2(defaultTheme2 = systemDefaultTheme) {
  return useTheme$3(defaultTheme2);
}
const _excluded$f = ["sx"];
const splitProps = (props) => {
  var _props$theme$unstable, _props$theme;
  const result = {
    systemProps: {},
    otherProps: {}
  };
  const config2 = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : defaultSxConfig;
  Object.keys(props).forEach((prop) => {
    if (config2[prop]) {
      result.systemProps[prop] = props[prop];
    } else {
      result.otherProps[prop] = props[prop];
    }
  });
  return result;
};
function extendSxProp(props) {
  const {
    sx: inSx
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$f);
  const {
    systemProps,
    otherProps
  } = splitProps(other);
  let finalSx;
  if (Array.isArray(inSx)) {
    finalSx = [systemProps, ...inSx];
  } else if (typeof inSx === "function") {
    finalSx = (...args) => {
      const result = inSx(...args);
      if (!isPlainObject(result)) {
        return systemProps;
      }
      return _extends$1({}, systemProps, result);
    };
  } else {
    finalSx = _extends$1({}, systemProps, inSx);
  }
  return _extends$1({}, otherProps, {
    sx: finalSx
  });
}
const styleFunctionSx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: styleFunctionSx$1,
  extendSxProp,
  unstable_createStyleFunctionSx,
  unstable_defaultSxConfig: defaultSxConfig
}, Symbol.toStringTag, { value: "Module" }));
const defaultGenerator = (componentName) => componentName;
const createClassNameGenerator = () => {
  let generate = defaultGenerator;
  return {
    configure(generator) {
      generate = generator;
    },
    generate(componentName) {
      return generate(componentName);
    },
    reset() {
      generate = defaultGenerator;
    }
  };
};
const ClassNameGenerator = createClassNameGenerator();
const globalStateClasses = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function generateUtilityClass(componentName, slot, globalStatePrefix = "Mui") {
  const globalStateClass = globalStateClasses[slot];
  return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${ClassNameGenerator.generate(componentName)}-${slot}`;
}
function generateUtilityClasses(componentName, slots, globalStatePrefix = "Mui") {
  const result = {};
  slots.forEach((slot) => {
    result[slot] = generateUtilityClass(componentName, slot, globalStatePrefix);
  });
  return result;
}
var reactIs$1 = { exports: {} };
var reactIs_production$1 = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production$1;
function requireReactIs_production$1() {
  if (hasRequiredReactIs_production$1) return reactIs_production$1;
  hasRequiredReactIs_production$1 = 1;
  var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler");
  var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
  function typeOf(object) {
    if ("object" === typeof object && null !== object) {
      var $$typeof = object.$$typeof;
      switch ($$typeof) {
        case REACT_ELEMENT_TYPE:
          switch (object = object.type, object) {
            case REACT_FRAGMENT_TYPE:
            case REACT_PROFILER_TYPE:
            case REACT_STRICT_MODE_TYPE:
            case REACT_SUSPENSE_TYPE:
            case REACT_SUSPENSE_LIST_TYPE:
            case REACT_VIEW_TRANSITION_TYPE:
              return object;
            default:
              switch (object = object && object.$$typeof, object) {
                case REACT_CONTEXT_TYPE:
                case REACT_FORWARD_REF_TYPE:
                case REACT_LAZY_TYPE:
                case REACT_MEMO_TYPE:
                  return object;
                case REACT_CONSUMER_TYPE:
                  return object;
                default:
                  return $$typeof;
              }
          }
        case REACT_PORTAL_TYPE:
          return $$typeof;
      }
    }
  }
  reactIs_production$1.ContextConsumer = REACT_CONSUMER_TYPE;
  reactIs_production$1.ContextProvider = REACT_CONTEXT_TYPE;
  reactIs_production$1.Element = REACT_ELEMENT_TYPE;
  reactIs_production$1.ForwardRef = REACT_FORWARD_REF_TYPE;
  reactIs_production$1.Fragment = REACT_FRAGMENT_TYPE;
  reactIs_production$1.Lazy = REACT_LAZY_TYPE;
  reactIs_production$1.Memo = REACT_MEMO_TYPE;
  reactIs_production$1.Portal = REACT_PORTAL_TYPE;
  reactIs_production$1.Profiler = REACT_PROFILER_TYPE;
  reactIs_production$1.StrictMode = REACT_STRICT_MODE_TYPE;
  reactIs_production$1.Suspense = REACT_SUSPENSE_TYPE;
  reactIs_production$1.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
  reactIs_production$1.isContextConsumer = function(object) {
    return typeOf(object) === REACT_CONSUMER_TYPE;
  };
  reactIs_production$1.isContextProvider = function(object) {
    return typeOf(object) === REACT_CONTEXT_TYPE;
  };
  reactIs_production$1.isElement = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
  };
  reactIs_production$1.isForwardRef = function(object) {
    return typeOf(object) === REACT_FORWARD_REF_TYPE;
  };
  reactIs_production$1.isFragment = function(object) {
    return typeOf(object) === REACT_FRAGMENT_TYPE;
  };
  reactIs_production$1.isLazy = function(object) {
    return typeOf(object) === REACT_LAZY_TYPE;
  };
  reactIs_production$1.isMemo = function(object) {
    return typeOf(object) === REACT_MEMO_TYPE;
  };
  reactIs_production$1.isPortal = function(object) {
    return typeOf(object) === REACT_PORTAL_TYPE;
  };
  reactIs_production$1.isProfiler = function(object) {
    return typeOf(object) === REACT_PROFILER_TYPE;
  };
  reactIs_production$1.isStrictMode = function(object) {
    return typeOf(object) === REACT_STRICT_MODE_TYPE;
  };
  reactIs_production$1.isSuspense = function(object) {
    return typeOf(object) === REACT_SUSPENSE_TYPE;
  };
  reactIs_production$1.isSuspenseList = function(object) {
    return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
  };
  reactIs_production$1.isValidElementType = function(type) {
    return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? true : false;
  };
  reactIs_production$1.typeOf = typeOf;
  return reactIs_production$1;
}
var reactIs_development$1 = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  if (hasRequiredReactIs_development$1) return reactIs_development$1;
  hasRequiredReactIs_development$1 = 1;
  "production" !== process.env.NODE_ENV && function() {
    function typeOf(object) {
      if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            switch (object = object.type, object) {
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
              case REACT_SUSPENSE_LIST_TYPE:
              case REACT_VIEW_TRANSITION_TYPE:
                return object;
              default:
                switch (object = object && object.$$typeof, object) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                    return object;
                  case REACT_CONSUMER_TYPE:
                    return object;
                  default:
                    return $$typeof;
                }
            }
          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }
    }
    var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
    reactIs_development$1.ContextConsumer = REACT_CONSUMER_TYPE;
    reactIs_development$1.ContextProvider = REACT_CONTEXT_TYPE;
    reactIs_development$1.Element = REACT_ELEMENT_TYPE;
    reactIs_development$1.ForwardRef = REACT_FORWARD_REF_TYPE;
    reactIs_development$1.Fragment = REACT_FRAGMENT_TYPE;
    reactIs_development$1.Lazy = REACT_LAZY_TYPE;
    reactIs_development$1.Memo = REACT_MEMO_TYPE;
    reactIs_development$1.Portal = REACT_PORTAL_TYPE;
    reactIs_development$1.Profiler = REACT_PROFILER_TYPE;
    reactIs_development$1.StrictMode = REACT_STRICT_MODE_TYPE;
    reactIs_development$1.Suspense = REACT_SUSPENSE_TYPE;
    reactIs_development$1.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
    reactIs_development$1.isContextConsumer = function(object) {
      return typeOf(object) === REACT_CONSUMER_TYPE;
    };
    reactIs_development$1.isContextProvider = function(object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    };
    reactIs_development$1.isElement = function(object) {
      return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
    };
    reactIs_development$1.isForwardRef = function(object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    };
    reactIs_development$1.isFragment = function(object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    };
    reactIs_development$1.isLazy = function(object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    };
    reactIs_development$1.isMemo = function(object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    };
    reactIs_development$1.isPortal = function(object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    };
    reactIs_development$1.isProfiler = function(object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    };
    reactIs_development$1.isStrictMode = function(object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    };
    reactIs_development$1.isSuspense = function(object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    };
    reactIs_development$1.isSuspenseList = function(object) {
      return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    };
    reactIs_development$1.isValidElementType = function(type) {
      return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? true : false;
    };
    reactIs_development$1.typeOf = typeOf;
  }();
  return reactIs_development$1;
}
var hasRequiredReactIs$1;
function requireReactIs$1() {
  if (hasRequiredReactIs$1) return reactIs$1.exports;
  hasRequiredReactIs$1 = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs$1.exports = /* @__PURE__ */ requireReactIs_production$1();
  } else {
    reactIs$1.exports = /* @__PURE__ */ requireReactIs_development$1();
  }
  return reactIs$1.exports;
}
var reactIsExports$1 = /* @__PURE__ */ requireReactIs$1();
const fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  const match2 = `${fn}`.match(fnNameMatchRegex);
  const name2 = match2 && match2[1];
  return name2 || "";
}
function getFunctionComponentName(Component, fallback = "") {
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}
function getWrappedName(outerType, innerType, wrapperName) {
  const functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function getDisplayName$1(Component) {
  if (Component == null) {
    return void 0;
  }
  if (typeof Component === "string") {
    return Component;
  }
  if (typeof Component === "function") {
    return getFunctionComponentName(Component, "Component");
  }
  if (typeof Component === "object") {
    switch (Component.$$typeof) {
      case reactIsExports$1.ForwardRef:
        return getWrappedName(Component, Component.render, "ForwardRef");
      case reactIsExports$1.Memo:
        return getWrappedName(Component, Component.type, "memo");
      default:
        return void 0;
    }
  }
  return void 0;
}
const getDisplayName = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: getDisplayName$1,
  getFunctionName
}, Symbol.toStringTag, { value: "Module" }));
function resolveProps(defaultProps2, props) {
  const output = _extends$1({}, props);
  Object.keys(defaultProps2).forEach((propName) => {
    if (propName.toString().match(/^(components|slots)$/)) {
      output[propName] = _extends$1({}, defaultProps2[propName], output[propName]);
    } else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
      const defaultSlotProps = defaultProps2[propName] || {};
      const slotProps = props[propName];
      output[propName] = {};
      if (!slotProps || !Object.keys(slotProps)) {
        output[propName] = defaultSlotProps;
      } else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) {
        output[propName] = slotProps;
      } else {
        output[propName] = _extends$1({}, slotProps);
        Object.keys(defaultSlotProps).forEach((slotPropName) => {
          output[propName][slotPropName] = resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName]);
        });
      }
    } else if (output[propName] === void 0) {
      output[propName] = defaultProps2[propName];
    }
  });
  return output;
}
const useEnhancedEffect = typeof window !== "undefined" ? React.useLayoutEffect : React.useEffect;
function clamp$1(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
  return Math.max(min, Math.min(val, max));
}
const clamp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: clamp$1
}, Symbol.toStringTag, { value: "Module" }));
function chainPropTypes(propType1, propType2) {
  if (process.env.NODE_ENV === "production") {
    return () => null;
  }
  return function validate(...args) {
    return propType1(...args) || propType2(...args);
  };
}
function isClassComponent(elementType) {
  const {
    prototype = {}
  } = elementType;
  return Boolean(prototype.isReactComponent);
}
function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
  const propValue = props[propName];
  const safePropName = propFullName || propName;
  if (propValue == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window === "undefined") {
    return null;
  }
  let warningHint;
  if (typeof propValue === "function" && !isClassComponent(propValue)) {
    warningHint = "Did you accidentally provide a plain function component instead?";
  }
  if (warningHint !== void 0) {
    return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. Expected an element type that can hold a ref. ${warningHint} For more information see https://mui.com/r/caveat-with-refs-guide`);
  }
  return null;
}
const elementTypeAcceptingRef$1 = chainPropTypes(PropTypes.elementType, elementTypeAcceptingRef);
const specialProperty = "exact-prop: ​";
function exactProp(propTypes2) {
  if (process.env.NODE_ENV === "production") {
    return propTypes2;
  }
  return _extends$1({}, propTypes2, {
    [specialProperty]: (props) => {
      const unsupportedProps = Object.keys(props).filter((prop) => !propTypes2.hasOwnProperty(prop));
      if (unsupportedProps.length > 0) {
        return new Error(`The following props are not supported: ${unsupportedProps.map((prop) => `\`${prop}\``).join(", ")}. Please remove them.`);
      }
      return null;
    }
  });
}
const refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
function setRef(ref, value2) {
  if (typeof ref === "function") {
    ref(value2);
  } else if (ref) {
    ref.current = value2;
  }
}
function useControlled({
  controlled,
  default: defaultProp,
  name: name2,
  state = "value"
}) {
  const {
    current: isControlled
  } = React.useRef(controlled !== void 0);
  const [valueState, setValue] = React.useState(defaultProp);
  const value2 = isControlled ? controlled : valueState;
  if (process.env.NODE_ENV !== "production") {
    React.useEffect(() => {
      if (isControlled !== (controlled !== void 0)) {
        console.error([`MUI: A component is changing the ${isControlled ? "" : "un"}controlled ${state} state of ${name2} to be ${isControlled ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${name2} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join("\n"));
      }
    }, [state, name2, controlled]);
    const {
      current: defaultValue
    } = React.useRef(defaultProp);
    React.useEffect(() => {
      if (!isControlled && !Object.is(defaultValue, defaultProp)) {
        console.error([`MUI: A component is changing the default ${state} state of an uncontrolled ${name2} after being initialized. To suppress this warning opt to use a controlled ${name2}.`].join("\n"));
      }
    }, [JSON.stringify(defaultProp)]);
  }
  const setValueIfUncontrolled = React.useCallback((newValue) => {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value2, setValueIfUncontrolled];
}
function useEventCallback(fn) {
  const ref = React.useRef(fn);
  useEnhancedEffect(() => {
    ref.current = fn;
  });
  return React.useRef((...args) => (
    // @ts-expect-error hide `this`
    (0, ref.current)(...args)
  )).current;
}
function useForkRef(...refs) {
  return React.useMemo(() => {
    if (refs.every((ref) => ref == null)) {
      return null;
    }
    return (instance) => {
      refs.forEach((ref) => {
        setRef(ref, instance);
      });
    };
  }, refs);
}
const UNINITIALIZED = {};
function useLazyRef(init, initArg) {
  const ref = React.useRef(UNINITIALIZED);
  if (ref.current === UNINITIALIZED) {
    ref.current = init(initArg);
  }
  return ref;
}
const EMPTY = [];
function useOnMount(fn) {
  React.useEffect(fn, EMPTY);
}
class Timeout {
  constructor() {
    this.currentId = null;
    this.clear = () => {
      if (this.currentId !== null) {
        clearTimeout(this.currentId);
        this.currentId = null;
      }
    };
    this.disposeEffect = () => {
      return this.clear;
    };
  }
  static create() {
    return new Timeout();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(delay, fn) {
    this.clear();
    this.currentId = setTimeout(() => {
      this.currentId = null;
      fn();
    }, delay);
  }
}
function useTimeout() {
  const timeout2 = useLazyRef(Timeout.create).current;
  useOnMount(timeout2.disposeEffect);
  return timeout2;
}
let hadKeyboardEvent = true;
let hadFocusVisibleRecently = false;
const hadFocusVisibleRecentlyTimeout = new Timeout();
const inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  "datetime-local": true
};
function focusTriggersKeyboardModality(node2) {
  const {
    type,
    tagName
  } = node2;
  if (tagName === "INPUT" && inputTypesWhitelist[type] && !node2.readOnly) {
    return true;
  }
  if (tagName === "TEXTAREA" && !node2.readOnly) {
    return true;
  }
  if (node2.isContentEditable) {
    return true;
  }
  return false;
}
function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }
  hadKeyboardEvent = true;
}
function handlePointerDown() {
  hadKeyboardEvent = false;
}
function handleVisibilityChange() {
  if (this.visibilityState === "hidden") {
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}
function prepare(doc) {
  doc.addEventListener("keydown", handleKeyDown, true);
  doc.addEventListener("mousedown", handlePointerDown, true);
  doc.addEventListener("pointerdown", handlePointerDown, true);
  doc.addEventListener("touchstart", handlePointerDown, true);
  doc.addEventListener("visibilitychange", handleVisibilityChange, true);
}
function isFocusVisible(event) {
  const {
    target
  } = event;
  try {
    return target.matches(":focus-visible");
  } catch (error2) {
  }
  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
function useIsFocusVisible() {
  const ref = React.useCallback((node2) => {
    if (node2 != null) {
      prepare(node2.ownerDocument);
    }
  }, []);
  const isFocusVisibleRef = React.useRef(false);
  function handleBlurVisible() {
    if (isFocusVisibleRef.current) {
      hadFocusVisibleRecently = true;
      hadFocusVisibleRecentlyTimeout.start(100, () => {
        hadFocusVisibleRecently = false;
      });
      isFocusVisibleRef.current = false;
      return true;
    }
    return false;
  }
  function handleFocusVisible(event) {
    if (isFocusVisible(event)) {
      isFocusVisibleRef.current = true;
      return true;
    }
    return false;
  }
  return {
    isFocusVisibleRef,
    onFocus: handleFocusVisible,
    onBlur: handleBlurVisible,
    ref
  };
}
function getTypeByValue(value2) {
  const valueType = typeof value2;
  switch (valueType) {
    case "number":
      if (Number.isNaN(value2)) {
        return "NaN";
      }
      if (!Number.isFinite(value2)) {
        return "Infinity";
      }
      if (value2 !== Math.floor(value2)) {
        return "float";
      }
      return "number";
    case "object":
      if (value2 === null) {
        return "null";
      }
      return value2.constructor.name;
    default:
      return valueType;
  }
}
function ponyfillIsInteger(x) {
  return typeof x === "number" && isFinite(x) && Math.floor(x) === x;
}
const isInteger = Number.isInteger || ponyfillIsInteger;
function requiredInteger(props, propName, componentName, location) {
  const propValue = props[propName];
  if (propValue == null || !isInteger(propValue)) {
    const propType = getTypeByValue(propValue);
    return new RangeError(`Invalid ${location} \`${propName}\` of type \`${propType}\` supplied to \`${componentName}\`, expected \`integer\`.`);
  }
  return null;
}
function validator(props, propName, ...other) {
  const propValue = props[propName];
  if (propValue === void 0) {
    return null;
  }
  return requiredInteger(props, propName, ...other);
}
function validatorNoop() {
  return null;
}
validator.isRequired = requiredInteger;
validatorNoop.isRequired = validatorNoop;
const integerPropType = process.env.NODE_ENV === "production" ? validatorNoop : validator;
function composeClasses(slots, getUtilityClass, classes = void 0) {
  const output = {};
  Object.keys(slots).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot) => {
      output[slot] = slots[slot].reduce((acc, key) => {
        if (key) {
          const utilityClass = getUtilityClass(key);
          if (utilityClass !== "") {
            acc.push(utilityClass);
          }
          if (classes && classes[key]) {
            acc.push(classes[key]);
          }
        }
        return acc;
      }, []).join(" ");
    }
  );
  return output;
}
function isHostComponent(element) {
  return typeof element === "string";
}
function appendOwnerState(elementType, otherProps, ownerState) {
  if (elementType === void 0 || isHostComponent(elementType)) {
    return otherProps;
  }
  return _extends$1({}, otherProps, {
    ownerState: _extends$1({}, otherProps.ownerState, ownerState)
  });
}
function r$1(e) {
  var t, f, n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;
  else if ("object" == typeof e) if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (f = r$1(e[t])) && (n && (n += " "), n += f);
  } else for (f in e) e[f] && (n && (n += " "), n += f);
  return n;
}
function clsx$1() {
  for (var e, t, f = 0, n = "", o = arguments.length; f < o; f++) (e = arguments[f]) && (t = r$1(e)) && (n && (n += " "), n += t);
  return n;
}
function extractEventHandlers(object, excludeKeys = []) {
  if (object === void 0) {
    return {};
  }
  const result = {};
  Object.keys(object).filter((prop) => prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop) => {
    result[prop] = object[prop];
  });
  return result;
}
function omitEventHandlers(object) {
  if (object === void 0) {
    return {};
  }
  const result = {};
  Object.keys(object).filter((prop) => !(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop) => {
    result[prop] = object[prop];
  });
  return result;
}
function mergeSlotProps(parameters) {
  const {
    getSlotProps,
    additionalProps,
    externalSlotProps,
    externalForwardedProps,
    className
  } = parameters;
  if (!getSlotProps) {
    const joinedClasses2 = clsx$1(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle2 = _extends$1({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props2 = _extends$1({}, additionalProps, externalForwardedProps, externalSlotProps);
    if (joinedClasses2.length > 0) {
      props2.className = joinedClasses2;
    }
    if (Object.keys(mergedStyle2).length > 0) {
      props2.style = mergedStyle2;
    }
    return {
      props: props2,
      internalRef: void 0
    };
  }
  const eventHandlers = extractEventHandlers(_extends$1({}, externalForwardedProps, externalSlotProps));
  const componentsPropsWithoutEventHandlers = omitEventHandlers(externalSlotProps);
  const otherPropsWithoutEventHandlers = omitEventHandlers(externalForwardedProps);
  const internalSlotProps = getSlotProps(eventHandlers);
  const joinedClasses = clsx$1(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
  const mergedStyle = _extends$1({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
  const props = _extends$1({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
  if (joinedClasses.length > 0) {
    props.className = joinedClasses;
  }
  if (Object.keys(mergedStyle).length > 0) {
    props.style = mergedStyle;
  }
  return {
    props,
    internalRef: internalSlotProps.ref
  };
}
function resolveComponentProps(componentProps, ownerState, slotState) {
  if (typeof componentProps === "function") {
    return componentProps(ownerState, slotState);
  }
  return componentProps;
}
const ThemeContext = /* @__PURE__ */ React.createContext(null);
if (process.env.NODE_ENV !== "production") {
  ThemeContext.displayName = "ThemeContext";
}
function useTheme$1() {
  const theme = React.useContext(ThemeContext);
  if (process.env.NODE_ENV !== "production") {
    React.useDebugValue(theme);
  }
  return theme;
}
const hasSymbol = typeof Symbol === "function" && Symbol.for;
const nested = hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";
function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === "function") {
    const mergedTheme = localTheme(outerTheme);
    if (process.env.NODE_ENV !== "production") {
      if (!mergedTheme) {
        console.error(["MUI: You should return an object from your theme function, i.e.", "<ThemeProvider theme={() => ({})} />"].join("\n"));
      }
    }
    return mergedTheme;
  }
  return _extends$1({}, outerTheme, localTheme);
}
function ThemeProvider$3(props) {
  const {
    children,
    theme: localTheme
  } = props;
  const outerTheme = useTheme$1();
  if (process.env.NODE_ENV !== "production") {
    if (outerTheme === null && typeof localTheme === "function") {
      console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join("\n"));
    }
  }
  const theme = React.useMemo(() => {
    const output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);
    if (output != null) {
      output[nested] = outerTheme !== null;
    }
    return output;
  }, [localTheme, outerTheme]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeContext.Provider, {
    value: theme,
    children
  });
}
process.env.NODE_ENV !== "production" ? ThemeProvider$3.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
} : void 0;
if (process.env.NODE_ENV !== "production") {
  process.env.NODE_ENV !== "production" ? ThemeProvider$3.propTypes = exactProp(ThemeProvider$3.propTypes) : void 0;
}
const _excluded$e = ["value"];
const RtlContext = /* @__PURE__ */ React.createContext();
function RtlProvider(_ref) {
  let {
    value: value2
  } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded$e);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(RtlContext.Provider, _extends$1({
    value: value2 != null ? value2 : true
  }, props));
}
process.env.NODE_ENV !== "production" ? RtlProvider.propTypes = {
  children: PropTypes.node,
  value: PropTypes.bool
} : void 0;
const PropsContext = /* @__PURE__ */ React.createContext(void 0);
function DefaultPropsProvider({
  value: value2,
  children
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PropsContext.Provider, {
    value: value2,
    children
  });
}
process.env.NODE_ENV !== "production" ? DefaultPropsProvider.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  value: PropTypes.object
} : void 0;
function getThemeProps(params) {
  const {
    theme,
    name: name2,
    props
  } = params;
  if (!theme || !theme.components || !theme.components[name2]) {
    return props;
  }
  const config2 = theme.components[name2];
  if (config2.defaultProps) {
    return resolveProps(config2.defaultProps, props);
  }
  if (!config2.styleOverrides && !config2.variants) {
    return resolveProps(config2, props);
  }
  return props;
}
function useDefaultProps$1({
  props,
  name: name2
}) {
  const ctx = React.useContext(PropsContext);
  return getThemeProps({
    props,
    name: name2,
    theme: {
      components: ctx
    }
  });
}
const EMPTY_THEME = {};
function useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
  return React.useMemo(() => {
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    if (typeof localTheme === "function") {
      const mergedTheme = localTheme(resolvedTheme);
      const result = themeId ? _extends$1({}, upperTheme, {
        [themeId]: mergedTheme
      }) : mergedTheme;
      if (isPrivate) {
        return () => result;
      }
      return result;
    }
    return themeId ? _extends$1({}, upperTheme, {
      [themeId]: localTheme
    }) : _extends$1({}, upperTheme, localTheme);
  }, [themeId, upperTheme, localTheme, isPrivate]);
}
function ThemeProvider$2(props) {
  const {
    children,
    theme: localTheme,
    themeId
  } = props;
  const upperTheme = useTheme$3(EMPTY_THEME);
  const upperPrivateTheme = useTheme$1() || EMPTY_THEME;
  if (process.env.NODE_ENV !== "production") {
    if (upperTheme === null && typeof localTheme === "function" || themeId && upperTheme && !upperTheme[themeId] && typeof localTheme === "function") {
      console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join("\n"));
    }
  }
  const engineTheme = useThemeScoping(themeId, upperTheme, localTheme);
  const privateTheme = useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
  const rtlValue = engineTheme.direction === "rtl";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider$3, {
    theme: privateTheme,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeContext$1.Provider, {
      value: engineTheme,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(RtlProvider, {
        value: rtlValue,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(DefaultPropsProvider, {
          value: engineTheme == null ? void 0 : engineTheme.components,
          children
        })
      })
    })
  });
}
process.env.NODE_ENV !== "production" ? ThemeProvider$2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: PropTypes.string
} : void 0;
if (process.env.NODE_ENV !== "production") {
  process.env.NODE_ENV !== "production" ? ThemeProvider$2.propTypes = exactProp(ThemeProvider$2.propTypes) : void 0;
}
function createMixins(breakpoints2, mixins) {
  return _extends$1({
    toolbar: {
      minHeight: 56,
      [breakpoints2.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [breakpoints2.up("sm")]: {
        minHeight: 64
      }
    }
  }, mixins);
}
var colorManipulator = {};
var interopRequireDefault = { exports: {} };
var hasRequiredInteropRequireDefault;
function requireInteropRequireDefault() {
  if (hasRequiredInteropRequireDefault) return interopRequireDefault.exports;
  hasRequiredInteropRequireDefault = 1;
  (function(module) {
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }
    module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(interopRequireDefault);
  return interopRequireDefault.exports;
}
const require$$1$1 = /* @__PURE__ */ getAugmentedNamespace(formatMuiErrorMessage);
const require$$2 = /* @__PURE__ */ getAugmentedNamespace(clamp);
var hasRequiredColorManipulator;
function requireColorManipulator() {
  if (hasRequiredColorManipulator) return colorManipulator;
  hasRequiredColorManipulator = 1;
  var _interopRequireDefault = /* @__PURE__ */ requireInteropRequireDefault();
  Object.defineProperty(colorManipulator, "__esModule", {
    value: true
  });
  colorManipulator.alpha = alpha;
  colorManipulator.blend = blend;
  colorManipulator.colorChannel = void 0;
  colorManipulator.darken = darken;
  colorManipulator.decomposeColor = decomposeColor;
  colorManipulator.emphasize = emphasize;
  colorManipulator.getContrastRatio = getContrastRatio;
  colorManipulator.getLuminance = getLuminance;
  colorManipulator.hexToRgb = hexToRgb;
  colorManipulator.hslToRgb = hslToRgb;
  colorManipulator.lighten = lighten;
  colorManipulator.private_safeAlpha = private_safeAlpha;
  colorManipulator.private_safeColorChannel = void 0;
  colorManipulator.private_safeDarken = private_safeDarken;
  colorManipulator.private_safeEmphasize = private_safeEmphasize;
  colorManipulator.private_safeLighten = private_safeLighten;
  colorManipulator.recomposeColor = recomposeColor;
  colorManipulator.rgbToHex = rgbToHex;
  var _formatMuiErrorMessage2 = _interopRequireDefault(require$$1$1);
  var _clamp = _interopRequireDefault(require$$2);
  function clampWrapper(value2, min = 0, max = 1) {
    if (process.env.NODE_ENV !== "production") {
      if (value2 < min || value2 > max) {
        console.error(`MUI: The value provided ${value2} is out of range [${min}, ${max}].`);
      }
    }
    return (0, _clamp.default)(value2, min, max);
  }
  function hexToRgb(color2) {
    color2 = color2.slice(1);
    const re = new RegExp(`.{1,${color2.length >= 6 ? 2 : 1}}`, "g");
    let colors = color2.match(re);
    if (colors && colors[0].length === 1) {
      colors = colors.map((n) => n + n);
    }
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index) => {
      return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3;
    }).join(", ")})` : "";
  }
  function intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
  }
  function decomposeColor(color2) {
    if (color2.type) {
      return color2;
    }
    if (color2.charAt(0) === "#") {
      return decomposeColor(hexToRgb(color2));
    }
    const marker = color2.indexOf("(");
    const type = color2.substring(0, marker);
    if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(type) === -1) {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${color2}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : (0, _formatMuiErrorMessage2.default)(9, color2));
    }
    let values2 = color2.substring(marker + 1, color2.length - 1);
    let colorSpace;
    if (type === "color") {
      values2 = values2.split(" ");
      colorSpace = values2.shift();
      if (values2.length === 4 && values2[3].charAt(0) === "/") {
        values2[3] = values2[3].slice(1);
      }
      if (["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(colorSpace) === -1) {
        throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${colorSpace}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : (0, _formatMuiErrorMessage2.default)(10, colorSpace));
      }
    } else {
      values2 = values2.split(",");
    }
    values2 = values2.map((value2) => parseFloat(value2));
    return {
      type,
      values: values2,
      colorSpace
    };
  }
  const colorChannel = (color2) => {
    const decomposedColor = decomposeColor(color2);
    return decomposedColor.values.slice(0, 3).map((val, idx) => decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
  };
  colorManipulator.colorChannel = colorChannel;
  const private_safeColorChannel = (color2, warning2) => {
    try {
      return colorChannel(color2);
    } catch (error2) {
      if (warning2 && process.env.NODE_ENV !== "production") {
        console.warn(warning2);
      }
      return color2;
    }
  };
  colorManipulator.private_safeColorChannel = private_safeColorChannel;
  function recomposeColor(color2) {
    const {
      type,
      colorSpace
    } = color2;
    let {
      values: values2
    } = color2;
    if (type.indexOf("rgb") !== -1) {
      values2 = values2.map((n, i) => i < 3 ? parseInt(n, 10) : n);
    } else if (type.indexOf("hsl") !== -1) {
      values2[1] = `${values2[1]}%`;
      values2[2] = `${values2[2]}%`;
    }
    if (type.indexOf("color") !== -1) {
      values2 = `${colorSpace} ${values2.join(" ")}`;
    } else {
      values2 = `${values2.join(", ")}`;
    }
    return `${type}(${values2})`;
  }
  function rgbToHex(color2) {
    if (color2.indexOf("#") === 0) {
      return color2;
    }
    const {
      values: values2
    } = decomposeColor(color2);
    return `#${values2.map((n, i) => intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
  }
  function hslToRgb(color2) {
    color2 = decomposeColor(color2);
    const {
      values: values2
    } = color2;
    const h = values2[0];
    const s = values2[1] / 100;
    const l = values2[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
    if (color2.type === "hsla") {
      type += "a";
      rgb.push(values2[3]);
    }
    return recomposeColor({
      type,
      values: rgb
    });
  }
  function getLuminance(color2) {
    color2 = decomposeColor(color2);
    let rgb = color2.type === "hsl" || color2.type === "hsla" ? decomposeColor(hslToRgb(color2)).values : color2.values;
    rgb = rgb.map((val) => {
      if (color2.type !== "color") {
        val /= 255;
      }
      return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
  }
  function getContrastRatio(foreground, background) {
    const lumA = getLuminance(foreground);
    const lumB = getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
  }
  function alpha(color2, value2) {
    color2 = decomposeColor(color2);
    value2 = clampWrapper(value2);
    if (color2.type === "rgb" || color2.type === "hsl") {
      color2.type += "a";
    }
    if (color2.type === "color") {
      color2.values[3] = `/${value2}`;
    } else {
      color2.values[3] = value2;
    }
    return recomposeColor(color2);
  }
  function private_safeAlpha(color2, value2, warning2) {
    try {
      return alpha(color2, value2);
    } catch (error2) {
      if (warning2 && process.env.NODE_ENV !== "production") {
        console.warn(warning2);
      }
      return color2;
    }
  }
  function darken(color2, coefficient) {
    color2 = decomposeColor(color2);
    coefficient = clampWrapper(coefficient);
    if (color2.type.indexOf("hsl") !== -1) {
      color2.values[2] *= 1 - coefficient;
    } else if (color2.type.indexOf("rgb") !== -1 || color2.type.indexOf("color") !== -1) {
      for (let i = 0; i < 3; i += 1) {
        color2.values[i] *= 1 - coefficient;
      }
    }
    return recomposeColor(color2);
  }
  function private_safeDarken(color2, coefficient, warning2) {
    try {
      return darken(color2, coefficient);
    } catch (error2) {
      if (warning2 && process.env.NODE_ENV !== "production") {
        console.warn(warning2);
      }
      return color2;
    }
  }
  function lighten(color2, coefficient) {
    color2 = decomposeColor(color2);
    coefficient = clampWrapper(coefficient);
    if (color2.type.indexOf("hsl") !== -1) {
      color2.values[2] += (100 - color2.values[2]) * coefficient;
    } else if (color2.type.indexOf("rgb") !== -1) {
      for (let i = 0; i < 3; i += 1) {
        color2.values[i] += (255 - color2.values[i]) * coefficient;
      }
    } else if (color2.type.indexOf("color") !== -1) {
      for (let i = 0; i < 3; i += 1) {
        color2.values[i] += (1 - color2.values[i]) * coefficient;
      }
    }
    return recomposeColor(color2);
  }
  function private_safeLighten(color2, coefficient, warning2) {
    try {
      return lighten(color2, coefficient);
    } catch (error2) {
      if (warning2 && process.env.NODE_ENV !== "production") {
        console.warn(warning2);
      }
      return color2;
    }
  }
  function emphasize(color2, coefficient = 0.15) {
    return getLuminance(color2) > 0.5 ? darken(color2, coefficient) : lighten(color2, coefficient);
  }
  function private_safeEmphasize(color2, coefficient, warning2) {
    try {
      return emphasize(color2, coefficient);
    } catch (error2) {
      if (warning2 && process.env.NODE_ENV !== "production") {
        console.warn(warning2);
      }
      return color2;
    }
  }
  function blend(background, overlay2, opacity, gamma = 1) {
    const blendChannel = (b, o) => Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor2 = decomposeColor(background);
    const overlayColor = decomposeColor(overlay2);
    const rgb = [blendChannel(backgroundColor2.values[0], overlayColor.values[0]), blendChannel(backgroundColor2.values[1], overlayColor.values[1]), blendChannel(backgroundColor2.values[2], overlayColor.values[2])];
    return recomposeColor({
      type: "rgb",
      values: rgb
    });
  }
  return colorManipulator;
}
var colorManipulatorExports = /* @__PURE__ */ requireColorManipulator();
const _excluded$d = ["mode", "contrastThreshold", "tonalOffset"];
const light$1 = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common.white,
    default: common.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
const dark$1 = {
  text: {
    primary: common.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: common.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function addLightOrDark(intent, direction, shade, tonalOffset) {
  const tonalOffsetLight = tonalOffset.light || tonalOffset;
  const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === "light") {
      intent.light = colorManipulatorExports.lighten(intent.main, tonalOffsetLight);
    } else if (direction === "dark") {
      intent.dark = colorManipulatorExports.darken(intent.main, tonalOffsetDark);
    }
  }
}
function getDefaultPrimary(mode = "light") {
  if (mode === "dark") {
    return {
      main: blue[200],
      light: blue[50],
      dark: blue[400]
    };
  }
  return {
    main: blue[700],
    light: blue[400],
    dark: blue[800]
  };
}
function getDefaultSecondary(mode = "light") {
  if (mode === "dark") {
    return {
      main: purple[200],
      light: purple[50],
      dark: purple[400]
    };
  }
  return {
    main: purple[500],
    light: purple[300],
    dark: purple[700]
  };
}
function getDefaultError(mode = "light") {
  if (mode === "dark") {
    return {
      main: red[500],
      light: red[300],
      dark: red[700]
    };
  }
  return {
    main: red[700],
    light: red[400],
    dark: red[800]
  };
}
function getDefaultInfo(mode = "light") {
  if (mode === "dark") {
    return {
      main: lightBlue[400],
      light: lightBlue[300],
      dark: lightBlue[700]
    };
  }
  return {
    main: lightBlue[700],
    light: lightBlue[500],
    dark: lightBlue[900]
  };
}
function getDefaultSuccess(mode = "light") {
  if (mode === "dark") {
    return {
      main: green[400],
      light: green[300],
      dark: green[700]
    };
  }
  return {
    main: green[800],
    light: green[500],
    dark: green[900]
  };
}
function getDefaultWarning(mode = "light") {
  if (mode === "dark") {
    return {
      main: orange[400],
      light: orange[300],
      dark: orange[700]
    };
  }
  return {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: orange[500],
    dark: orange[900]
  };
}
function createPalette(palette) {
  const {
    mode = "light",
    contrastThreshold = 3,
    tonalOffset = 0.2
  } = palette, other = _objectWithoutPropertiesLoose(palette, _excluded$d);
  const primary2 = palette.primary || getDefaultPrimary(mode);
  const secondary2 = palette.secondary || getDefaultSecondary(mode);
  const error2 = palette.error || getDefaultError(mode);
  const info2 = palette.info || getDefaultInfo(mode);
  const success2 = palette.success || getDefaultSuccess(mode);
  const warning2 = palette.warning || getDefaultWarning(mode);
  function getContrastText(background) {
    const contrastText = colorManipulatorExports.getContrastRatio(background, dark$1.text.primary) >= contrastThreshold ? dark$1.text.primary : light$1.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const contrast = colorManipulatorExports.getContrastRatio(background, contrastText);
      if (contrast < 3) {
        console.error([`MUI: The contrast ratio of ${contrast}:1 for ${contrastText} on ${background}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join("\n"));
      }
    }
    return contrastText;
  }
  const augmentColor = ({
    color: color2,
    name: name2,
    mainShade = 500,
    lightShade = 300,
    darkShade = 700
  }) => {
    color2 = _extends$1({}, color2);
    if (!color2.main && color2[mainShade]) {
      color2.main = color2[mainShade];
    }
    if (!color2.hasOwnProperty("main")) {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${name2 ? ` (${name2})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${mainShade}\` property.` : formatMuiErrorMessage$1(11, name2 ? ` (${name2})` : "", mainShade));
    }
    if (typeof color2.main !== "string") {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${name2 ? ` (${name2})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(color2.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : formatMuiErrorMessage$1(12, name2 ? ` (${name2})` : "", JSON.stringify(color2.main)));
    }
    addLightOrDark(color2, "light", lightShade, tonalOffset);
    addLightOrDark(color2, "dark", darkShade, tonalOffset);
    if (!color2.contrastText) {
      color2.contrastText = getContrastText(color2.main);
    }
    return color2;
  };
  const modes = {
    dark: dark$1,
    light: light$1
  };
  if (process.env.NODE_ENV !== "production") {
    if (!modes[mode]) {
      console.error(`MUI: The palette mode \`${mode}\` is not supported.`);
    }
  }
  const paletteOutput = deepmerge$1(_extends$1({
    // A collection of common colors.
    common: _extends$1({}, common),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor({
      color: primary2,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor({
      color: secondary2,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor({
      color: error2,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor({
      color: warning2,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor({
      color: info2,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor({
      color: success2,
      name: "success"
    }),
    // The grey colors.
    grey,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText,
    // Generate a rich color object.
    augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset
  }, modes[mode]), other);
  return paletteOutput;
}
const _excluded$c = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function round(value2) {
  return Math.round(value2 * 1e5) / 1e5;
}
const caseAllCaps = {
  textTransform: "uppercase"
};
const defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function createTypography(palette, typography) {
  const _ref = typeof typography === "function" ? typography(palette) : typography, {
    fontFamily = defaultFontFamily,
    // The default font size of the Material Specification.
    fontSize = 14,
    // px
    fontWeightLight = 300,
    fontWeightRegular = 400,
    fontWeightMedium = 500,
    fontWeightBold = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16,
    // Apply the CSS properties to all the variants.
    allVariants,
    pxToRem: pxToRem2
  } = _ref, other = _objectWithoutPropertiesLoose(_ref, _excluded$c);
  if (process.env.NODE_ENV !== "production") {
    if (typeof fontSize !== "number") {
      console.error("MUI: `fontSize` is required to be a number.");
    }
    if (typeof htmlFontSize !== "number") {
      console.error("MUI: `htmlFontSize` is required to be a number.");
    }
  }
  const coef = fontSize / 14;
  const pxToRem = pxToRem2 || ((size) => `${size / htmlFontSize * coef}rem`);
  const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing) => _extends$1({
    fontFamily,
    fontWeight,
    fontSize: pxToRem(size),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight
  }, fontFamily === defaultFontFamily ? {
    letterSpacing: `${round(letterSpacing / size)}em`
  } : {}, casing, allVariants);
  const variants2 = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return deepmerge$1(_extends$1({
    htmlFontSize,
    pxToRem,
    fontFamily,
    fontSize,
    fontWeightLight,
    fontWeightRegular,
    fontWeightMedium,
    fontWeightBold
  }, variants2), other, {
    clone: false
    // No need to clone deep
  });
}
const shadowKeyUmbraOpacity = 0.2;
const shadowKeyPenumbraOpacity = 0.14;
const shadowAmbientShadowOpacity = 0.12;
function createShadow(...px) {
  return [`${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(",");
}
const shadows = ["none", createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
const _excluded$b = ["duration", "easing", "delay"];
const easing = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function formatMs(milliseconds) {
  return `${Math.round(milliseconds)}ms`;
}
function getAutoHeightDuration(height2) {
  if (!height2) {
    return 0;
  }
  const constant = height2 / 36;
  return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function createTransitions(inputTransitions) {
  const mergedEasing = _extends$1({}, easing, inputTransitions.easing);
  const mergedDuration = _extends$1({}, duration, inputTransitions.duration);
  const create = (props = ["all"], options = {}) => {
    const {
      duration: durationOption = mergedDuration.standard,
      easing: easingOption = mergedEasing.easeInOut,
      delay = 0
    } = options, other = _objectWithoutPropertiesLoose(options, _excluded$b);
    if (process.env.NODE_ENV !== "production") {
      const isString = (value2) => typeof value2 === "string";
      const isNumber = (value2) => !isNaN(parseFloat(value2));
      if (!isString(props) && !Array.isArray(props)) {
        console.error('MUI: Argument "props" must be a string or Array.');
      }
      if (!isNumber(durationOption) && !isString(durationOption)) {
        console.error(`MUI: Argument "duration" must be a number or a string but found ${durationOption}.`);
      }
      if (!isString(easingOption)) {
        console.error('MUI: Argument "easing" must be a string.');
      }
      if (!isNumber(delay) && !isString(delay)) {
        console.error('MUI: Argument "delay" must be a number or a string.');
      }
      if (typeof options !== "object") {
        console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join("\n"));
      }
      if (Object.keys(other).length !== 0) {
        console.error(`MUI: Unrecognized argument(s) [${Object.keys(other).join(",")}].`);
      }
    }
    return (Array.isArray(props) ? props : [props]).map((animatedProp) => `${animatedProp} ${typeof durationOption === "string" ? durationOption : formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : formatMs(delay)}`).join(",");
  };
  return _extends$1({
    getAutoHeightDuration,
    create
  }, inputTransitions, {
    easing: mergedEasing,
    duration: mergedDuration
  });
}
const zIndex = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
const _excluded$a = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function createTheme(options = {}, ...args) {
  const {
    mixins: mixinsInput = {},
    palette: paletteInput = {},
    transitions: transitionsInput = {},
    typography: typographyInput = {}
  } = options, other = _objectWithoutPropertiesLoose(options, _excluded$a);
  if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
  // `generateCssVars` is the closest identifier for checking that the `options` is a result of `extendTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
  options.generateCssVars === void 0) {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: \`vars\` is a private field used for CSS variables support.
Please use another name.` : formatMuiErrorMessage$1(18));
  }
  const palette = createPalette(paletteInput);
  const systemTheme = createTheme$2(options);
  let muiTheme = deepmerge$1(systemTheme, {
    mixins: createMixins(systemTheme.breakpoints, mixinsInput),
    palette,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: shadows.slice(),
    typography: createTypography(palette, typographyInput),
    transitions: createTransitions(transitionsInput),
    zIndex: _extends$1({}, zIndex)
  });
  muiTheme = deepmerge$1(muiTheme, other);
  muiTheme = args.reduce((acc, argument) => deepmerge$1(acc, argument), muiTheme);
  if (process.env.NODE_ENV !== "production") {
    const stateClasses = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"];
    const traverse = (node2, component) => {
      let key;
      for (key in node2) {
        const child = node2[key];
        if (stateClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const stateClass = generateUtilityClass("", key);
            console.error([`MUI: The \`${component}\` component increases the CSS specificity of the \`${key}\` internal state.`, "You can not override it like this: ", JSON.stringify(node2, null, 2), "", `Instead, you need to use the '&.${stateClass}' syntax:`, JSON.stringify({
              root: {
                [`&.${stateClass}`]: child
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join("\n"));
          }
          node2[key] = {};
        }
      }
    };
    Object.keys(muiTheme.components).forEach((component) => {
      const styleOverrides = muiTheme.components[component].styleOverrides;
      if (styleOverrides && component.indexOf("Mui") === 0) {
        traverse(styleOverrides, component);
      }
    });
  }
  muiTheme.unstable_sxConfig = _extends$1({}, defaultSxConfig, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return styleFunctionSx$1({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}
const defaultTheme = createTheme();
function useTheme() {
  const theme = useTheme$2(defaultTheme);
  if (process.env.NODE_ENV !== "production") {
    React.useDebugValue(theme);
  }
  return theme[THEME_ID] || theme;
}
var createStyled$1 = {};
var _extends = { exports: {} };
var hasRequired_extends;
function require_extends() {
  if (hasRequired_extends) return _extends.exports;
  hasRequired_extends = 1;
  (function(module) {
    function _extends2() {
      return module.exports = _extends2 = Object.assign ? Object.assign.bind() : function(n) {
        for (var e = 1; e < arguments.length; e++) {
          var t = arguments[e];
          for (var r2 in t) ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
        }
        return n;
      }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends2.apply(null, arguments);
    }
    module.exports = _extends2, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(_extends);
  return _extends.exports;
}
var objectWithoutPropertiesLoose = { exports: {} };
var hasRequiredObjectWithoutPropertiesLoose;
function requireObjectWithoutPropertiesLoose() {
  if (hasRequiredObjectWithoutPropertiesLoose) return objectWithoutPropertiesLoose.exports;
  hasRequiredObjectWithoutPropertiesLoose = 1;
  (function(module) {
    function _objectWithoutPropertiesLoose2(r2, e) {
      if (null == r2) return {};
      var t = {};
      for (var n in r2) if ({}.hasOwnProperty.call(r2, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r2[n];
      }
      return t;
    }
    module.exports = _objectWithoutPropertiesLoose2, module.exports.__esModule = true, module.exports["default"] = module.exports;
  })(objectWithoutPropertiesLoose);
  return objectWithoutPropertiesLoose.exports;
}
const require$$1 = /* @__PURE__ */ getAugmentedNamespace(styledEngine);
const require$$4 = /* @__PURE__ */ getAugmentedNamespace(deepmerge);
const require$$5 = /* @__PURE__ */ getAugmentedNamespace(capitalize);
const require$$6 = /* @__PURE__ */ getAugmentedNamespace(getDisplayName);
const require$$7 = /* @__PURE__ */ getAugmentedNamespace(createTheme$1);
const require$$8 = /* @__PURE__ */ getAugmentedNamespace(styleFunctionSx);
var hasRequiredCreateStyled;
function requireCreateStyled() {
  if (hasRequiredCreateStyled) return createStyled$1;
  hasRequiredCreateStyled = 1;
  var _interopRequireDefault = /* @__PURE__ */ requireInteropRequireDefault();
  Object.defineProperty(createStyled$1, "__esModule", {
    value: true
  });
  createStyled$1.default = createStyled3;
  createStyled$1.shouldForwardProp = shouldForwardProp;
  createStyled$1.systemDefaultTheme = void 0;
  var _extends2 = _interopRequireDefault(/* @__PURE__ */ require_extends());
  var _objectWithoutPropertiesLoose2 = _interopRequireDefault(/* @__PURE__ */ requireObjectWithoutPropertiesLoose());
  var _styledEngine = _interopRequireWildcard(require$$1);
  var _deepmerge = require$$4;
  var _capitalize = _interopRequireDefault(require$$5);
  var _getDisplayName = _interopRequireDefault(require$$6);
  var _createTheme = _interopRequireDefault(require$$7);
  var _styleFunctionSx = _interopRequireDefault(require$$8);
  const _excluded4 = ["ownerState"], _excluded22 = ["variants"], _excluded32 = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
  function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r2 = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap();
    return (_getRequireWildcardCache = function(e2) {
      return e2 ? t : r2;
    })(e);
  }
  function _interopRequireWildcard(e, r2) {
    if (e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return { default: e };
    var t = _getRequireWildcardCache(r2);
    if (t && t.has(e)) return t.get(e);
    var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
  }
  function isEmpty2(obj) {
    return Object.keys(obj).length === 0;
  }
  function isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
  }
  function shouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
  }
  const systemDefaultTheme2 = createStyled$1.systemDefaultTheme = (0, _createTheme.default)();
  const lowercaseFirstLetter = (string) => {
    if (!string) {
      return string;
    }
    return string.charAt(0).toLowerCase() + string.slice(1);
  };
  function resolveTheme({
    defaultTheme: defaultTheme2,
    theme,
    themeId
  }) {
    return isEmpty2(theme) ? defaultTheme2 : theme[themeId] || theme;
  }
  function defaultOverridesResolver(slot) {
    if (!slot) {
      return null;
    }
    return (props, styles2) => styles2[slot];
  }
  function processStyleArg(callableStyle, _ref) {
    let {
      ownerState
    } = _ref, props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded4);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, _extends2.default)({
      ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) {
      return resolvedStylesArg.flatMap((resolvedStyle) => processStyleArg(resolvedStyle, (0, _extends2.default)({
        ownerState
      }, props)));
    }
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
      const {
        variants: variants2 = []
      } = resolvedStylesArg, otherStyles = (0, _objectWithoutPropertiesLoose2.default)(resolvedStylesArg, _excluded22);
      let result = otherStyles;
      variants2.forEach((variant) => {
        let isMatch = true;
        if (typeof variant.props === "function") {
          isMatch = variant.props((0, _extends2.default)({
            ownerState
          }, props, ownerState));
        } else {
          Object.keys(variant.props).forEach((key) => {
            if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) {
              isMatch = false;
            }
          });
        }
        if (isMatch) {
          if (!Array.isArray(result)) {
            result = [result];
          }
          result.push(typeof variant.style === "function" ? variant.style((0, _extends2.default)({
            ownerState
          }, props, ownerState)) : variant.style);
        }
      });
      return result;
    }
    return resolvedStylesArg;
  }
  function createStyled3(input2 = {}) {
    const {
      themeId,
      defaultTheme: defaultTheme2 = systemDefaultTheme2,
      rootShouldForwardProp: rootShouldForwardProp2 = shouldForwardProp,
      slotShouldForwardProp: slotShouldForwardProp2 = shouldForwardProp
    } = input2;
    const systemSx = (props) => {
      return (0, _styleFunctionSx.default)((0, _extends2.default)({}, props, {
        theme: resolveTheme((0, _extends2.default)({}, props, {
          defaultTheme: defaultTheme2,
          themeId
        }))
      }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {}) => {
      (0, _styledEngine.internal_processStyles)(tag, (styles2) => styles2.filter((style2) => !(style2 != null && style2.__mui_systemSx)));
      const {
        name: componentName,
        slot: componentSlot,
        skipVariantsResolver: inputSkipVariantsResolver,
        skipSx: inputSkipSx,
        // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = defaultOverridesResolver(lowercaseFirstLetter(componentSlot))
      } = inputOptions, options = (0, _objectWithoutPropertiesLoose2.default)(inputOptions, _excluded32);
      const skipVariantsResolver = inputSkipVariantsResolver !== void 0 ? inputSkipVariantsResolver : (
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false
      );
      const skipSx = inputSkipSx || false;
      let label2;
      if (process.env.NODE_ENV !== "production") {
        if (componentName) {
          label2 = `${componentName}-${lowercaseFirstLetter(componentSlot || "Root")}`;
        }
      }
      let shouldForwardPropOption = shouldForwardProp;
      if (componentSlot === "Root" || componentSlot === "root") {
        shouldForwardPropOption = rootShouldForwardProp2;
      } else if (componentSlot) {
        shouldForwardPropOption = slotShouldForwardProp2;
      } else if (isStringTag(tag)) {
        shouldForwardPropOption = void 0;
      }
      const defaultStyledResolver = (0, _styledEngine.default)(tag, (0, _extends2.default)({
        shouldForwardProp: shouldForwardPropOption,
        label: label2
      }, options));
      const transformStyleArg = (stylesArg) => {
        if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, _deepmerge.isPlainObject)(stylesArg)) {
          return (props) => processStyleArg(stylesArg, (0, _extends2.default)({}, props, {
            theme: resolveTheme({
              theme: props.theme,
              defaultTheme: defaultTheme2,
              themeId
            })
          }));
        }
        return stylesArg;
      };
      const muiStyledResolver = (styleArg, ...expressions) => {
        let transformedStyleArg = transformStyleArg(styleArg);
        const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
        if (componentName && overridesResolver) {
          expressionsWithDefaultTheme.push((props) => {
            const theme = resolveTheme((0, _extends2.default)({}, props, {
              defaultTheme: defaultTheme2,
              themeId
            }));
            if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) {
              return null;
            }
            const styleOverrides = theme.components[componentName].styleOverrides;
            const resolvedStyleOverrides = {};
            Object.entries(styleOverrides).forEach(([slotKey, slotStyle]) => {
              resolvedStyleOverrides[slotKey] = processStyleArg(slotStyle, (0, _extends2.default)({}, props, {
                theme
              }));
            });
            return overridesResolver(props, resolvedStyleOverrides);
          });
        }
        if (componentName && !skipVariantsResolver) {
          expressionsWithDefaultTheme.push((props) => {
            var _theme$components;
            const theme = resolveTheme((0, _extends2.default)({}, props, {
              defaultTheme: defaultTheme2,
              themeId
            }));
            const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
            return processStyleArg({
              variants: themeVariants
            }, (0, _extends2.default)({}, props, {
              theme
            }));
          });
        }
        if (!skipSx) {
          expressionsWithDefaultTheme.push(systemSx);
        }
        const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
        if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
          const placeholders = new Array(numOfCustomFnsApplied).fill("");
          transformedStyleArg = [...styleArg, ...placeholders];
          transformedStyleArg.raw = [...styleArg.raw, ...placeholders];
        }
        const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
        if (process.env.NODE_ENV !== "production") {
          let displayName;
          if (componentName) {
            displayName = `${componentName}${(0, _capitalize.default)(componentSlot || "")}`;
          }
          if (displayName === void 0) {
            displayName = `Styled(${(0, _getDisplayName.default)(tag)})`;
          }
          Component.displayName = displayName;
        }
        if (tag.muiName) {
          Component.muiName = tag.muiName;
        }
        return Component;
      };
      if (defaultStyledResolver.withConfig) {
        muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
      }
      return muiStyledResolver;
    };
  }
  return createStyled$1;
}
var createStyledExports = /* @__PURE__ */ requireCreateStyled();
const createStyled2 = /* @__PURE__ */ getDefaultExportFromCjs(createStyledExports);
function slotShouldForwardProp(prop) {
  return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const rootShouldForwardProp = (prop) => slotShouldForwardProp(prop) && prop !== "classes";
const styled = createStyled2({
  themeId: THEME_ID,
  defaultTheme,
  rootShouldForwardProp
});
const _excluded$9 = ["theme"];
function ThemeProvider$1(_ref) {
  let {
    theme: themeInput
  } = _ref, props = _objectWithoutPropertiesLoose(_ref, _excluded$9);
  const scopedTheme = themeInput[THEME_ID];
  let finalTheme = scopedTheme || themeInput;
  if (typeof themeInput !== "function") {
    if (scopedTheme && !scopedTheme.vars) {
      finalTheme = _extends$1({}, scopedTheme, {
        vars: null
      });
    } else if (themeInput && !themeInput.vars) {
      finalTheme = _extends$1({}, themeInput, {
        vars: null
      });
    }
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider$2, _extends$1({}, props, {
    themeId: scopedTheme ? THEME_ID : void 0,
    theme: finalTheme
  }));
}
process.env.NODE_ENV !== "production" ? ThemeProvider$1.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
} : void 0;
const getOverlayAlpha = (elevation) => {
  let alphaValue;
  if (elevation < 1) {
    alphaValue = 5.11916 * elevation ** 2;
  } else {
    alphaValue = 4.5 * Math.log(elevation + 1) + 2;
  }
  return (alphaValue / 100).toFixed(2);
};
function r(e) {
  var t, f, n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;
  else if ("object" == typeof e) if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
  } else for (f in e) e[f] && (n && (n += " "), n += f);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = "", o = arguments.length; f < o; f++) (e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
process.env.NODE_ENV !== "production" ? {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  value: PropTypes.object.isRequired
} : void 0;
function useDefaultProps(params) {
  return useDefaultProps$1(params);
}
var reactIs = { exports: {} };
var reactIs_production = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production;
function requireReactIs_production() {
  if (hasRequiredReactIs_production) return reactIs_production;
  hasRequiredReactIs_production = 1;
  var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler");
  var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
  function typeOf(object) {
    if ("object" === typeof object && null !== object) {
      var $$typeof = object.$$typeof;
      switch ($$typeof) {
        case REACT_ELEMENT_TYPE:
          switch (object = object.type, object) {
            case REACT_FRAGMENT_TYPE:
            case REACT_PROFILER_TYPE:
            case REACT_STRICT_MODE_TYPE:
            case REACT_SUSPENSE_TYPE:
            case REACT_SUSPENSE_LIST_TYPE:
            case REACT_VIEW_TRANSITION_TYPE:
              return object;
            default:
              switch (object = object && object.$$typeof, object) {
                case REACT_CONTEXT_TYPE:
                case REACT_FORWARD_REF_TYPE:
                case REACT_LAZY_TYPE:
                case REACT_MEMO_TYPE:
                  return object;
                case REACT_CONSUMER_TYPE:
                  return object;
                default:
                  return $$typeof;
              }
          }
        case REACT_PORTAL_TYPE:
          return $$typeof;
      }
    }
  }
  reactIs_production.ContextConsumer = REACT_CONSUMER_TYPE;
  reactIs_production.ContextProvider = REACT_CONTEXT_TYPE;
  reactIs_production.Element = REACT_ELEMENT_TYPE;
  reactIs_production.ForwardRef = REACT_FORWARD_REF_TYPE;
  reactIs_production.Fragment = REACT_FRAGMENT_TYPE;
  reactIs_production.Lazy = REACT_LAZY_TYPE;
  reactIs_production.Memo = REACT_MEMO_TYPE;
  reactIs_production.Portal = REACT_PORTAL_TYPE;
  reactIs_production.Profiler = REACT_PROFILER_TYPE;
  reactIs_production.StrictMode = REACT_STRICT_MODE_TYPE;
  reactIs_production.Suspense = REACT_SUSPENSE_TYPE;
  reactIs_production.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
  reactIs_production.isContextConsumer = function(object) {
    return typeOf(object) === REACT_CONSUMER_TYPE;
  };
  reactIs_production.isContextProvider = function(object) {
    return typeOf(object) === REACT_CONTEXT_TYPE;
  };
  reactIs_production.isElement = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
  };
  reactIs_production.isForwardRef = function(object) {
    return typeOf(object) === REACT_FORWARD_REF_TYPE;
  };
  reactIs_production.isFragment = function(object) {
    return typeOf(object) === REACT_FRAGMENT_TYPE;
  };
  reactIs_production.isLazy = function(object) {
    return typeOf(object) === REACT_LAZY_TYPE;
  };
  reactIs_production.isMemo = function(object) {
    return typeOf(object) === REACT_MEMO_TYPE;
  };
  reactIs_production.isPortal = function(object) {
    return typeOf(object) === REACT_PORTAL_TYPE;
  };
  reactIs_production.isProfiler = function(object) {
    return typeOf(object) === REACT_PROFILER_TYPE;
  };
  reactIs_production.isStrictMode = function(object) {
    return typeOf(object) === REACT_STRICT_MODE_TYPE;
  };
  reactIs_production.isSuspense = function(object) {
    return typeOf(object) === REACT_SUSPENSE_TYPE;
  };
  reactIs_production.isSuspenseList = function(object) {
    return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
  };
  reactIs_production.isValidElementType = function(type) {
    return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? true : false;
  };
  reactIs_production.typeOf = typeOf;
  return reactIs_production;
}
var reactIs_development = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  "production" !== process.env.NODE_ENV && function() {
    function typeOf(object) {
      if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            switch (object = object.type, object) {
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
              case REACT_SUSPENSE_LIST_TYPE:
              case REACT_VIEW_TRANSITION_TYPE:
                return object;
              default:
                switch (object = object && object.$$typeof, object) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                    return object;
                  case REACT_CONSUMER_TYPE:
                    return object;
                  default:
                    return $$typeof;
                }
            }
          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }
    }
    var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
    reactIs_development.ContextConsumer = REACT_CONSUMER_TYPE;
    reactIs_development.ContextProvider = REACT_CONTEXT_TYPE;
    reactIs_development.Element = REACT_ELEMENT_TYPE;
    reactIs_development.ForwardRef = REACT_FORWARD_REF_TYPE;
    reactIs_development.Fragment = REACT_FRAGMENT_TYPE;
    reactIs_development.Lazy = REACT_LAZY_TYPE;
    reactIs_development.Memo = REACT_MEMO_TYPE;
    reactIs_development.Portal = REACT_PORTAL_TYPE;
    reactIs_development.Profiler = REACT_PROFILER_TYPE;
    reactIs_development.StrictMode = REACT_STRICT_MODE_TYPE;
    reactIs_development.Suspense = REACT_SUSPENSE_TYPE;
    reactIs_development.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
    reactIs_development.isContextConsumer = function(object) {
      return typeOf(object) === REACT_CONSUMER_TYPE;
    };
    reactIs_development.isContextProvider = function(object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    };
    reactIs_development.isElement = function(object) {
      return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
    };
    reactIs_development.isForwardRef = function(object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    };
    reactIs_development.isFragment = function(object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    };
    reactIs_development.isLazy = function(object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    };
    reactIs_development.isMemo = function(object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    };
    reactIs_development.isPortal = function(object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    };
    reactIs_development.isProfiler = function(object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    };
    reactIs_development.isStrictMode = function(object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    };
    reactIs_development.isSuspense = function(object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    };
    reactIs_development.isSuspenseList = function(object) {
      return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    };
    reactIs_development.isValidElementType = function(type) {
      return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? true : false;
    };
    reactIs_development.typeOf = typeOf;
  }();
  return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs.exports = /* @__PURE__ */ requireReactIs_production();
  } else {
    reactIs.exports = /* @__PURE__ */ requireReactIs_development();
  }
  return reactIs.exports;
}
var reactIsExports = /* @__PURE__ */ requireReactIs();
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
const config = {
  disabled: false
};
var timeoutsShape = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;
const TransitionGroupContext = React__default.createContext(null);
var forceReflow = function forceReflow2(node2) {
  return node2.scrollTop;
};
var UNMOUNTED = "unmounted";
var EXITED = "exited";
var ENTERING = "entering";
var ENTERED = "entered";
var EXITING = "exiting";
var Transition = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(Transition2, _React$Component);
  function Transition2(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context;
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;
    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }
    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }
  Transition2.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;
    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }
    return null;
  };
  var _proto = Transition2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;
      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };
  _proto.getTimeouts = function getTimeouts() {
    var timeout2 = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout2;
    if (timeout2 != null && typeof timeout2 !== "number") {
      exit = timeout2.exit;
      enter = timeout2.enter;
      appear = timeout2.appear !== void 0 ? timeout2.appear : enter;
    }
    return {
      exit,
      enter,
      appear
    };
  };
  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }
    if (nextStatus !== null) {
      this.cancelNextCallback();
      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node2 = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
          if (node2) forceReflow(node2);
        }
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };
  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;
    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter;
    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function() {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }
    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function() {
      _this2.props.onEntering(maybeNode, maybeAppearing);
      _this2.onTransitionEnd(enterTimeout, function() {
        _this2.safeSetState({
          status: ENTERED
        }, function() {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };
  _proto.performExit = function performExit() {
    var _this3 = this;
    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? void 0 : ReactDOM.findDOMNode(this);
    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function() {
        _this3.props.onExited(maybeNode);
      });
      return;
    }
    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function() {
      _this3.props.onExiting(maybeNode);
      _this3.onTransitionEnd(timeouts.exit, function() {
        _this3.safeSetState({
          status: EXITED
        }, function() {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };
  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };
  _proto.safeSetState = function safeSetState(nextState, callback) {
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };
  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;
    var active2 = true;
    this.nextCallback = function(event) {
      if (active2) {
        active2 = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };
    this.nextCallback.cancel = function() {
      active2 = false;
    };
    return this.nextCallback;
  };
  _proto.onTransitionEnd = function onTransitionEnd(timeout2, handler) {
    this.setNextCallback(handler);
    var node2 = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout2 == null && !this.props.addEndListener;
    if (!node2 || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node2, this.nextCallback], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
      this.props.addEndListener(maybeNode, maybeNextCallback);
    }
    if (timeout2 != null) {
      setTimeout(this.nextCallback, timeout2);
    }
  };
  _proto.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }
    var _this$props = this.props, children = _this$props.children;
    _this$props.in;
    _this$props.mountOnEnter;
    _this$props.unmountOnExit;
    _this$props.appear;
    _this$props.enter;
    _this$props.exit;
    _this$props.timeout;
    _this$props.addEndListener;
    _this$props.onEnter;
    _this$props.onEntering;
    _this$props.onEntered;
    _this$props.onExit;
    _this$props.onExiting;
    _this$props.onExited;
    _this$props.nodeRef;
    var childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === "function" ? children(status, childProps) : React__default.cloneElement(React__default.Children.only(children), childProps))
    );
  };
  return Transition2;
}(React__default.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === "undefined" ? PropTypes.any : function(propValue, key, componentName, location, propFullName, secret) {
      var value2 = propValue[key];
      return PropTypes.instanceOf(value2 && "ownerDocument" in value2 ? value2.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return pt.apply(void 0, [props].concat(args));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};
function noop() {
}
Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function getChildMapping(children, mapFn) {
  var mapper = function mapper2(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };
  var result = /* @__PURE__ */ Object.create(null);
  if (children) Children.map(children, function(c) {
    return c;
  }).forEach(function(child) {
    result[child.key] = mapper(child);
  });
  return result;
}
function mergeChildMappings(prev2, next2) {
  prev2 = prev2 || {};
  next2 = next2 || {};
  function getValueForKey(key) {
    return key in next2 ? next2[key] : prev2[key];
  }
  var nextKeysPending = /* @__PURE__ */ Object.create(null);
  var pendingKeys = [];
  for (var prevKey in prev2) {
    if (prevKey in next2) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }
  var i;
  var childMapping = {};
  for (var nextKey in next2) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }
  return childMapping;
}
function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function(child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, "appear", props),
      enter: getProp(child, "enter", props),
      exit: getProp(child, "exit", props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function(key) {
    var child = children[key];
    if (!isValidElement(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in;
    if (hasNext && (!hasPrev || isLeaving)) {
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, "exit", nextProps),
        enter: getProp(child, "enter", nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      children[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, "exit", nextProps),
        enter: getProp(child, "enter", nextProps)
      });
    }
  });
  return children;
}
var values = Object.values || function(obj) {
  return Object.keys(obj).map(function(k) {
    return obj[k];
  });
};
var defaultProps = {
  component: "div",
  childFactory: function childFactory(child) {
    return child;
  }
};
var TransitionGroup = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(TransitionGroup2, _React$Component);
  function TransitionGroup2(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this));
    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited,
      firstRender: true
    };
    return _this;
  }
  var _proto = TransitionGroup2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };
  TransitionGroup2.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };
  _proto.handleExited = function handleExited(child, node2) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;
    if (child.props.onExited) {
      child.props.onExited(node2);
    }
    if (this.mounted) {
      this.setState(function(state) {
        var children = _extends$1({}, state.children);
        delete children[child.key];
        return {
          children
        };
      });
    }
  };
  _proto.render = function render() {
    var _this$props = this.props, Component = _this$props.component, childFactory2 = _this$props.childFactory, props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory2);
    delete props.appear;
    delete props.enter;
    delete props.exit;
    if (Component === null) {
      return /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }
    return /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /* @__PURE__ */ React__default.createElement(Component, props, children));
  };
  return TransitionGroup2;
}(React__default.Component);
TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps;
function getTransitionProps(props, options) {
  var _style$transitionDura, _style$transitionTimi;
  const {
    timeout: timeout2,
    easing: easing2,
    style: style2 = {}
  } = props;
  return {
    duration: (_style$transitionDura = style2.transitionDuration) != null ? _style$transitionDura : typeof timeout2 === "number" ? timeout2 : timeout2[options.mode] || 0,
    easing: (_style$transitionTimi = style2.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing2 === "object" ? easing2[options.mode] : easing2,
    delay: style2.transitionDelay
  };
}
function getCollapseUtilityClass(slot) {
  return generateUtilityClass("MuiCollapse", slot);
}
generateUtilityClasses("MuiCollapse", ["root", "horizontal", "vertical", "entered", "hidden", "wrapper", "wrapperInner"]);
const _excluded$8 = ["addEndListener", "children", "className", "collapsedSize", "component", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "orientation", "style", "timeout", "TransitionComponent"];
const useUtilityClasses$6 = (ownerState) => {
  const {
    orientation,
    classes
  } = ownerState;
  const slots = {
    root: ["root", `${orientation}`],
    entered: ["entered"],
    hidden: ["hidden"],
    wrapper: ["wrapper", `${orientation}`],
    wrapperInner: ["wrapperInner", `${orientation}`]
  };
  return composeClasses(slots, getCollapseUtilityClass, classes);
};
const CollapseRoot = styled("div", {
  name: "MuiCollapse",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, styles2[ownerState.orientation], ownerState.state === "entered" && styles2.entered, ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && styles2.hidden];
  }
})(({
  theme,
  ownerState
}) => _extends$1({
  height: 0,
  overflow: "hidden",
  transition: theme.transitions.create("height")
}, ownerState.orientation === "horizontal" && {
  height: "auto",
  width: 0,
  transition: theme.transitions.create("width")
}, ownerState.state === "entered" && _extends$1({
  height: "auto",
  overflow: "visible"
}, ownerState.orientation === "horizontal" && {
  width: "auto"
}), ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && {
  visibility: "hidden"
}));
const CollapseWrapper = styled("div", {
  name: "MuiCollapse",
  slot: "Wrapper",
  overridesResolver: (props, styles2) => styles2.wrapper
})(({
  ownerState
}) => _extends$1({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: "flex",
  width: "100%"
}, ownerState.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
}));
const CollapseWrapperInner = styled("div", {
  name: "MuiCollapse",
  slot: "WrapperInner",
  overridesResolver: (props, styles2) => styles2.wrapperInner
})(({
  ownerState
}) => _extends$1({
  width: "100%"
}, ownerState.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
}));
const Collapse = /* @__PURE__ */ React.forwardRef(function Collapse2(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiCollapse"
  });
  const {
    addEndListener,
    children,
    className,
    collapsedSize: collapsedSizeProp = "0px",
    component,
    easing: easing2,
    in: inProp,
    onEnter,
    onEntered,
    onEntering,
    onExit,
    onExited,
    onExiting,
    orientation = "vertical",
    style: style2,
    timeout: timeout2 = duration.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent = Transition
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$8);
  const ownerState = _extends$1({}, props, {
    orientation,
    collapsedSize: collapsedSizeProp
  });
  const classes = useUtilityClasses$6(ownerState);
  const theme = useTheme();
  const timer = useTimeout();
  const wrapperRef = React.useRef(null);
  const autoTransitionDuration = React.useRef();
  const collapsedSize = typeof collapsedSizeProp === "number" ? `${collapsedSizeProp}px` : collapsedSizeProp;
  const isHorizontal = orientation === "horizontal";
  const size = isHorizontal ? "width" : "height";
  const nodeRef = React.useRef(null);
  const handleRef = useForkRef(ref, nodeRef);
  const normalizedTransitionCallback = (callback) => (maybeIsAppearing) => {
    if (callback) {
      const node2 = nodeRef.current;
      if (maybeIsAppearing === void 0) {
        callback(node2);
      } else {
        callback(node2, maybeIsAppearing);
      }
    }
  };
  const getWrapperSize = () => wrapperRef.current ? wrapperRef.current[isHorizontal ? "clientWidth" : "clientHeight"] : 0;
  const handleEnter = normalizedTransitionCallback((node2, isAppearing) => {
    if (wrapperRef.current && isHorizontal) {
      wrapperRef.current.style.position = "absolute";
    }
    node2.style[size] = collapsedSize;
    if (onEnter) {
      onEnter(node2, isAppearing);
    }
  });
  const handleEntering = normalizedTransitionCallback((node2, isAppearing) => {
    const wrapperSize = getWrapperSize();
    if (wrapperRef.current && isHorizontal) {
      wrapperRef.current.style.position = "";
    }
    const {
      duration: transitionDuration,
      easing: transitionTimingFunction
    } = getTransitionProps({
      style: style2,
      timeout: timeout2,
      easing: easing2
    }, {
      mode: "enter"
    });
    if (timeout2 === "auto") {
      const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
      node2.style.transitionDuration = `${duration2}ms`;
      autoTransitionDuration.current = duration2;
    } else {
      node2.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
    }
    node2.style[size] = `${wrapperSize}px`;
    node2.style.transitionTimingFunction = transitionTimingFunction;
    if (onEntering) {
      onEntering(node2, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback((node2, isAppearing) => {
    node2.style[size] = "auto";
    if (onEntered) {
      onEntered(node2, isAppearing);
    }
  });
  const handleExit = normalizedTransitionCallback((node2) => {
    node2.style[size] = `${getWrapperSize()}px`;
    if (onExit) {
      onExit(node2);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);
  const handleExiting = normalizedTransitionCallback((node2) => {
    const wrapperSize = getWrapperSize();
    const {
      duration: transitionDuration,
      easing: transitionTimingFunction
    } = getTransitionProps({
      style: style2,
      timeout: timeout2,
      easing: easing2
    }, {
      mode: "exit"
    });
    if (timeout2 === "auto") {
      const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
      node2.style.transitionDuration = `${duration2}ms`;
      autoTransitionDuration.current = duration2;
    } else {
      node2.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
    }
    node2.style[size] = collapsedSize;
    node2.style.transitionTimingFunction = transitionTimingFunction;
    if (onExiting) {
      onExiting(node2);
    }
  });
  const handleAddEndListener = (next2) => {
    if (timeout2 === "auto") {
      timer.start(autoTransitionDuration.current || 0, next2);
    }
    if (addEndListener) {
      addEndListener(nodeRef.current, next2);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionComponent, _extends$1({
    in: inProp,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    nodeRef,
    timeout: timeout2 === "auto" ? null : timeout2
  }, other, {
    children: (state, childProps) => /* @__PURE__ */ jsxRuntimeExports.jsx(CollapseRoot, _extends$1({
      as: component,
      className: clsx(classes.root, className, {
        "entered": classes.entered,
        "exited": !inProp && collapsedSize === "0px" && classes.hidden
      }[state]),
      style: _extends$1({
        [isHorizontal ? "minWidth" : "minHeight"]: collapsedSize
      }, style2),
      ref: handleRef
    }, childProps, {
      // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
      // that might have been forwarded from the Transition component.
      ownerState: _extends$1({}, ownerState, {
        state
      }),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(CollapseWrapper, {
        ownerState: _extends$1({}, ownerState, {
          state
        }),
        className: classes.wrapper,
        ref: wrapperRef,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(CollapseWrapperInner, {
          ownerState: _extends$1({}, ownerState, {
            state
          }),
          className: classes.wrapperInner,
          children
        })
      })
    }))
  }));
});
process.env.NODE_ENV !== "production" ? Collapse.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * The content node to be collapsed.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */
  collapsedSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * The transition orientation.
   * @default 'vertical'
   */
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
Collapse.muiSupportAuto = true;
function getPaperUtilityClass(slot) {
  return generateUtilityClass("MuiPaper", slot);
}
generateUtilityClasses("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const _excluded$7 = ["className", "component", "elevation", "square", "variant"];
const useUtilityClasses$5 = (ownerState) => {
  const {
    square: square2,
    elevation,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ["root", variant, !square2 && "rounded", variant === "elevation" && `elevation${elevation}`]
  };
  return composeClasses(slots, getPaperUtilityClass, classes);
};
const PaperRoot = styled("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, styles2[ownerState.variant], !ownerState.square && styles2.rounded, ownerState.variant === "elevation" && styles2[`elevation${ownerState.elevation}`]];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$vars$overlays;
  return _extends$1({
    backgroundColor: (theme.vars || theme).palette.background.paper,
    color: (theme.vars || theme).palette.text.primary,
    transition: theme.transitions.create("box-shadow")
  }, !ownerState.square && {
    borderRadius: theme.shape.borderRadius
  }, ownerState.variant === "outlined" && {
    border: `1px solid ${(theme.vars || theme).palette.divider}`
  }, ownerState.variant === "elevation" && _extends$1({
    boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
  }, !theme.vars && theme.palette.mode === "dark" && {
    backgroundImage: `linear-gradient(${colorManipulatorExports.alpha("#fff", getOverlayAlpha(ownerState.elevation))}, ${colorManipulatorExports.alpha("#fff", getOverlayAlpha(ownerState.elevation))})`
  }, theme.vars && {
    backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
  }));
});
const Paper = /* @__PURE__ */ React.forwardRef(function Paper2(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiPaper"
  });
  const {
    className,
    component = "div",
    elevation = 1,
    square: square2 = false,
    variant = "elevation"
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$7);
  const ownerState = _extends$1({}, props, {
    component,
    elevation,
    square: square2,
    variant
  });
  const classes = useUtilityClasses$5(ownerState);
  if (process.env.NODE_ENV !== "production") {
    const theme = useTheme();
    if (theme.shadows[elevation] === void 0) {
      console.error([`MUI: The elevation provided <Paper elevation={${elevation}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${elevation}]\` is defined.`].join("\n"));
    }
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PaperRoot, _extends$1({
    as: component,
    ownerState,
    className: clsx(classes.root, className),
    ref
  }, other));
});
process.env.NODE_ENV !== "production" ? Paper.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: chainPropTypes(integerPropType, (props) => {
    const {
      elevation,
      variant
    } = props;
    if (elevation > 0 && variant === "outlined") {
      return new Error(`MUI: Combining \`elevation={${elevation}}\` with \`variant="${variant}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`);
    }
    return null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["elevation", "outlined"]), PropTypes.string])
} : void 0;
const AccordionContext = /* @__PURE__ */ React.createContext({});
if (process.env.NODE_ENV !== "production") {
  AccordionContext.displayName = "AccordionContext";
}
const _excluded$6 = ["className", "elementType", "ownerState", "externalForwardedProps", "getSlotOwnerState", "internalForwardedProps"], _excluded2 = ["component", "slots", "slotProps"], _excluded3 = ["component"];
function useSlot(name2, parameters) {
  const {
    className,
    elementType: initialElementType,
    ownerState,
    externalForwardedProps,
    getSlotOwnerState,
    internalForwardedProps
  } = parameters, useSlotPropsParams = _objectWithoutPropertiesLoose(parameters, _excluded$6);
  const {
    component: rootComponent,
    slots = {
      [name2]: void 0
    },
    slotProps = {
      [name2]: void 0
    }
  } = externalForwardedProps;
  _objectWithoutPropertiesLoose(externalForwardedProps, _excluded2);
  const elementType = slots[name2] || initialElementType;
  const resolvedComponentsProps = resolveComponentProps(slotProps[name2], ownerState);
  const _mergeSlotProps = mergeSlotProps(_extends$1({
    className
  }, useSlotPropsParams, {
    externalForwardedProps: void 0,
    externalSlotProps: resolvedComponentsProps
  })), {
    props: {
      component: slotComponent
    },
    internalRef
  } = _mergeSlotProps, mergedProps = _objectWithoutPropertiesLoose(_mergeSlotProps.props, _excluded3);
  const ref = useForkRef(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
  const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
  const finalOwnerState = _extends$1({}, ownerState, slotOwnerState);
  const LeafComponent = slotComponent;
  const props = appendOwnerState(elementType, _extends$1({}, name2 === "root", !slots[name2] && internalForwardedProps, mergedProps, LeafComponent && {
    as: LeafComponent
  }, {
    ref
  }), finalOwnerState);
  Object.keys(slotOwnerState).forEach((propName) => {
    delete props[propName];
  });
  return [elementType, props];
}
function getAccordionUtilityClass(slot) {
  return generateUtilityClass("MuiAccordion", slot);
}
const accordionClasses = generateUtilityClasses("MuiAccordion", ["root", "rounded", "expanded", "disabled", "gutters", "region"]);
const _excluded$5 = ["children", "className", "defaultExpanded", "disabled", "disableGutters", "expanded", "onChange", "square", "slots", "slotProps", "TransitionComponent", "TransitionProps"];
const useUtilityClasses$4 = (ownerState) => {
  const {
    classes,
    square: square2,
    expanded,
    disabled: disabled2,
    disableGutters
  } = ownerState;
  const slots = {
    root: ["root", !square2 && "rounded", expanded && "expanded", disabled2 && "disabled", !disableGutters && "gutters"],
    region: ["region"]
  };
  return composeClasses(slots, getAccordionUtilityClass, classes);
};
const AccordionRoot = styled(Paper, {
  name: "MuiAccordion",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${accordionClasses.region}`]: styles2.region
    }, styles2.root, !ownerState.square && styles2.rounded, !ownerState.disableGutters && styles2.gutters];
  }
})(({
  theme
}) => {
  const transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    position: "relative",
    transition: theme.transitions.create(["margin"], transition),
    overflowAnchor: "none",
    // Keep the same scrolling position
    "&::before": {
      position: "absolute",
      left: 0,
      top: -1,
      right: 0,
      height: 1,
      content: '""',
      opacity: 1,
      backgroundColor: (theme.vars || theme).palette.divider,
      transition: theme.transitions.create(["opacity", "background-color"], transition)
    },
    "&:first-of-type": {
      "&::before": {
        display: "none"
      }
    },
    [`&.${accordionClasses.expanded}`]: {
      "&::before": {
        opacity: 0
      },
      "&:first-of-type": {
        marginTop: 0
      },
      "&:last-of-type": {
        marginBottom: 0
      },
      "& + &": {
        "&::before": {
          display: "none"
        }
      }
    },
    [`&.${accordionClasses.disabled}`]: {
      backgroundColor: (theme.vars || theme).palette.action.disabledBackground
    }
  };
}, ({
  theme
}) => ({
  variants: [{
    props: (props) => !props.square,
    style: {
      borderRadius: 0,
      "&:first-of-type": {
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius
      },
      "&:last-of-type": {
        borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
        // Fix a rendering issue on Edge
        "@supports (-ms-ime-align: auto)": {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    }
  }, {
    props: (props) => !props.disableGutters,
    style: {
      [`&.${accordionClasses.expanded}`]: {
        margin: "16px 0"
      }
    }
  }]
}));
const Accordion$2 = /* @__PURE__ */ React.forwardRef(function Accordion(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiAccordion"
  });
  const {
    children: childrenProp,
    className,
    defaultExpanded = false,
    disabled: disabled2 = false,
    disableGutters = false,
    expanded: expandedProp,
    onChange,
    square: square2 = false,
    slots = {},
    slotProps = {},
    TransitionComponent: TransitionComponentProp,
    TransitionProps: TransitionPropsProp
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$5);
  const [expanded, setExpandedState] = useControlled({
    controlled: expandedProp,
    default: defaultExpanded,
    name: "Accordion",
    state: "expanded"
  });
  const handleChange = React.useCallback((event) => {
    setExpandedState(!expanded);
    if (onChange) {
      onChange(event, !expanded);
    }
  }, [expanded, onChange, setExpandedState]);
  const [summary, ...children] = React.Children.toArray(childrenProp);
  const contextValue = React.useMemo(() => ({
    expanded,
    disabled: disabled2,
    disableGutters,
    toggle: handleChange
  }), [expanded, disabled2, disableGutters, handleChange]);
  const ownerState = _extends$1({}, props, {
    square: square2,
    disabled: disabled2,
    disableGutters,
    expanded
  });
  const classes = useUtilityClasses$4(ownerState);
  const backwardCompatibleSlots = _extends$1({
    transition: TransitionComponentProp
  }, slots);
  const backwardCompatibleSlotProps = _extends$1({
    transition: TransitionPropsProp
  }, slotProps);
  const [TransitionSlot, transitionProps] = useSlot("transition", {
    elementType: Collapse,
    externalForwardedProps: {
      slots: backwardCompatibleSlots,
      slotProps: backwardCompatibleSlotProps
    },
    ownerState
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(AccordionRoot, _extends$1({
    className: clsx(classes.root, className),
    ref,
    ownerState,
    square: square2
  }, other, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(AccordionContext.Provider, {
      value: contextValue,
      children: summary
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionSlot, _extends$1({
      in: expanded,
      timeout: "auto"
    }, transitionProps, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
        "aria-labelledby": summary.props.id,
        id: summary.props["aria-controls"],
        role: "region",
        className: classes.region,
        children
      })
    }))]
  }));
});
process.env.NODE_ENV !== "production" ? Accordion$2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: chainPropTypes(PropTypes.node.isRequired, (props) => {
    const summary = React.Children.toArray(props.children)[0];
    if (reactIsExports.isFragment(summary)) {
      return new Error("MUI: The Accordion doesn't accept a Fragment as a child. Consider providing an array instead.");
    }
    if (!/* @__PURE__ */ React.isValidElement(summary)) {
      return new Error("MUI: Expected the first child of Accordion to be a valid element.");
    }
    return null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, expands the accordion by default.
   * @default false
   */
  defaultExpanded: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, it removes the margin between two expanded accordion items and the increase of height.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, expands the accordion, otherwise collapse it.
   * Setting this prop enables control over the accordion.
   */
  expanded: PropTypes.bool,
  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {boolean} expanded The `expanded` state of the accordion.
   */
  onChange: PropTypes.func,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    transition: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    transition: PropTypes.elementType
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */
  TransitionProps: PropTypes.object
} : void 0;
function getAccordionDetailsUtilityClass(slot) {
  return generateUtilityClass("MuiAccordionDetails", slot);
}
generateUtilityClasses("MuiAccordionDetails", ["root"]);
const _excluded$4 = ["className"];
const useUtilityClasses$3 = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["root"]
  };
  return composeClasses(slots, getAccordionDetailsUtilityClass, classes);
};
const AccordionDetailsRoot = styled("div", {
  name: "MuiAccordionDetails",
  slot: "Root",
  overridesResolver: (props, styles2) => styles2.root
})(({
  theme
}) => ({
  padding: theme.spacing(1, 2, 2)
}));
const AccordionDetails = /* @__PURE__ */ React.forwardRef(function AccordionDetails2(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiAccordionDetails"
  });
  const {
    className
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$4);
  const ownerState = props;
  const classes = useUtilityClasses$3(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AccordionDetailsRoot, _extends$1({
    className: clsx(classes.root, className),
    ref,
    ownerState
  }, other));
});
process.env.NODE_ENV !== "production" ? AccordionDetails.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
function Ripple(props) {
  const {
    className,
    classes,
    pulsate = false,
    rippleX,
    rippleY,
    rippleSize,
    in: inProp,
    onExited,
    timeout: timeout2
  } = props;
  const [leaving, setLeaving] = React.useState(false);
  const rippleClassName = clsx(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  const rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  const childClassName = clsx(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
  if (!inProp && !leaving) {
    setLeaving(true);
  }
  React.useEffect(() => {
    if (!inProp && onExited != null) {
      const timeoutId = setTimeout(onExited, timeout2);
      return () => {
        clearTimeout(timeoutId);
      };
    }
    return void 0;
  }, [onExited, inProp, timeout2]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
    className: rippleClassName,
    style: rippleStyles,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      className: childClassName
    })
  });
}
process.env.NODE_ENV !== "production" ? Ripple.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: PropTypes.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: PropTypes.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: PropTypes.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: PropTypes.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: PropTypes.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: PropTypes.number,
  /**
   * exit delay
   */
  timeout: PropTypes.number.isRequired
} : void 0;
const touchRippleClasses = generateUtilityClasses("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]);
const _excluded$3 = ["center", "classes", "className"];
let _ = (t) => t, _t, _t2, _t3, _t4;
const DURATION = 550;
const DELAY_RIPPLE = 80;
const enterKeyframe = keyframes(_t || (_t = _`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const exitKeyframe = keyframes(_t2 || (_t2 = _`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const pulsateKeyframe = keyframes(_t3 || (_t3 = _`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const TouchRippleRoot = styled("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
});
const TouchRippleRipple = styled(Ripple, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(_t4 || (_t4 = _`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), touchRippleClasses.rippleVisible, enterKeyframe, DURATION, ({
  theme
}) => theme.transitions.easing.easeInOut, touchRippleClasses.ripplePulsate, ({
  theme
}) => theme.transitions.duration.shorter, touchRippleClasses.child, touchRippleClasses.childLeaving, exitKeyframe, DURATION, ({
  theme
}) => theme.transitions.easing.easeInOut, touchRippleClasses.childPulsate, pulsateKeyframe, ({
  theme
}) => theme.transitions.easing.easeInOut);
const TouchRipple = /* @__PURE__ */ React.forwardRef(function TouchRipple2(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiTouchRipple"
  });
  const {
    center: centerProp = false,
    classes = {},
    className
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$3);
  const [ripples, setRipples] = React.useState([]);
  const nextKey = React.useRef(0);
  const rippleCallback = React.useRef(null);
  React.useEffect(() => {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]);
  const ignoringMouseDown = React.useRef(false);
  const startTimer = useTimeout();
  const startTimerCommit = React.useRef(null);
  const container2 = React.useRef(null);
  const startCommit = React.useCallback((params) => {
    const {
      pulsate: pulsate2,
      rippleX,
      rippleY,
      rippleSize,
      cb
    } = params;
    setRipples((oldRipples) => [...oldRipples, /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRippleRipple, {
      classes: {
        ripple: clsx(classes.ripple, touchRippleClasses.ripple),
        rippleVisible: clsx(classes.rippleVisible, touchRippleClasses.rippleVisible),
        ripplePulsate: clsx(classes.ripplePulsate, touchRippleClasses.ripplePulsate),
        child: clsx(classes.child, touchRippleClasses.child),
        childLeaving: clsx(classes.childLeaving, touchRippleClasses.childLeaving),
        childPulsate: clsx(classes.childPulsate, touchRippleClasses.childPulsate)
      },
      timeout: DURATION,
      pulsate: pulsate2,
      rippleX,
      rippleY,
      rippleSize
    }, nextKey.current)]);
    nextKey.current += 1;
    rippleCallback.current = cb;
  }, [classes]);
  const start = React.useCallback((event = {}, options = {}, cb = () => {
  }) => {
    const {
      pulsate: pulsate2 = false,
      center = centerProp || options.pulsate,
      fakeElement = false
      // For test purposes
    } = options;
    if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }
    if ((event == null ? void 0 : event.type) === "touchstart") {
      ignoringMouseDown.current = true;
    }
    const element = fakeElement ? null : container2.current;
    const rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let rippleX;
    let rippleY;
    let rippleSize;
    if (center || event === void 0 || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      const {
        clientX,
        clientY
      } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }
    if (center) {
      rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
    }
    if (event != null && event.touches) {
      if (startTimerCommit.current === null) {
        startTimerCommit.current = () => {
          startCommit({
            pulsate: pulsate2,
            rippleX,
            rippleY,
            rippleSize,
            cb
          });
        };
        startTimer.start(DELAY_RIPPLE, () => {
          if (startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
          }
        });
      }
    } else {
      startCommit({
        pulsate: pulsate2,
        rippleX,
        rippleY,
        rippleSize,
        cb
      });
    }
  }, [centerProp, startCommit, startTimer]);
  const pulsate = React.useCallback(() => {
    start({}, {
      pulsate: true
    });
  }, [start]);
  const stop = React.useCallback((event, cb) => {
    startTimer.clear();
    if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.start(0, () => {
        stop(event, cb);
      });
      return;
    }
    startTimerCommit.current = null;
    setRipples((oldRipples) => {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }
      return oldRipples;
    });
    rippleCallback.current = cb;
  }, [startTimer]);
  React.useImperativeHandle(ref, () => ({
    pulsate,
    start,
    stop
  }), [pulsate, start, stop]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRippleRoot, _extends$1({
    className: clsx(touchRippleClasses.root, classes.root, className),
    ref: container2
  }, other, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionGroup, {
      component: null,
      exit: true,
      children: ripples
    })
  }));
});
process.env.NODE_ENV !== "production" ? TouchRipple.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
function getButtonBaseUtilityClass(slot) {
  return generateUtilityClass("MuiButtonBase", slot);
}
const buttonBaseClasses = generateUtilityClasses("MuiButtonBase", ["root", "disabled", "focusVisible"]);
const _excluded$2 = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"];
const useUtilityClasses$2 = (ownerState) => {
  const {
    disabled: disabled2,
    focusVisible,
    focusVisibleClassName,
    classes
  } = ownerState;
  const slots = {
    root: ["root", disabled2 && "disabled", focusVisible && "focusVisible"]
  };
  const composedClasses = composeClasses(slots, getButtonBaseUtilityClass, classes);
  if (focusVisible && focusVisibleClassName) {
    composedClasses.root += ` ${focusVisibleClassName}`;
  }
  return composedClasses;
};
const ButtonBaseRoot = styled("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (props, styles2) => styles2.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${buttonBaseClasses.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
});
const ButtonBase = /* @__PURE__ */ React.forwardRef(function ButtonBase2(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiButtonBase"
  });
  const {
    action,
    centerRipple = false,
    children,
    className,
    component = "button",
    disabled: disabled2 = false,
    disableRipple = false,
    disableTouchRipple = false,
    focusRipple = false,
    LinkComponent = "a",
    onBlur,
    onClick,
    onContextMenu,
    onDragLeave,
    onFocus,
    onFocusVisible,
    onKeyDown,
    onKeyUp,
    onMouseDown,
    onMouseLeave,
    onMouseUp,
    onTouchEnd,
    onTouchMove,
    onTouchStart,
    tabIndex = 0,
    TouchRippleProps,
    touchRippleRef,
    type
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$2);
  const buttonRef = React.useRef(null);
  const rippleRef = React.useRef(null);
  const handleRippleRef = useForkRef(rippleRef, touchRippleRef);
  const {
    isFocusVisibleRef,
    onFocus: handleFocusVisible,
    onBlur: handleBlurVisible,
    ref: focusVisibleRef
  } = useIsFocusVisible();
  const [focusVisible, setFocusVisible] = React.useState(false);
  if (disabled2 && focusVisible) {
    setFocusVisible(false);
  }
  React.useImperativeHandle(action, () => ({
    focusVisible: () => {
      setFocusVisible(true);
      buttonRef.current.focus();
    }
  }), []);
  const [mountedState, setMountedState] = React.useState(false);
  React.useEffect(() => {
    setMountedState(true);
  }, []);
  const enableTouchRipple = mountedState && !disableRipple && !disabled2;
  React.useEffect(() => {
    if (focusVisible && focusRipple && !disableRipple && mountedState) {
      rippleRef.current.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible, mountedState]);
  function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
    return useEventCallback((event) => {
      if (eventCallback) {
        eventCallback(event);
      }
      const ignore = skipRippleAction;
      if (!ignore && rippleRef.current) {
        rippleRef.current[rippleAction](event);
      }
      return true;
    });
  }
  const handleMouseDown = useRippleHandler("start", onMouseDown);
  const handleContextMenu = useRippleHandler("stop", onContextMenu);
  const handleDragLeave = useRippleHandler("stop", onDragLeave);
  const handleMouseUp = useRippleHandler("stop", onMouseUp);
  const handleMouseLeave = useRippleHandler("stop", (event) => {
    if (focusVisible) {
      event.preventDefault();
    }
    if (onMouseLeave) {
      onMouseLeave(event);
    }
  });
  const handleTouchStart = useRippleHandler("start", onTouchStart);
  const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
  const handleTouchMove = useRippleHandler("stop", onTouchMove);
  const handleBlur = useRippleHandler("stop", (event) => {
    handleBlurVisible(event);
    if (isFocusVisibleRef.current === false) {
      setFocusVisible(false);
    }
    if (onBlur) {
      onBlur(event);
    }
  }, false);
  const handleFocus = useEventCallback((event) => {
    if (!buttonRef.current) {
      buttonRef.current = event.currentTarget;
    }
    handleFocusVisible(event);
    if (isFocusVisibleRef.current === true) {
      setFocusVisible(true);
      if (onFocusVisible) {
        onFocusVisible(event);
      }
    }
    if (onFocus) {
      onFocus(event);
    }
  });
  const isNonNativeButton = () => {
    const button = buttonRef.current;
    return component && component !== "button" && !(button.tagName === "A" && button.href);
  };
  const keydownRef = React.useRef(false);
  const handleKeyDown2 = useEventCallback((event) => {
    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
      keydownRef.current = true;
      rippleRef.current.stop(event, () => {
        rippleRef.current.start(event);
      });
    }
    if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") {
      event.preventDefault();
    }
    if (onKeyDown) {
      onKeyDown(event);
    }
    if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled2) {
      event.preventDefault();
      if (onClick) {
        onClick(event);
      }
    }
  });
  const handleKeyUp = useEventCallback((event) => {
    if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
      keydownRef.current = false;
      rippleRef.current.stop(event, () => {
        rippleRef.current.pulsate(event);
      });
    }
    if (onKeyUp) {
      onKeyUp(event);
    }
    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) {
      onClick(event);
    }
  });
  let ComponentProp = component;
  if (ComponentProp === "button" && (other.href || other.to)) {
    ComponentProp = LinkComponent;
  }
  const buttonProps = {};
  if (ComponentProp === "button") {
    buttonProps.type = type === void 0 ? "button" : type;
    buttonProps.disabled = disabled2;
  } else {
    if (!other.href && !other.to) {
      buttonProps.role = "button";
    }
    if (disabled2) {
      buttonProps["aria-disabled"] = disabled2;
    }
  }
  const handleRef = useForkRef(ref, focusVisibleRef, buttonRef);
  if (process.env.NODE_ENV !== "production") {
    React.useEffect(() => {
      if (enableTouchRipple && !rippleRef.current) {
        console.error(["MUI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join("\n"));
      }
    }, [enableTouchRipple]);
  }
  const ownerState = _extends$1({}, props, {
    centerRipple,
    component,
    disabled: disabled2,
    disableRipple,
    disableTouchRipple,
    focusRipple,
    tabIndex,
    focusVisible
  });
  const classes = useUtilityClasses$2(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonBaseRoot, _extends$1({
    as: ComponentProp,
    className: clsx(classes.root, className),
    ownerState,
    onBlur: handleBlur,
    onClick,
    onContextMenu: handleContextMenu,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown2,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled2 ? -1 : tabIndex,
    type
  }, buttonProps, other, {
    children: [children, enableTouchRipple ? (
      /* TouchRipple is only needed client-side, x2 boost on the server. */
      /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRipple, _extends$1({
        ref: handleRippleRef,
        center: centerRipple
      }, TouchRippleProps))
    ) : null]
  }));
});
process.env.NODE_ENV !== "production" ? ButtonBase.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: refType,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: PropTypes.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  href: PropTypes.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: PropTypes.elementType,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onContextMenu: PropTypes.func,
  /**
   * @ignore
   */
  onDragLeave: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,
  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,
  /**
   * @ignore
   */
  onMouseUp: PropTypes.func,
  /**
   * @ignore
   */
  onTouchEnd: PropTypes.func,
  /**
   * @ignore
   */
  onTouchMove: PropTypes.func,
  /**
   * @ignore
   */
  onTouchStart: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      pulsate: PropTypes.func.isRequired,
      start: PropTypes.func.isRequired,
      stop: PropTypes.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(["button", "reset", "submit"]), PropTypes.string])
} : void 0;
function getAccordionSummaryUtilityClass(slot) {
  return generateUtilityClass("MuiAccordionSummary", slot);
}
const accordionSummaryClasses = generateUtilityClasses("MuiAccordionSummary", ["root", "expanded", "focusVisible", "disabled", "gutters", "contentGutters", "content", "expandIconWrapper"]);
const _excluded$1 = ["children", "className", "expandIcon", "focusVisibleClassName", "onClick"];
const useUtilityClasses$1 = (ownerState) => {
  const {
    classes,
    expanded,
    disabled: disabled2,
    disableGutters
  } = ownerState;
  const slots = {
    root: ["root", expanded && "expanded", disabled2 && "disabled", !disableGutters && "gutters"],
    focusVisible: ["focusVisible"],
    content: ["content", expanded && "expanded", !disableGutters && "contentGutters"],
    expandIconWrapper: ["expandIconWrapper", expanded && "expanded"]
  };
  return composeClasses(slots, getAccordionSummaryUtilityClass, classes);
};
const AccordionSummaryRoot = styled(ButtonBase, {
  name: "MuiAccordionSummary",
  slot: "Root",
  overridesResolver: (props, styles2) => styles2.root
})(({
  theme
}) => {
  const transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    display: "flex",
    minHeight: 48,
    padding: theme.spacing(0, 2),
    transition: theme.transitions.create(["min-height", "background-color"], transition),
    [`&.${accordionSummaryClasses.focusVisible}`]: {
      backgroundColor: (theme.vars || theme).palette.action.focus
    },
    [`&.${accordionSummaryClasses.disabled}`]: {
      opacity: (theme.vars || theme).palette.action.disabledOpacity
    },
    [`&:hover:not(.${accordionSummaryClasses.disabled})`]: {
      cursor: "pointer"
    },
    variants: [{
      props: (props) => !props.disableGutters,
      style: {
        [`&.${accordionSummaryClasses.expanded}`]: {
          minHeight: 64
        }
      }
    }]
  };
});
const AccordionSummaryContent = styled("div", {
  name: "MuiAccordionSummary",
  slot: "Content",
  overridesResolver: (props, styles2) => styles2.content
})(({
  theme
}) => ({
  display: "flex",
  flexGrow: 1,
  margin: "12px 0",
  variants: [{
    props: (props) => !props.disableGutters,
    style: {
      transition: theme.transitions.create(["margin"], {
        duration: theme.transitions.duration.shortest
      }),
      [`&.${accordionSummaryClasses.expanded}`]: {
        margin: "20px 0"
      }
    }
  }]
}));
const AccordionSummaryExpandIconWrapper = styled("div", {
  name: "MuiAccordionSummary",
  slot: "ExpandIconWrapper",
  overridesResolver: (props, styles2) => styles2.expandIconWrapper
})(({
  theme
}) => ({
  display: "flex",
  color: (theme.vars || theme).palette.action.active,
  transform: "rotate(0deg)",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest
  }),
  [`&.${accordionSummaryClasses.expanded}`]: {
    transform: "rotate(180deg)"
  }
}));
const AccordionSummary = /* @__PURE__ */ React.forwardRef(function AccordionSummary2(inProps, ref) {
  const props = useDefaultProps({
    props: inProps,
    name: "MuiAccordionSummary"
  });
  const {
    children,
    className,
    expandIcon: expandIcon2,
    focusVisibleClassName,
    onClick
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded$1);
  const {
    disabled: disabled2 = false,
    disableGutters,
    expanded,
    toggle
  } = React.useContext(AccordionContext);
  const handleChange = (event) => {
    if (toggle) {
      toggle(event);
    }
    if (onClick) {
      onClick(event);
    }
  };
  const ownerState = _extends$1({}, props, {
    expanded,
    disabled: disabled2,
    disableGutters
  });
  const classes = useUtilityClasses$1(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(AccordionSummaryRoot, _extends$1({
    focusRipple: false,
    disableRipple: true,
    disabled: disabled2,
    component: "div",
    "aria-expanded": expanded,
    className: clsx(classes.root, className),
    focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName),
    onClick: handleChange,
    ref,
    ownerState
  }, other, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(AccordionSummaryContent, {
      className: classes.content,
      ownerState,
      children
    }), expandIcon2 && /* @__PURE__ */ jsxRuntimeExports.jsx(AccordionSummaryExpandIconWrapper, {
      className: classes.expandIconWrapper,
      ownerState,
      children: expandIcon2
    })]
  }));
});
process.env.NODE_ENV !== "production" ? AccordionSummary.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: PropTypes.node,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
function getTypographyUtilityClass(slot) {
  return generateUtilityClass("MuiTypography", slot);
}
generateUtilityClasses("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const _excluded = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"];
const useUtilityClasses = (ownerState) => {
  const {
    align,
    gutterBottom,
    noWrap,
    paragraph,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ["root", variant, ownerState.align !== "inherit" && `align${capitalize$1(align)}`, gutterBottom && "gutterBottom", noWrap && "noWrap", paragraph && "paragraph"]
  };
  return composeClasses(slots, getTypographyUtilityClass, classes);
};
const TypographyRoot = styled("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (props, styles2) => {
    const {
      ownerState
    } = props;
    return [styles2.root, ownerState.variant && styles2[ownerState.variant], ownerState.align !== "inherit" && styles2[`align${capitalize$1(ownerState.align)}`], ownerState.noWrap && styles2.noWrap, ownerState.gutterBottom && styles2.gutterBottom, ownerState.paragraph && styles2.paragraph];
  }
})(({
  theme,
  ownerState
}) => _extends$1({
  margin: 0
}, ownerState.variant === "inherit" && {
  // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
  font: "inherit"
}, ownerState.variant !== "inherit" && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
  textAlign: ownerState.align
}, ownerState.noWrap && {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, ownerState.gutterBottom && {
  marginBottom: "0.35em"
}, ownerState.paragraph && {
  marginBottom: 16
}));
const defaultVariantMapping = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
};
const colorTransformations = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
};
const transformDeprecatedColors = (color2) => {
  return colorTransformations[color2] || color2;
};
const Typography$1 = /* @__PURE__ */ React.forwardRef(function Typography(inProps, ref) {
  const themeProps = useDefaultProps({
    props: inProps,
    name: "MuiTypography"
  });
  const color2 = transformDeprecatedColors(themeProps.color);
  const props = extendSxProp(_extends$1({}, themeProps, {
    color: color2
  }));
  const {
    align = "inherit",
    className,
    component,
    gutterBottom = false,
    noWrap = false,
    paragraph = false,
    variant = "body1",
    variantMapping = defaultVariantMapping
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded);
  const ownerState = _extends$1({}, props, {
    align,
    color: color2,
    className,
    component,
    gutterBottom,
    noWrap,
    paragraph,
    variant,
    variantMapping
  });
  const Component = component || (paragraph ? "p" : variantMapping[variant] || defaultVariantMapping[variant]) || "span";
  const classes = useUtilityClasses(ownerState);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TypographyRoot, _extends$1({
    as: Component,
    ref,
    ownerState,
    className: clsx(classes.root, className)
  }, other));
});
process.env.NODE_ENV !== "production" ? Typography$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: PropTypes.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: PropTypes.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: PropTypes.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */
  paragraph: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), PropTypes.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: PropTypes.object
} : void 0;
var H1Bold = "typography_H1Bold__pwlk6r0";
var H1Regular = "typography_H1Regular__pwlk6r1";
var H2Bold = "typography_H2Bold__pwlk6r2";
var H2Regular = "typography_H2Regular__pwlk6r3";
var H3Bold = "typography_H3Bold__pwlk6r4";
var H3Regular = "typography_H3Regular__pwlk6r5";
var H4Bold = "typography_H4Bold__pwlk6r6";
var H4Regular = "typography_H4Regular__pwlk6r7";
var H5Bold = "typography_H5Bold__pwlk6r8";
var H5Regular = "typography_H5Regular__pwlk6r9";
var H6Bold = "typography_H6Bold__pwlk6ra";
var BodyXLBold = "typography_BodyXLBold__pwlk6rb";
var BodyXLMedium = "typography_BodyXLMedium__pwlk6rc";
var BodyXLRegular = "typography_BodyXLRegular__pwlk6rd";
var BodyLBold = "typography_BodyLBold__pwlk6re";
var BodyLMedium = "typography_BodyLMedium__pwlk6rf";
var BodyLRegular = "typography_BodyLRegular__pwlk6rg";
var BodyMBold = "typography_BodyMBold__pwlk6rh";
var BodyMMedium = "typography_BodyMMedium__pwlk6ri";
var BodyMRegular = "typography_BodyMRegular__pwlk6rj";
var BodySBold = "typography_BodySBold__pwlk6rk";
var BodySMedium = "typography_BodySMedium__pwlk6rl";
var BodySRegular = "typography_BodySRegular__pwlk6rm";
var BodyXSBold = "typography_BodyXSBold__pwlk6rn";
var BodyXSMedium = "typography_BodyXSMedium__pwlk6ro";
var BodyXSRegular = "typography_BodyXSRegular__pwlk6rp";
const variants$7 = {
  H1Bold,
  H1Regular,
  H2Bold,
  H2Regular,
  H3Bold,
  H3Regular,
  H4Bold,
  H4Regular,
  H5Bold,
  H5Regular,
  H6Bold,
  BodyXLBold,
  BodyXLMedium,
  BodyXLRegular,
  BodyLBold,
  BodyLMedium,
  BodyLRegular,
  BodyMBold,
  BodyMMedium,
  BodyMRegular,
  BodySBold,
  BodySMedium,
  BodySRegular,
  BodyXSBold,
  BodyXSMedium,
  BodyXSRegular
};
const Typography2 = ({ className, children, variant, component, color: color2 }) => {
  return (
    /* @ts-ignore */
    /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$1, { className: classNames(variants$7 == null ? void 0 : variants$7[variant], className), color: color2, component, children })
  );
};
var xlUp = "hidden_xlUp__1qun3jc0";
var xlDown = "hidden_xlDown__1qun3jc1";
var lgUp = "hidden_lgUp__1qun3jc2";
var lgDown = "hidden_lgDown__1qun3jc3";
var mdUp = "hidden_mdUp__1qun3jc4";
var mdDown = "hidden_mdDown__1qun3jc5";
var smUp = "hidden_smUp__1qun3jc6";
var smDown = "hidden_smDown__1qun3jc7";
var xsmUp = "hidden_xsmUp__1qun3jc8";
var xsmDown = "hidden_xsmDown__1qun3jc9";
var xsUp = "hidden_xsUp__1qun3jca";
var xsDown = "hidden_xsDown__1qun3jcb";
const variants$6 = {
  xlUp,
  xlDown,
  lgUp,
  lgDown,
  mdUp,
  mdDown,
  smUp,
  smDown,
  xsmUp,
  xsmDown,
  xsUp,
  xsDown
};
const Hidden = ({ className, children, up, down }) => {
  const upClass = up ? variants$6[`${up}Up`] : "";
  const downClass = down ? variants$6[`${down}Down`] : "";
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(className, { [upClass]: up, [downClass]: down }), children });
};
const SpriteContext = React__default.createContext("");
const useSpritePath = () => React__default.useContext(SpriteContext);
const Icon$1 = ({ name: name2, width: width2 = "1em", height: height2 = "1em", ...rest }) => {
  const spritePath = useSpritePath();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      style: {
        height: height2,
        width: width2,
        minHeight: height2,
        minWidth: width2
      },
      width: width2,
      height: height2,
      ...rest,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("use", { href: `${spritePath || "/icons.svg"}#${name2}` })
    }
  );
};
var layoutDisabled$2 = "search_layoutDisabled__17zcz8m1";
var input$1 = "search_input__17zcz8m2";
var small$6 = "search_small__17zcz8m3 search_layout__17zcz8m0";
var medium$4 = "search_medium__17zcz8m4 search_layout__17zcz8m0";
var large$6 = "search_large__17zcz8m5 search_layout__17zcz8m0";
var iconSmall = "search_iconSmall__17zcz8m7 search_iconLayout__17zcz8m6";
var iconMedium = "search_iconMedium__17zcz8m8 search_iconLayout__17zcz8m6";
var iconLarge = "search_iconLarge__17zcz8m9 search_iconLayout__17zcz8m6";
var skeleton$3 = "search_skeleton__17zcz8ma";
var loadingWheelSmall = "search_loadingWheelSmall__17zcz8mc search_loadingWheelBase__17zcz8mb";
var loadingWheelMedium = "search_loadingWheelMedium__17zcz8md search_loadingWheelBase__17zcz8mb";
var loadingWheelLarge = "search_loadingWheelLarge__17zcz8me search_loadingWheelBase__17zcz8mb";
var deleteButton = "search_deleteButton__17zcz8mf";
const Input$1 = ({ className, value: value2, onChange, placeholder, disabled: disabled2, loading }) => {
  const onClear = React__default.useCallback(() => {
    if (!disabled2) {
      onChange == null ? void 0 : onChange("");
    }
  }, [onChange, disabled2]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "input",
      {
        value: value2,
        disabled: disabled2,
        placeholder,
        onChange: (e) => onChange == null ? void 0 : onChange(e.target.value),
        className: classNames(input$1, className)
      }
    ),
    value2 && !loading ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick: onClear, className: deleteButton, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { name: "close" }) }) : null
  ] });
};
const iconSizes = {
  small: iconSmall,
  medium: iconMedium,
  large: iconLarge
};
const SearchIcon = ({ className, size = "medium" }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(iconSizes[size], className), children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { name: "search" }) });
};
const sizes$f = {
  small: small$6,
  medium: medium$4,
  large: large$6
};
const Skeleton$1 = ({ className, size = "medium" }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(sizes$f[size], className, skeleton$3) });
};
var root = "loadingWheel_root__11yv8ox1";
const LoadingWheel = ({ className, color: color2 = "currentColor" }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "svg",
    {
      className: classNames(root, className),
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M14.3266 2.32657C14.3266 3.55947 13.3271 4.5589 12.0942 4.5589C10.8613 4.5589 9.86191 3.55947 9.86191 2.32657C9.86191 1.09367 10.8613 0.0942383 12.0942 0.0942383C13.3271 0.0942383 14.3266 1.09367 14.3266 2.32657ZM12.0942 19.4411C10.8613 19.4411 9.86191 20.4405 9.86191 21.6734C9.86191 22.9063 10.8613 23.9058 12.0942 23.9058C13.3271 23.9058 14.3266 22.9063 14.3266 21.6734C14.3266 20.4405 13.3271 19.4411 12.0942 19.4411ZM21.7677 9.76767C20.5348 9.76767 19.5353 10.7671 19.5353 12C19.5353 13.2329 20.5348 14.2323 21.7677 14.2323C23.0006 14.2323 24 13.2329 24 12C24 10.7671 23.0006 9.76767 21.7677 9.76767ZM4.65314 12C4.65314 10.7671 3.6537 9.76767 2.42081 9.76767C1.18791 9.76767 0.188477 10.7671 0.188477 12C0.188477 13.2329 1.18791 14.2323 2.42081 14.2323C3.6537 14.2323 4.65314 13.2329 4.65314 12ZM5.2541 16.6078C4.0212 16.6078 3.02177 17.6072 3.02177 18.8401C3.02177 20.073 4.0212 21.0725 5.2541 21.0725C6.487 21.0725 7.48643 20.073 7.48643 18.8401C7.48643 17.6073 6.48695 16.6078 5.2541 16.6078ZM18.9344 16.6078C17.7015 16.6078 16.702 17.6072 16.702 18.8401C16.702 20.073 17.7015 21.0725 18.9344 21.0725C20.1673 21.0725 21.1667 20.073 21.1667 18.8401C21.1667 17.6073 20.1673 16.6078 18.9344 16.6078ZM5.2541 2.92753C4.0212 2.92753 3.02177 3.92696 3.02177 5.15986C3.02177 6.39276 4.0212 7.39219 5.2541 7.39219C6.487 7.39219 7.48643 6.39276 7.48643 5.15986C7.48643 3.92696 6.48695 2.92753 5.2541 2.92753Z",
          fill: color2
        }
      )
    }
  );
};
const sizes$e = {
  small: small$6,
  medium: medium$4,
  large: large$6
};
const loadingWheelSizes = {
  small: loadingWheelSmall,
  medium: loadingWheelMedium,
  large: loadingWheelLarge
};
const Search$1 = ({
  className,
  value: value2,
  onChange,
  children,
  size = "medium",
  disabled: disabled2,
  loading,
  placeholder
}) => {
  const [_value, _setValue] = React__default.useState(value2 ?? "");
  const _onChange = React__default.useCallback(
    (val) => {
      if (!disabled2) {
        _setValue(val);
        onChange == null ? void 0 : onChange(val);
      }
    },
    [onChange, disabled2]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames(sizes$e[size], className, { [layoutDisabled$2]: disabled2 }), children: [
    React__default.Children.map(
      children,
      (child) => React__default.isValidElement(child) ? React__default.cloneElement(child, {
        size,
        disabled: disabled2,
        loading,
        onChange: _onChange,
        placeholder,
        value: _value,
        ...(child == null ? void 0 : child.props) ?? {}
      }) : child
    ),
    loading ? /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingWheel, { className: loadingWheelSizes[size] }) : null
  ] });
};
Search$1.Input = Input$1;
Search$1.Icon = SearchIcon;
Search$1.Skeleton = Skeleton$1;
var layout$b = "systemMessage_layout__4gjox00";
var error$1 = "systemMessage_error__4gjox01";
var success = "systemMessage_success__4gjox02";
var warning = "systemMessage_warning__4gjox03";
var info = "systemMessage_info__4gjox04";
var CTAError = "systemMessage_CTAError__4gjox06 systemMessage_CTABase__4gjox05";
var CTASuccess = "systemMessage_CTASuccess__4gjox07 systemMessage_CTABase__4gjox05";
var CTAWarning = "systemMessage_CTAWarning__4gjox08 systemMessage_CTABase__4gjox05";
var CTAInfo = "systemMessage_CTAInfo__4gjox09 systemMessage_CTABase__4gjox05";
const Icon = ({ className }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { className, name: "exclude" });
};
const variants$5 = {
  info: CTAInfo,
  error: CTAError,
  success: CTASuccess,
  warning: CTAWarning
};
const CTA = ({ className, children, variant = "info", onClick }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Button$2, { onClick, size: "small", className: classNames(variants$5[variant], className), variant: "plain", children });
};
const Close = ({ className, onClick, color: color2 }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: classNames(flexCenter, className),
      style: { cursor: "pointer", fontSize: "16px" },
      onClick,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { color: color2, name: "close" })
    }
  );
};
const variants$4 = {
  warning,
  info,
  success,
  error: error$1
};
const SystemMessage$1 = ({
  className,
  children,
  variant = "info"
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(layout$b, className, variants$4[variant]), children: React__default.Children.map(
    children,
    (child) => React__default.isValidElement(child) ? React__default.cloneElement(child, {
      variant,
      ...(child == null ? void 0 : child.props) ?? {}
    }) : child
  ) });
};
SystemMessage$1.Icon = Icon;
SystemMessage$1.CTA = CTA;
SystemMessage$1.Close = Close;
var layout$a = "accordion_layout__13i56pc0";
var itemDefault = "accordion_itemDefault__13i56pc1";
var itemLarge = "accordion_itemLarge__13i56pc2";
var itemMedium = "accordion_itemMedium__13i56pc3";
var itemSmall = "accordion_itemSmall__13i56pc4";
var itemHeader = "accordion_itemHeader__13i56pc5";
var itemHeaderText = "accordion_itemHeaderText__13i56pc6";
var itemContent = "accordion_itemContent__13i56pc7";
var itemContentText = "accordion_itemContentText__13i56pc8";
var skeleton$2 = "accordion_skeleton__13i56pc9";
const sizes$d = {
  large: itemLarge,
  medium: itemMedium,
  small: itemSmall
};
const Item$2 = ({ className, children, expandedDefault, size = "medium", variant, disabled: disabled2 }) => {
  const [expanded, setExpanded] = useState(expandedDefault ?? false);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Accordion$2,
    {
      className: classNames(sizes$d[size], { [itemDefault]: variant !== "plain" }, className),
      disableGutters: true,
      expanded,
      disabled: disabled2,
      onChange: (_2, value2) => setExpanded(value2),
      children: React__default.Children.map(
        children,
        (child) => React__default.isValidElement(child) ? React__default.cloneElement(child, {
          expanded,
          disabled: disabled2,
          ...(child == null ? void 0 : child.props) ?? {}
        }) : child
      )
    }
  );
};
const Header$1 = ({ className, chevronClassName, children, expanded }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  AccordionSummary,
  {
    className: classNames(itemHeader, className),
    expandIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { className: chevronClassName, name: "chevron_down" }),
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: itemHeaderText, children: React__default.isValidElement(children) ? React__default.cloneElement(children, { expanded, ...(children == null ? void 0 : children.props) ?? {} }) : children })
  }
);
const Content$4 = ({ className, children, disabled: disabled2 }) => {
  return (
    // @ts-ignore
    /* @__PURE__ */ jsxRuntimeExports.jsx(AccordionDetails, { className: classNames(itemContentText, className, { [itemContent]: disabled2 }), children: typeof children === "string" ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { dangerouslySetInnerHTML: { __html: children } }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children }) })
  );
};
var vars = { typography: { H1Bold: { fontFamily: "var(--typography-H1Bold-fontFamily__1lricb60)", fontSize: "var(--typography-H1Bold-fontSize__1lricb61)", lineHeight: "var(--typography-H1Bold-lineHeight__1lricb62)", letterSpacing: "var(--typography-H1Bold-letterSpacing__1lricb63)", fontWeight: "var(--typography-H1Bold-fontWeight__1lricb64)", WebkitFontSmoothing: "var(--typography-H1Bold-WebkitFontSmoothing__1lricb65)" }, H1Regular: { fontFamily: "var(--typography-H1Regular-fontFamily__1lricb66)", fontSize: "var(--typography-H1Regular-fontSize__1lricb67)", lineHeight: "var(--typography-H1Regular-lineHeight__1lricb68)", letterSpacing: "var(--typography-H1Regular-letterSpacing__1lricb69)", fontWeight: "var(--typography-H1Regular-fontWeight__1lricb6a)", WebkitFontSmoothing: "var(--typography-H1Regular-WebkitFontSmoothing__1lricb6b)" }, H2Bold: { fontFamily: "var(--typography-H2Bold-fontFamily__1lricb6c)", fontSize: "var(--typography-H2Bold-fontSize__1lricb6d)", lineHeight: "var(--typography-H2Bold-lineHeight__1lricb6e)", letterSpacing: "var(--typography-H2Bold-letterSpacing__1lricb6f)", fontWeight: "var(--typography-H2Bold-fontWeight__1lricb6g)", WebkitFontSmoothing: "var(--typography-H2Bold-WebkitFontSmoothing__1lricb6h)" }, H2Regular: { fontFamily: "var(--typography-H2Regular-fontFamily__1lricb6i)", fontSize: "var(--typography-H2Regular-fontSize__1lricb6j)", lineHeight: "var(--typography-H2Regular-lineHeight__1lricb6k)", letterSpacing: "var(--typography-H2Regular-letterSpacing__1lricb6l)", fontWeight: "var(--typography-H2Regular-fontWeight__1lricb6m)", WebkitFontSmoothing: "var(--typography-H2Regular-WebkitFontSmoothing__1lricb6n)" }, H3Bold: { fontFamily: "var(--typography-H3Bold-fontFamily__1lricb6o)", fontSize: "var(--typography-H3Bold-fontSize__1lricb6p)", lineHeight: "var(--typography-H3Bold-lineHeight__1lricb6q)", letterSpacing: "var(--typography-H3Bold-letterSpacing__1lricb6r)", fontWeight: "var(--typography-H3Bold-fontWeight__1lricb6s)", WebkitFontSmoothing: "var(--typography-H3Bold-WebkitFontSmoothing__1lricb6t)" }, H3Regular: { fontFamily: "var(--typography-H3Regular-fontFamily__1lricb6u)", fontSize: "var(--typography-H3Regular-fontSize__1lricb6v)", lineHeight: "var(--typography-H3Regular-lineHeight__1lricb6w)", letterSpacing: "var(--typography-H3Regular-letterSpacing__1lricb6x)", fontWeight: "var(--typography-H3Regular-fontWeight__1lricb6y)", WebkitFontSmoothing: "var(--typography-H3Regular-WebkitFontSmoothing__1lricb6z)" }, H4Bold: { fontFamily: "var(--typography-H4Bold-fontFamily__1lricb610)", fontSize: "var(--typography-H4Bold-fontSize__1lricb611)", lineHeight: "var(--typography-H4Bold-lineHeight__1lricb612)", letterSpacing: "var(--typography-H4Bold-letterSpacing__1lricb613)", fontWeight: "var(--typography-H4Bold-fontWeight__1lricb614)", WebkitFontSmoothing: "var(--typography-H4Bold-WebkitFontSmoothing__1lricb615)" }, H4Regular: { fontFamily: "var(--typography-H4Regular-fontFamily__1lricb616)", fontSize: "var(--typography-H4Regular-fontSize__1lricb617)", lineHeight: "var(--typography-H4Regular-lineHeight__1lricb618)", letterSpacing: "var(--typography-H4Regular-letterSpacing__1lricb619)", fontWeight: "var(--typography-H4Regular-fontWeight__1lricb61a)", WebkitFontSmoothing: "var(--typography-H4Regular-WebkitFontSmoothing__1lricb61b)" }, H5Bold: { fontFamily: "var(--typography-H5Bold-fontFamily__1lricb61c)", fontSize: "var(--typography-H5Bold-fontSize__1lricb61d)", lineHeight: "var(--typography-H5Bold-lineHeight__1lricb61e)", letterSpacing: "var(--typography-H5Bold-letterSpacing__1lricb61f)", fontWeight: "var(--typography-H5Bold-fontWeight__1lricb61g)", WebkitFontSmoothing: "var(--typography-H5Bold-WebkitFontSmoothing__1lricb61h)" }, H5Regular: { fontFamily: "var(--typography-H5Regular-fontFamily__1lricb61i)", fontSize: "var(--typography-H5Regular-fontSize__1lricb61j)", lineHeight: "var(--typography-H5Regular-lineHeight__1lricb61k)", letterSpacing: "var(--typography-H5Regular-letterSpacing__1lricb61l)", fontWeight: "var(--typography-H5Regular-fontWeight__1lricb61m)", WebkitFontSmoothing: "var(--typography-H5Regular-WebkitFontSmoothing__1lricb61n)" }, H6Bold: { fontFamily: "var(--typography-H6Bold-fontFamily__1lricb61o)", fontSize: "var(--typography-H6Bold-fontSize__1lricb61p)", lineHeight: "var(--typography-H6Bold-lineHeight__1lricb61q)", letterSpacing: "var(--typography-H6Bold-letterSpacing__1lricb61r)", fontWeight: "var(--typography-H6Bold-fontWeight__1lricb61s)", WebkitFontSmoothing: "var(--typography-H6Bold-WebkitFontSmoothing__1lricb61t)" }, BodyXLBold: { fontFamily: "var(--typography-BodyXLBold-fontFamily__1lricb61u)", fontSize: "var(--typography-BodyXLBold-fontSize__1lricb61v)", lineHeight: "var(--typography-BodyXLBold-lineHeight__1lricb61w)", letterSpacing: "var(--typography-BodyXLBold-letterSpacing__1lricb61x)", fontWeight: "var(--typography-BodyXLBold-fontWeight__1lricb61y)", WebkitFontSmoothing: "var(--typography-BodyXLBold-WebkitFontSmoothing__1lricb61z)" }, BodyXLMedium: { fontFamily: "var(--typography-BodyXLMedium-fontFamily__1lricb620)", fontSize: "var(--typography-BodyXLMedium-fontSize__1lricb621)", lineHeight: "var(--typography-BodyXLMedium-lineHeight__1lricb622)", letterSpacing: "var(--typography-BodyXLMedium-letterSpacing__1lricb623)", fontWeight: "var(--typography-BodyXLMedium-fontWeight__1lricb624)", WebkitFontSmoothing: "var(--typography-BodyXLMedium-WebkitFontSmoothing__1lricb625)" }, BodyXLRegular: { fontFamily: "var(--typography-BodyXLRegular-fontFamily__1lricb626)", fontSize: "var(--typography-BodyXLRegular-fontSize__1lricb627)", lineHeight: "var(--typography-BodyXLRegular-lineHeight__1lricb628)", letterSpacing: "var(--typography-BodyXLRegular-letterSpacing__1lricb629)", fontWeight: "var(--typography-BodyXLRegular-fontWeight__1lricb62a)", WebkitFontSmoothing: "var(--typography-BodyXLRegular-WebkitFontSmoothing__1lricb62b)" }, BodyLBold: { fontFamily: "var(--typography-BodyLBold-fontFamily__1lricb62c)", fontSize: "var(--typography-BodyLBold-fontSize__1lricb62d)", lineHeight: "var(--typography-BodyLBold-lineHeight__1lricb62e)", letterSpacing: "var(--typography-BodyLBold-letterSpacing__1lricb62f)", fontWeight: "var(--typography-BodyLBold-fontWeight__1lricb62g)", WebkitFontSmoothing: "var(--typography-BodyLBold-WebkitFontSmoothing__1lricb62h)" }, BodyLMedium: { fontFamily: "var(--typography-BodyLMedium-fontFamily__1lricb62i)", fontSize: "var(--typography-BodyLMedium-fontSize__1lricb62j)", lineHeight: "var(--typography-BodyLMedium-lineHeight__1lricb62k)", letterSpacing: "var(--typography-BodyLMedium-letterSpacing__1lricb62l)", fontWeight: "var(--typography-BodyLMedium-fontWeight__1lricb62m)", WebkitFontSmoothing: "var(--typography-BodyLMedium-WebkitFontSmoothing__1lricb62n)" }, BodyLRegular: { fontFamily: "var(--typography-BodyLRegular-fontFamily__1lricb62o)", fontSize: "var(--typography-BodyLRegular-fontSize__1lricb62p)", lineHeight: "var(--typography-BodyLRegular-lineHeight__1lricb62q)", letterSpacing: "var(--typography-BodyLRegular-letterSpacing__1lricb62r)", fontWeight: "var(--typography-BodyLRegular-fontWeight__1lricb62s)", WebkitFontSmoothing: "var(--typography-BodyLRegular-WebkitFontSmoothing__1lricb62t)" }, BodyMBold: { fontFamily: "var(--typography-BodyMBold-fontFamily__1lricb62u)", fontSize: "var(--typography-BodyMBold-fontSize__1lricb62v)", lineHeight: "var(--typography-BodyMBold-lineHeight__1lricb62w)", letterSpacing: "var(--typography-BodyMBold-letterSpacing__1lricb62x)", fontWeight: "var(--typography-BodyMBold-fontWeight__1lricb62y)", WebkitFontSmoothing: "var(--typography-BodyMBold-WebkitFontSmoothing__1lricb62z)" }, BodyMMedium: { fontFamily: "var(--typography-BodyMMedium-fontFamily__1lricb630)", fontSize: "var(--typography-BodyMMedium-fontSize__1lricb631)", lineHeight: "var(--typography-BodyMMedium-lineHeight__1lricb632)", letterSpacing: "var(--typography-BodyMMedium-letterSpacing__1lricb633)", fontWeight: "var(--typography-BodyMMedium-fontWeight__1lricb634)", WebkitFontSmoothing: "var(--typography-BodyMMedium-WebkitFontSmoothing__1lricb635)" }, BodyMRegular: { fontFamily: "var(--typography-BodyMRegular-fontFamily__1lricb636)", fontSize: "var(--typography-BodyMRegular-fontSize__1lricb637)", lineHeight: "var(--typography-BodyMRegular-lineHeight__1lricb638)", letterSpacing: "var(--typography-BodyMRegular-letterSpacing__1lricb639)", fontWeight: "var(--typography-BodyMRegular-fontWeight__1lricb63a)", WebkitFontSmoothing: "var(--typography-BodyMRegular-WebkitFontSmoothing__1lricb63b)" }, BodySBold: { fontFamily: "var(--typography-BodySBold-fontFamily__1lricb63c)", fontSize: "var(--typography-BodySBold-fontSize__1lricb63d)", lineHeight: "var(--typography-BodySBold-lineHeight__1lricb63e)", letterSpacing: "var(--typography-BodySBold-letterSpacing__1lricb63f)", fontWeight: "var(--typography-BodySBold-fontWeight__1lricb63g)", WebkitFontSmoothing: "var(--typography-BodySBold-WebkitFontSmoothing__1lricb63h)" }, BodySMedium: { fontFamily: "var(--typography-BodySMedium-fontFamily__1lricb63i)", fontSize: "var(--typography-BodySMedium-fontSize__1lricb63j)", lineHeight: "var(--typography-BodySMedium-lineHeight__1lricb63k)", letterSpacing: "var(--typography-BodySMedium-letterSpacing__1lricb63l)", fontWeight: "var(--typography-BodySMedium-fontWeight__1lricb63m)", WebkitFontSmoothing: "var(--typography-BodySMedium-WebkitFontSmoothing__1lricb63n)" }, BodySRegular: { fontFamily: "var(--typography-BodySRegular-fontFamily__1lricb63o)", fontSize: "var(--typography-BodySRegular-fontSize__1lricb63p)", lineHeight: "var(--typography-BodySRegular-lineHeight__1lricb63q)", letterSpacing: "var(--typography-BodySRegular-letterSpacing__1lricb63r)", fontWeight: "var(--typography-BodySRegular-fontWeight__1lricb63s)", WebkitFontSmoothing: "var(--typography-BodySRegular-WebkitFontSmoothing__1lricb63t)" }, BodyXSBold: { fontFamily: "var(--typography-BodyXSBold-fontFamily__1lricb63u)", fontSize: "var(--typography-BodyXSBold-fontSize__1lricb63v)", lineHeight: "var(--typography-BodyXSBold-lineHeight__1lricb63w)", letterSpacing: "var(--typography-BodyXSBold-letterSpacing__1lricb63x)", fontWeight: "var(--typography-BodyXSBold-fontWeight__1lricb63y)", WebkitFontSmoothing: "var(--typography-BodyXSBold-WebkitFontSmoothing__1lricb63z)" }, BodyXSMedium: { fontFamily: "var(--typography-BodyXSMedium-fontFamily__1lricb640)", fontSize: "var(--typography-BodyXSMedium-fontSize__1lricb641)", lineHeight: "var(--typography-BodyXSMedium-lineHeight__1lricb642)", letterSpacing: "var(--typography-BodyXSMedium-letterSpacing__1lricb643)", fontWeight: "var(--typography-BodyXSMedium-fontWeight__1lricb644)", WebkitFontSmoothing: "var(--typography-BodyXSMedium-WebkitFontSmoothing__1lricb645)" }, BodyXSRegular: { fontFamily: "var(--typography-BodyXSRegular-fontFamily__1lricb646)", fontSize: "var(--typography-BodyXSRegular-fontSize__1lricb647)", lineHeight: "var(--typography-BodyXSRegular-lineHeight__1lricb648)", letterSpacing: "var(--typography-BodyXSRegular-letterSpacing__1lricb649)", fontWeight: "var(--typography-BodyXSRegular-fontWeight__1lricb64a)", WebkitFontSmoothing: "var(--typography-BodyXSRegular-WebkitFontSmoothing__1lricb64b)" } }, palette: { "default": { background: "var(--palette-default-background__1lricb64c)", surface: { primary: "var(--palette-default-surface-primary__1lricb64d)", secondary: "var(--palette-default-surface-secondary__1lricb64e)", tertiary: "var(--palette-default-surface-tertiary__1lricb64f)", fourth: "var(--palette-default-surface-fourth__1lricb64g)" }, text: { primary: "var(--palette-default-text-primary__1lricb64h)", secondary: "var(--palette-default-text-secondary__1lricb64i)", tertiary: "var(--palette-default-text-tertiary__1lricb64j)", disabled: "var(--palette-default-text-disabled__1lricb64k)", white: "var(--palette-default-text-white__1lricb64l)" }, icon: { primary: "var(--palette-default-icon-primary__1lricb64m)", secondary: "var(--palette-default-icon-secondary__1lricb64n)", tertiary: "var(--palette-default-icon-tertiary__1lricb64o)", fourth: "var(--palette-default-icon-fourth__1lricb64p)", iconStart: "var(--palette-default-icon-iconStart__1lricb64q)", disabled: "var(--palette-default-icon-disabled__1lricb64r)", iconDashboardMenu: "var(--palette-default-icon-iconDashboardMenu__1lricb64s)" }, link: { link: "var(--palette-default-link-link__1lricb64t)", hover: "var(--palette-default-link-hover__1lricb64u)" }, buttons: { primary: { fill: "var(--palette-default-buttons-primary-fill__1lricb64v)", onFill: "var(--palette-default-buttons-primary-onFill__1lricb64w)", hover: "var(--palette-default-buttons-primary-hover__1lricb64x)" }, secondary: { fill: "var(--palette-default-buttons-secondary-fill__1lricb64y)", onFill: "var(--palette-default-buttons-secondary-onFill__1lricb64z)", hover: "var(--palette-default-buttons-secondary-hover__1lricb650)" }, tertiary: { fill: "var(--palette-default-buttons-tertiary-fill__1lricb651)", onFill: "var(--palette-default-buttons-tertiary-onFill__1lricb652)", hover: "var(--palette-default-buttons-tertiary-hover__1lricb653)" }, fourth: { fill: "var(--palette-default-buttons-fourth-fill__1lricb654)", onFill: "var(--palette-default-buttons-fourth-onFill__1lricb655)", hover: "var(--palette-default-buttons-fourth-hover__1lricb656)" }, disabled: { fill: "var(--palette-default-buttons-disabled-fill__1lricb657)", onFill: "var(--palette-default-buttons-disabled-onFill__1lricb658)", hover: "var(--palette-default-buttons-disabled-hover__1lricb659)" }, white: { fill: "var(--palette-default-buttons-white-fill__1lricb65a)", onFill: "var(--palette-default-buttons-white-onFill__1lricb65b)", hover: "var(--palette-default-buttons-white-hover__1lricb65c)" } }, fill: { primary: { fill: "var(--palette-default-fill-primary-fill__1lricb65d)", onFill: "var(--palette-default-fill-primary-onFill__1lricb65e)", hover: "var(--palette-default-fill-primary-hover__1lricb65f)" }, secondary: { fill: "var(--palette-default-fill-secondary-fill__1lricb65g)", onFill: "var(--palette-default-fill-secondary-onFill__1lricb65h)", hover: "var(--palette-default-fill-secondary-hover__1lricb65i)" }, tertiary: { fill: "var(--palette-default-fill-tertiary-fill__1lricb65j)", onFill: "var(--palette-default-fill-tertiary-onFill__1lricb65k)", hover: "var(--palette-default-fill-tertiary-hover__1lricb65l)" }, fourth: { fill: "var(--palette-default-fill-fourth-fill__1lricb65m)", onFill: "var(--palette-default-fill-fourth-onFill__1lricb65n)", hover: "var(--palette-default-fill-fourth-hover__1lricb65o)" }, disabled: { fill: "var(--palette-default-fill-disabled-fill__1lricb65p)", onFill: "var(--palette-default-fill-disabled-onFill__1lricb65q)", hover: "var(--palette-default-fill-disabled-hover__1lricb65r)" } }, border: { primary: "var(--palette-default-border-primary__1lricb65s)", secondary: "var(--palette-default-border-secondary__1lricb65t)" } }, highlight: { accent1: { background: "var(--palette-highlight-accent1-background__1lricb65u)", surface: "var(--palette-highlight-accent1-surface__1lricb65v)", text: { primary: "var(--palette-highlight-accent1-text-primary__1lricb65w)", secondary: "var(--palette-highlight-accent1-text-secondary__1lricb65x)" }, icon: "var(--palette-highlight-accent1-icon__1lricb65y)", link: { link: "var(--palette-highlight-accent1-link-link__1lricb65z)", hover: "var(--palette-highlight-accent1-link-hover__1lricb660)" }, fill: { fill: "var(--palette-highlight-accent1-fill-fill__1lricb661)", onFill: "var(--palette-highlight-accent1-fill-onFill__1lricb662)" }, border: "var(--palette-highlight-accent1-border__1lricb663)" }, accent2: { background: "var(--palette-highlight-accent2-background__1lricb664)", surface: "var(--palette-highlight-accent2-surface__1lricb665)", text: { primary: "var(--palette-highlight-accent2-text-primary__1lricb666)", secondary: "var(--palette-highlight-accent2-text-secondary__1lricb667)" }, icon: "var(--palette-highlight-accent2-icon__1lricb668)", link: { link: "var(--palette-highlight-accent2-link-link__1lricb669)", hover: "var(--palette-highlight-accent2-link-hover__1lricb66a)" }, fill: { fill: "var(--palette-highlight-accent2-fill-fill__1lricb66b)", onFill: "var(--palette-highlight-accent2-fill-onFill__1lricb66c)" }, border: "var(--palette-highlight-accent2-border__1lricb66d)" }, accent3: { background: "var(--palette-highlight-accent3-background__1lricb66e)", surface: "var(--palette-highlight-accent3-surface__1lricb66f)", text: { primary: "var(--palette-highlight-accent3-text-primary__1lricb66g)", secondary: "var(--palette-highlight-accent3-text-secondary__1lricb66h)" }, icon: "var(--palette-highlight-accent3-icon__1lricb66i)", link: { link: "var(--palette-highlight-accent3-link-link__1lricb66j)", hover: "var(--palette-highlight-accent3-link-hover__1lricb66k)" }, fill: { fill: "var(--palette-highlight-accent3-fill-fill__1lricb66l)", onFill: "var(--palette-highlight-accent3-fill-onFill__1lricb66m)" }, border: "var(--palette-highlight-accent3-border__1lricb66n)" } }, inverse: { background: "var(--palette-inverse-background__1lricb66o)", surface: { primary: "var(--palette-inverse-surface-primary__1lricb66p)", secondary: "var(--palette-inverse-surface-secondary__1lricb66q)" }, text: "var(--palette-inverse-text__1lricb66r)", icon: "var(--palette-inverse-icon__1lricb66s)", link: { link: "var(--palette-inverse-link-link__1lricb66t)", hover: "var(--palette-inverse-link-hover__1lricb66u)" }, fill: { fill: "var(--palette-inverse-fill-fill__1lricb66v)", onFill: "var(--palette-inverse-fill-onFill__1lricb66w)" }, border: "var(--palette-inverse-border__1lricb66x)" }, status: { success: { surface: "var(--palette-status-success-surface__1lricb66y)", text: "var(--palette-status-success-text__1lricb66z)", icon: "var(--palette-status-success-icon__1lricb670)", fill: { fill: "var(--palette-status-success-fill-fill__1lricb671)", onFill: "var(--palette-status-success-fill-onFill__1lricb672)", hover: "var(--palette-status-success-fill-hover__1lricb673)", active: "var(--palette-status-success-fill-active__1lricb674)", selected: "var(--palette-status-success-fill-selected__1lricb675)" }, border: "var(--palette-status-success-border__1lricb676)" }, caution: { surface: "var(--palette-status-caution-surface__1lricb677)", text: "var(--palette-status-caution-text__1lricb678)", icon: "var(--palette-status-caution-icon__1lricb679)", fill: { fill: "var(--palette-status-caution-fill-fill__1lricb67a)", onFill: "var(--palette-status-caution-fill-onFill__1lricb67b)", hover: "var(--palette-status-caution-fill-hover__1lricb67c)", active: "var(--palette-status-caution-fill-active__1lricb67d)", selected: "var(--palette-status-caution-fill-selected__1lricb67e)" }, border: "var(--palette-status-caution-border__1lricb67f)" }, warning: { surface: "var(--palette-status-warning-surface__1lricb67g)", text: "var(--palette-status-warning-text__1lricb67h)", icon: "var(--palette-status-warning-icon__1lricb67i)", fill: { fill: "var(--palette-status-warning-fill-fill__1lricb67j)", onFill: "var(--palette-status-warning-fill-onFill__1lricb67k)", hover: "var(--palette-status-warning-fill-hover__1lricb67l)", active: "var(--palette-status-warning-fill-active__1lricb67m)", selected: "var(--palette-status-warning-fill-selected__1lricb67n)" }, border: "var(--palette-status-warning-border__1lricb67o)" }, critical: { surface: "var(--palette-status-critical-surface__1lricb67p)", text: "var(--palette-status-critical-text__1lricb67q)", icon: "var(--palette-status-critical-icon__1lricb67r)", fill: { fill: "var(--palette-status-critical-fill-fill__1lricb67s)", onFill: "var(--palette-status-critical-fill-onFill__1lricb67t)", hover: "var(--palette-status-critical-fill-hover__1lricb67u)", active: "var(--palette-status-critical-fill-active__1lricb67v)", selected: "var(--palette-status-critical-fill-selected__1lricb67w)" }, border: "var(--palette-status-critical-border__1lricb67x)" } }, primitives: { brandWhite1000: "var(--palette-primitives-brandWhite1000__1lricb67y)", brandWhite800: "var(--palette-primitives-brandWhite800__1lricb67z)", brandWhite600: "var(--palette-primitives-brandWhite600__1lricb680)", brandWhite400: "var(--palette-primitives-brandWhite400__1lricb681)", brandWhite200: "var(--palette-primitives-brandWhite200__1lricb682)", brandBlack1000: "var(--palette-primitives-brandBlack1000__1lricb683)", brandBlack900: "var(--palette-primitives-brandBlack900__1lricb684)", brandBlack800: "var(--palette-primitives-brandBlack800__1lricb685)", brandBlack700: "var(--palette-primitives-brandBlack700__1lricb686)", brandBlack600: "var(--palette-primitives-brandBlack600__1lricb687)", brandBlack500: "var(--palette-primitives-brandBlack500__1lricb688)", brandBlack400: "var(--palette-primitives-brandBlack400__1lricb689)", brandBlack300: "var(--palette-primitives-brandBlack300__1lricb68a)", brandBlack200: "var(--palette-primitives-brandBlack200__1lricb68b)", brandBlack100: "var(--palette-primitives-brandBlack100__1lricb68c)", brandBlack50: "var(--palette-primitives-brandBlack50__1lricb68d)", brandBlack25: "var(--palette-primitives-brandBlack25__1lricb68e)", brandBlue1100: "var(--palette-primitives-brandBlue1100__1lricb68f)", brandBlue1000: "var(--palette-primitives-brandBlue1000__1lricb68g)", brandBlue900: "var(--palette-primitives-brandBlue900__1lricb68h)", brandBlue800: "var(--palette-primitives-brandBlue800__1lricb68i)", brandBlue700: "var(--palette-primitives-brandBlue700__1lricb68j)", brandBlue600: "var(--palette-primitives-brandBlue600__1lricb68k)", brandBlue500: "var(--palette-primitives-brandBlue500__1lricb68l)", brandBlue400: "var(--palette-primitives-brandBlue400__1lricb68m)", brandBlue300: "var(--palette-primitives-brandBlue300__1lricb68n)", brandBlue200: "var(--palette-primitives-brandBlue200__1lricb68o)", brandBlue100: "var(--palette-primitives-brandBlue100__1lricb68p)", brandBlue50: "var(--palette-primitives-brandBlue50__1lricb68q)", brandAqua1000: "var(--palette-primitives-brandAqua1000__1lricb68r)", brandAqua900: "var(--palette-primitives-brandAqua900__1lricb68s)", brandAqua800: "var(--palette-primitives-brandAqua800__1lricb68t)", brandAqua700: "var(--palette-primitives-brandAqua700__1lricb68u)", brandAqua600: "var(--palette-primitives-brandAqua600__1lricb68v)", brandAqua500: "var(--palette-primitives-brandAqua500__1lricb68w)", brandAqua400: "var(--palette-primitives-brandAqua400__1lricb68x)", brandAqua300: "var(--palette-primitives-brandAqua300__1lricb68y)", brandAqua200: "var(--palette-primitives-brandAqua200__1lricb68z)", brandAqua100: "var(--palette-primitives-brandAqua100__1lricb690)", brandAqua50: "var(--palette-primitives-brandAqua50__1lricb691)", brandAqua10: "var(--palette-primitives-brandAqua10__1lricb692)", brandGreen1000: "var(--palette-primitives-brandGreen1000__1lricb693)", brandGreen900: "var(--palette-primitives-brandGreen900__1lricb694)", brandGreen800: "var(--palette-primitives-brandGreen800__1lricb695)", brandGreen700: "var(--palette-primitives-brandGreen700__1lricb696)", brandGreen600: "var(--palette-primitives-brandGreen600__1lricb697)", brandGreen500: "var(--palette-primitives-brandGreen500__1lricb698)", brandGreen400: "var(--palette-primitives-brandGreen400__1lricb699)", brandGreen300: "var(--palette-primitives-brandGreen300__1lricb69a)", brandGreen200: "var(--palette-primitives-brandGreen200__1lricb69b)", brandGreen100: "var(--palette-primitives-brandGreen100__1lricb69c)", brandGreen50: "var(--palette-primitives-brandGreen50__1lricb69d)", brandCoral1000: "var(--palette-primitives-brandCoral1000__1lricb69e)", brandCoral900: "var(--palette-primitives-brandCoral900__1lricb69f)", brandCoral800: "var(--palette-primitives-brandCoral800__1lricb69g)", brandCoral700: "var(--palette-primitives-brandCoral700__1lricb69h)", brandCoral600: "var(--palette-primitives-brandCoral600__1lricb69i)", brandCoral500: "var(--palette-primitives-brandCoral500__1lricb69j)", brandCoral400: "var(--palette-primitives-brandCoral400__1lricb69k)", brandCoral300: "var(--palette-primitives-brandCoral300__1lricb69l)", brandCoral200: "var(--palette-primitives-brandCoral200__1lricb69m)", brandCoral100: "var(--palette-primitives-brandCoral100__1lricb69n)", brandCoral50: "var(--palette-primitives-brandCoral50__1lricb69o)", systemGreen1000: "var(--palette-primitives-systemGreen1000__1lricb69p)", systemGreen900: "var(--palette-primitives-systemGreen900__1lricb69q)", systemGreen800: "var(--palette-primitives-systemGreen800__1lricb69r)", systemGreen700: "var(--palette-primitives-systemGreen700__1lricb69s)", systemGreen600: "var(--palette-primitives-systemGreen600__1lricb69t)", systemGreen500: "var(--palette-primitives-systemGreen500__1lricb69u)", systemGreen400: "var(--palette-primitives-systemGreen400__1lricb69v)", systemGreen300: "var(--palette-primitives-systemGreen300__1lricb69w)", systemGreen200: "var(--palette-primitives-systemGreen200__1lricb69x)", systemGreen100: "var(--palette-primitives-systemGreen100__1lricb69y)", systemGreen50: "var(--palette-primitives-systemGreen50__1lricb69z)", systemYellow1000: "var(--palette-primitives-systemYellow1000__1lricb6a0)", systemYellow900: "var(--palette-primitives-systemYellow900__1lricb6a1)", systemYellow800: "var(--palette-primitives-systemYellow800__1lricb6a2)", systemYellow700: "var(--palette-primitives-systemYellow700__1lricb6a3)", systemYellow600: "var(--palette-primitives-systemYellow600__1lricb6a4)", systemYellow500: "var(--palette-primitives-systemYellow500__1lricb6a5)", systemYellow400: "var(--palette-primitives-systemYellow400__1lricb6a6)", systemYellow300: "var(--palette-primitives-systemYellow300__1lricb6a7)", systemYellow200: "var(--palette-primitives-systemYellow200__1lricb6a8)", systemYellow100: "var(--palette-primitives-systemYellow100__1lricb6a9)", systemYellow50: "var(--palette-primitives-systemYellow50__1lricb6aa)", systemAmber1000: "var(--palette-primitives-systemAmber1000__1lricb6ab)", systemAmber900: "var(--palette-primitives-systemAmber900__1lricb6ac)", systemAmber800: "var(--palette-primitives-systemAmber800__1lricb6ad)", systemAmber700: "var(--palette-primitives-systemAmber700__1lricb6ae)", systemAmber600: "var(--palette-primitives-systemAmber600__1lricb6af)", systemAmber500: "var(--palette-primitives-systemAmber500__1lricb6ag)", systemAmber400: "var(--palette-primitives-systemAmber400__1lricb6ah)", systemAmber300: "var(--palette-primitives-systemAmber300__1lricb6ai)", systemAmber200: "var(--palette-primitives-systemAmber200__1lricb6aj)", systemAmber100: "var(--palette-primitives-systemAmber100__1lricb6ak)", systemAmber50: "var(--palette-primitives-systemAmber50__1lricb6al)", systemRed1000: "var(--palette-primitives-systemRed1000__1lricb6am)", systemRed900: "var(--palette-primitives-systemRed900__1lricb6an)", systemRed800: "var(--palette-primitives-systemRed800__1lricb6ao)", systemRed700: "var(--palette-primitives-systemRed700__1lricb6ap)", systemRed600: "var(--palette-primitives-systemRed600__1lricb6aq)", systemRed500: "var(--palette-primitives-systemRed500__1lricb6ar)", systemRed400: "var(--palette-primitives-systemRed400__1lricb6as)", systemRed300: "var(--palette-primitives-systemRed300__1lricb6at)", systemRed200: "var(--palette-primitives-systemRed200__1lricb6au)", systemRed100: "var(--palette-primitives-systemRed100__1lricb6av)", systemRed50: "var(--palette-primitives-systemRed50__1lricb6aw)" } }, spacing: { space: { none: "var(--spacing-space-none__1lricb6ax)", xxs: "var(--spacing-space-xxs__1lricb6ay)", xs: "var(--spacing-space-xs__1lricb6az)", sm: "var(--spacing-space-sm__1lricb6b0)", md: "var(--spacing-space-md__1lricb6b1)", lg: "var(--spacing-space-lg__1lricb6b2)", xl: "var(--spacing-space-xl__1lricb6b3)", "2xl": "var(--spacing-space-2xl__1lricb6b4)", "3xl": "var(--spacing-space-3xl__1lricb6b5)", "4xl": "var(--spacing-space-4xl__1lricb6b6)", "5xl": "var(--spacing-space-5xl__1lricb6b7)", "6xl": "var(--spacing-space-6xl__1lricb6b8)", "7xl": "var(--spacing-space-7xl__1lricb6b9)", "8xl": "var(--spacing-space-8xl__1lricb6ba)", "9xl": "var(--spacing-space-9xl__1lricb6bb)", "10xl": "var(--spacing-space-10xl__1lricb6bc)", mobile1: "var(--spacing-space-mobile1__1lricb6bd)", mobile2: "var(--spacing-space-mobile2__1lricb6be)", desktop1: "var(--spacing-space-desktop1__1lricb6bf)", desktop2: "var(--spacing-space-desktop2__1lricb6bg)", desktop3: "var(--spacing-space-desktop3__1lricb6bh)", desktop4: "var(--spacing-space-desktop4__1lricb6bi)", desktop5: "var(--spacing-space-desktop5__1lricb6bj)", positive: { "100": "var(--spacing-space-positive-100__1lricb6bk)", "200": "var(--spacing-space-positive-200__1lricb6bl)", "300": "var(--spacing-space-positive-300__1lricb6bm)", "400": "var(--spacing-space-positive-400__1lricb6bn)", "500": "var(--spacing-space-positive-500__1lricb6bo)", "600": "var(--spacing-space-positive-600__1lricb6bp)", "800": "var(--spacing-space-positive-800__1lricb6bq)", "900": "var(--spacing-space-positive-900__1lricb6br)", "1000": "var(--spacing-space-positive-1000__1lricb6bs)", "1400": "var(--spacing-space-positive-1400__1lricb6bt)", "1600": "var(--spacing-space-positive-1600__1lricb6bu)", "2400": "var(--spacing-space-positive-2400__1lricb6bv)", "4000": "var(--spacing-space-positive-4000__1lricb6bw)" }, negative: { "-100": "var(--spacing-space-negative--100__1lricb6bx)", "-200": "var(--spacing-space-negative--200__1lricb6by)", "-300": "var(--spacing-space-negative--300__1lricb6bz)", "-400": "var(--spacing-space-negative--400__1lricb6c0)", "-600": "var(--spacing-space-negative--600__1lricb6c1)", "-800": "var(--spacing-space-negative--800__1lricb6c2)" } }, radius: { "100": "var(--spacing-radius-100__1lricb6c3)", "200": "var(--spacing-radius-200__1lricb6c4)", "400": "var(--spacing-radius-400__1lricb6c5)", "800": "var(--spacing-radius-800__1lricb6c6)", "1600": "var(--spacing-radius-1600__1lricb6c7)", none: "var(--spacing-radius-none__1lricb6c8)", small: "var(--spacing-radius-small__1lricb6c9)", medium: "var(--spacing-radius-medium__1lricb6ca)", large: "var(--spacing-radius-large__1lricb6cb)", xLarge: "var(--spacing-radius-xLarge__1lricb6cc)", full: "var(--spacing-radius-full__1lricb6cd)" } }, shadow: { "0dp": "var(--shadow-0dp__1lricb6ce)", "3dp": "var(--shadow-3dp__1lricb6cf)", "6dp": "var(--shadow-6dp__1lricb6cg)", "12dp": "var(--shadow-12dp__1lricb6ch)", "24dp": "var(--shadow-24dp__1lricb6ci)", "48dp": "var(--shadow-48dp__1lricb6cj)", drop: { "100": "var(--shadow-drop-100__1lricb6ck)", "200": "var(--shadow-drop-200__1lricb6cl)", "300": "var(--shadow-drop-300__1lricb6cm)", "400": "var(--shadow-drop-400__1lricb6cn)", "500": "var(--shadow-drop-500__1lricb6co)", "600": "var(--shadow-drop-600__1lricb6cp)" }, inner: { "100": "var(--shadow-inner-100__1lricb6cq)", "200": "var(--shadow-inner-200__1lricb6cr)", "300": "var(--shadow-inner-300__1lricb6cs)", "400": "var(--shadow-inner-400__1lricb6ct)", "500": "var(--shadow-inner-500__1lricb6cu)", "600": "var(--shadow-inner-600__1lricb6cv)" } }, blur: { overlay: { background: "var(--blur-overlay-background__1lricb6cw)", backdropFilter: "var(--blur-overlay-backdropFilter__1lricb6cx)" }, blanket: { background: "var(--blur-blanket-background__1lricb6cy)", backdropFilter: "var(--blur-blanket-backdropFilter__1lricb6cz)" }, layer: { background: "var(--blur-layer-background__1lricb6d0)", backdropFilter: "var(--blur-layer-backdropFilter__1lricb6d1)" }, glass: { background: "var(--blur-glass-background__1lricb6d2)", backdropFilter: "var(--blur-glass-backdropFilter__1lricb6d3)" } } };
const Skeleton = ({ className }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { margin: vars.spacing.space.sm }, className: classNames(skeleton$2, className) });
};
const Accordion$1 = ({
  className,
  children,
  size,
  variant = "primary",
  disabled: disabled2
}) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(layout$a, className), children: React__default.Children.map(
  children,
  (child) => React__default.isValidElement(child) ? React__default.cloneElement(child, { size, variant, disabled: disabled2, ...(child == null ? void 0 : child.props) ?? {} }) : child
) });
Accordion$1.Item = Item$2;
Accordion$1.Header = Header$1;
Accordion$1.Content = Content$4;
Accordion$1.Skeleton = Skeleton;
var icon$4 = "checkbox_icon__o3zwnu0";
var i16 = "checkbox_i16__o3zwnu1";
var i24 = "checkbox_i24__o3zwnu2";
var checked$1 = "checkbox_checked__o3zwnu3";
var layout$9 = "checkbox_layout__o3zwnu4";
var skeleton$1 = "checkbox_skeleton__o3zwnu5";
const sizes$c = {
  i16,
  i24
};
function getNextValue(array, current) {
  const index = array.indexOf(current);
  const nextIndex = (index + 1) % array.length;
  return array[nextIndex];
}
const Checkbox = ({
  children,
  className,
  checked: _checked,
  indeterminate,
  skeleton: skeleton2,
  disabled: disabled2,
  size = "i24",
  onChange
}) => {
  const values2 = React__default.useMemo(() => {
    const vals = [false, true];
    if (indeterminate) {
      vals.push("indeterminate");
    }
    return vals;
  }, [indeterminate]);
  const [checked2, setChecked] = React__default.useState(_checked ?? false);
  const icon2 = React__default.useMemo(() => {
    if (skeleton2) {
      return "checkbox";
    }
    switch (checked2) {
      case true:
        return "checkbox-fill";
      case false:
        return "checkbox";
      case "indeterminate":
        return "checkbox-indeterminate";
      default:
        return "";
    }
  }, [checked2, skeleton2]);
  const handleCheck = React__default.useCallback(() => {
    if (!disabled2) {
      const newValue = getNextValue(values2, checked2);
      setChecked(newValue);
      onChange == null ? void 0 : onChange(newValue);
    }
  }, [checked2, disabled2, values2, onChange]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames(layout$9, className), onClick: handleCheck, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Icon$1,
      {
        className: classNames(icon$4, sizes$c[size], {
          [checked$1]: typeof checked2 === "boolean" && checked2,
          "d-disabled": disabled2 || skeleton2
        }),
        name: icon2
      }
    ),
    skeleton2 ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: skeleton$1 }) : children
  ] });
};
var wrapper$1 = "toggle_wrapper__ol5u1u0";
var dotSmall = "toggle_dotSmall__ol5u1u3 toggle_dot__ol5u1u2";
var dotLarge = "toggle_dotLarge__ol5u1u4 toggle_dot__ol5u1u2";
var small$5 = "toggle_small__ol5u1u5 toggle_layout__ol5u1u1";
var large$5 = "toggle_large__ol5u1u6 toggle_layout__ol5u1u1";
var disabled$6 = "toggle_disabled__ol5u1u7";
const sizes$b = {
  small: small$5,
  large: large$5
};
const dotSizes = {
  small: dotSmall,
  large: dotLarge
};
const Toggle = ({
  children,
  className,
  size = "large",
  checked: _checked,
  disabled: disabled2,
  onChange
}) => {
  const [checked2, setChecked] = React__default.useState(_checked ?? false);
  const handleCheck = React__default.useCallback(() => {
    if (!disabled2) {
      setChecked((prev2) => {
        onChange == null ? void 0 : onChange(!prev2);
        return !prev2;
      });
    }
  }, [disabled2, onChange]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames(wrapper$1, className), onClick: handleCheck, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(sizes$b[size], { [disabled$6]: disabled2, "d-checked": checked2 }), children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(dotSizes[size], { "d-checked": checked2 }) }) }),
    children
  ] });
};
var wrapper = "radio_wrapper__1yqva740";
var small$4 = "radio_small__1yqva742 radio_layout__1yqva741";
var large$4 = "radio_large__1yqva743 radio_layout__1yqva741";
var dot = "radio_dot__1yqva744";
var checked = "radio_checked__1yqva745";
var disabled$5 = "radio_disabled__1yqva746";
const sizes$a = {
  small: small$4,
  large: large$4
};
const Radio = ({
  className,
  children,
  size = "small",
  value: value2,
  onChange,
  disabled: disabled2,
  selected
}) => {
  const handleSelect = React__default.useCallback(() => {
    onChange == null ? void 0 : onChange(value2);
  }, [onChange, value2]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { onClick: handleSelect, className: classNames(wrapper, className), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(sizes$a[size], { [disabled$5]: disabled2 }), children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(dot, { [checked]: selected }) }) }),
    children
  ] });
};
var treatmentXL = "tag_treatmentXL__1rb0w5w1 tag_treatmentBase__1rb0w5w0";
var treatmentLarge = "tag_treatmentLarge__1rb0w5w2 tag_treatmentBase__1rb0w5w0";
var treatmentSmall = "tag_treatmentSmall__1rb0w5w3 tag_treatmentBase__1rb0w5w0";
var dashboardLarge = "tag_dashboardLarge__1rb0w5w5 tag_dashboardBase__1rb0w5w4";
var dashboardSmall = "tag_dashboardSmall__1rb0w5w6 tag_dashboardBase__1rb0w5w4";
var dashboardPrimary = "tag_dashboardPrimary__1rb0w5w7";
var dashboardSecondary = "tag_dashboardSecondary__1rb0w5w8";
var disabled$4 = "tag_disabled__1rb0w5w9";
var betaMobile = "tag_betaMobile__1rb0w5wb tag_betaBase__1rb0w5wa";
var betaDesktop = "tag_betaDesktop__1rb0w5wc tag_betaBase__1rb0w5wa";
var newMobile = "tag_newMobile__1rb0w5we tag_newBase__1rb0w5wd tag_betaBase__1rb0w5wa";
var newDesktop = "tag_newDesktop__1rb0w5wf tag_newBase__1rb0w5wd tag_betaBase__1rb0w5wa";
var notificationMobile = "tag_notificationMobile__1rb0w5wh tag_notificationBase__1rb0w5wg";
var notificationDesktop = "tag_notificationDesktop__1rb0w5wi tag_notificationBase__1rb0w5wg";
const sizes$9 = {
  small: treatmentSmall,
  large: treatmentLarge,
  XL: treatmentXL
};
const Treatment = ({ className, children, onClick, selected, ticked, size = "XL", disabled: disabled2 }) => {
  const handleClick = React__default.useCallback(() => {
    onClick == null ? void 0 : onClick();
  }, [onClick]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "button",
    {
      onClick: handleClick,
      className: classNames(className, sizes$9[size], {
        [disabled$4]: disabled2,
        "d-ticked": ticked,
        "d-selected": selected
      }),
      children: [
        ticked ? /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M19.1666 9.99998C19.1666 15.0626 15.0626 19.1666 9.99998 19.1666C4.93737 19.1666 0.833313 15.0626 0.833313 9.99998C0.833313 4.93737 4.93737 0.833313 9.99998 0.833313C15.0626 0.833313 19.1666 4.93737 19.1666 9.99998ZM4.99998 10.35L6.17498 9.17498L8.33331 11.325L13.825 5.83331L15 7.01665L8.33331 13.6833L4.99998 10.35Z",
            fill: disabled2 ? vars.palette.primitives.brandBlack800 : vars.palette.primitives.brandAqua800
          }
        ) }) : null,
        children
      ]
    }
  );
};
const sizes$8 = {
  small: dashboardSmall,
  large: dashboardLarge
};
const variants$3 = {
  primary: dashboardPrimary,
  secondary: dashboardSecondary
};
const Dashboard = ({ className, size = "large", variant = "primary", disabled: disabled2, children, onClick }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "button",
    {
      onClick,
      className: classNames(className, sizes$8[size], variants$3[variant], { [disabled$4]: disabled2 }),
      children
    }
  );
};
const sizes$7 = {
  mobile: notificationMobile,
  desktop: notificationDesktop
};
const Notification$1 = ({ className, children, size = "desktop", onClick }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick, className: classNames(className, sizes$7[size]), children });
};
const sizes$6 = {
  mobile: newMobile,
  desktop: newDesktop
};
const New = ({ className, size = "desktop", onClick }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick, className: classNames(className, sizes$6[size]), children: "New" });
};
const sizes$5 = {
  mobile: betaMobile,
  desktop: betaDesktop
};
const Beta = ({ className, size = "desktop", onClick }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick, className: classNames(className, sizes$5[size]), children: "Beta" });
};
const Tag = () => /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
Tag.Treatment = Treatment;
Tag.Dashboard = Dashboard;
Tag.Notification = Notification$1;
Tag.New = New;
Tag.Beta = Beta;
var container$e = "progressBar_container__ktq3gp0";
var fill = "progressBar_fill__ktq3gp1";
const ProgressBar = ({ className, current, total: total2 }) => {
  const width2 = React__default.useMemo(() => {
    if (current >= total2) {
      return "100%";
    }
    return `${Math.ceil(current / total2 * 100)}%`;
  }, [current, total2]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(className, container$e), children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { width: width2 }, className: fill }) });
};
var layout$8 = "input_layout__ivi6w50";
var layoutDisabled$1 = "input_layoutDisabled__ivi6w51";
var input = "input_input__ivi6w52";
var small$3 = "input_small__ivi6w53 input_layout__ivi6w50";
var medium$3 = "input_medium__ivi6w54 input_layout__ivi6w50";
var large$3 = "input_large__ivi6w55 input_layout__ivi6w50";
var statusError$1 = "input_statusError__ivi6w56";
var statusSuccess$1 = "input_statusSuccess__ivi6w57";
var statusWarning$1 = "input_statusWarning__ivi6w58";
var statusInfo$1 = "input_statusInfo__ivi6w59";
const sizes$4 = {
  small: small$3,
  medium: medium$3,
  large: large$3
};
const statuses$1 = {
  success: statusSuccess$1,
  error: statusError$1,
  warning: statusWarning$1,
  info: statusInfo$1
};
const Input = ({
  className,
  value: value2,
  onChange,
  size = "medium",
  status,
  placeholder,
  disabled: disabled2
}) => {
  const [focused, setFocused] = React__default.useState(false);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: classNames(layout$8, sizes$4[size], className, {
        [layoutDisabled$1]: disabled2,
        [status ? statuses$1[status] : ""]: status
      }),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        "input",
        {
          onFocus: () => setFocused(true),
          onBlur: () => setFocused(false),
          disabled: disabled2,
          className: classNames(input, { "d-focus": focused }),
          value: value2,
          onChange: (e) => onChange == null ? void 0 : onChange(e.target.value),
          placeholder
        }
      )
    }
  );
};
var layout$7 = "dropdown_layout__1qtup7m0";
var optionsContainer = "dropdown_optionsContainer__1qtup7m1 commonStyles_scrollBar__e0bve42";
var optionsContainerSmall = "dropdown_optionsContainerSmall__1qtup7m2";
var optionsContainerMedium = "dropdown_optionsContainerMedium__1qtup7m3";
var optionsContainerLarge = "dropdown_optionsContainerMedium__1qtup7m3";
var dropdownTrigger = "dropdown_dropdownTrigger__1qtup7m4";
var layoutDisabled = "dropdown_layoutDisabled__1qtup7m5";
var small$2 = "dropdown_small__1qtup7m7";
var medium$2 = "dropdown_medium__1qtup7m8";
var large$2 = "dropdown_large__1qtup7m9";
var smallLayout = "dropdown_smallLayout__1qtup7ma dropdown_small__1qtup7m7";
var mediumLayout = "dropdown_mediumLayout__1qtup7mb dropdown_medium__1qtup7m8";
var largeLayout = "dropdown_largeLayout__1qtup7mc dropdown_large__1qtup7m9";
var defaultVariant = "dropdown_defaultVariant__1qtup7md";
var filterVariant = "dropdown_filterVariant__1qtup7me";
var statusError = "dropdown_statusError__1qtup7mf";
var statusSuccess = "dropdown_statusSuccess__1qtup7mg";
var statusWarning = "dropdown_statusWarning__1qtup7mh";
var statusInfo = "dropdown_statusInfo__1qtup7mi";
var skeleton = "dropdown_skeleton__1qtup7mj";
var itemLayout = "dropdown_itemLayout__1qtup7mk";
const sizes$3 = {
  small: small$2,
  medium: medium$2,
  large: large$2
};
const Item$1 = ({ children, size = "medium", onChange, value: value2, keepOpen }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "div",
  {
    className: classNames(sizes$3[size], itemLayout),
    onClick: (event) => {
      event.preventDefault();
      if (keepOpen) {
        event.stopPropagation();
      }
      onChange == null ? void 0 : onChange(value2);
    },
    children
  }
);
Item$1.displayName = "Dropdown.Item";
const layoutSizes = {
  small: smallLayout,
  medium: mediumLayout,
  large: largeLayout
};
const optionsContainerSizes = {
  small: optionsContainerSmall,
  medium: optionsContainerMedium,
  large: optionsContainerLarge
};
const statuses = {
  success: statusSuccess,
  error: statusError,
  warning: statusWarning,
  info: statusInfo
};
const variants$2 = {
  default: defaultVariant,
  filter: filterVariant
};
const Dropdown = ({
  className,
  value: value2,
  onChange,
  size = "medium",
  variant = "default",
  status,
  placeholder,
  disabled: disabled2,
  children,
  skeleton: skeleton$12
}) => {
  const [open, setOpen] = React__default.useState(false);
  const [coords, setCoords] = React__default.useState({ top: 0, left: 0 });
  const [optionWidth, setOptionWidth] = React__default.useState(0);
  const containerRef = React__default.useRef(null);
  const optionsRef = React__default.useRef(null);
  const updatePosition = () => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      const computedStyle = window.getComputedStyle(containerRef.current);
      const borderLeft2 = parseFloat(computedStyle.borderLeftWidth);
      const borderRight2 = parseFloat(computedStyle.borderRightWidth);
      setOptionWidth(rect.width - borderLeft2 - borderRight2);
      setCoords({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX
      });
    }
  };
  React__default.useLayoutEffect(() => {
    if (!open) {
      return;
    }
    updatePosition();
    const handleClickOutside = (event) => {
      const target = event.target;
      if (containerRef.current && !containerRef.current.contains(target) && optionsRef.current && !optionsRef.current.contains(target)) {
        setOpen(false);
      }
    };
    window.addEventListener("scroll", updatePosition, true);
    window.addEventListener("resize", updatePosition);
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener("scroll", updatePosition, true);
      window.removeEventListener("resize", updatePosition);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      ref: containerRef,
      className: classNames(layout$7, layoutSizes[size], variants$2[variant], className, {
        [layoutDisabled]: disabled2,
        [status ? statuses[status] : ""]: status,
        "d-open": open,
        [skeleton]: skeleton$12
      }),
      onClick: () => {
        if (!disabled2 && !skeleton$12) {
          setOpen((prev2) => !prev2);
        }
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: dropdownTrigger, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("button", { children: value2 || placeholder }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { className: classNames({ "d-open": open }), name: "chevron_down" })
        ] }),
        open ? /* @__PURE__ */ jsxRuntimeExports.jsx(Portal, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "div",
          {
            ref: optionsRef,
            className: classNames(optionsContainer, optionsContainerSizes[size], `d-${variant}`),
            style: {
              top: coords.top,
              left: coords.left,
              width: optionWidth
            },
            children: React__default.Children.map(
              children,
              (child) => React__default.isValidElement(child) ? React__default.cloneElement(child, {
                size,
                onChange,
                ...(child == null ? void 0 : child.props) ?? {}
              }) : child
            )
          }
        ) }) : null
      ]
    }
  );
};
Dropdown.Item = Item$1;
var layout$6 = "formInput_layout__1y7x5o20";
var label$3 = "formInput_label__1y7x5o21";
const SystemMessage = ({
  children,
  variant = "info",
  CTAClick,
  CTAText,
  onClose
}) => {
  return children ? /* @__PURE__ */ jsxRuntimeExports.jsxs(SystemMessage$1, { variant, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: flexCenter, style: { gap: vars.spacing.space.sm }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(SystemMessage$1.Icon, {}),
      children
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: flexCenter, style: { gap: vars.spacing.space.sm }, children: [
      CTAText ? /* @__PURE__ */ jsxRuntimeExports.jsx(SystemMessage$1.CTA, { variant, onClick: CTAClick, children: CTAText }) : null,
      onClose ? /* @__PURE__ */ jsxRuntimeExports.jsx(SystemMessage$1.Close, { onClick: onClose, color: CTAText ? "#051851" : "" }) : null
    ] })
  ] }) : null;
};
const Label = ({ className, children, disabled: disabled2, required }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames(className, label$3, { "d-disabled": disabled2 }), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children }),
    required ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { color: vars.palette.primitives.brandCoral700 }, children: "*" }) : null
  ] });
};
const Description$1 = ({ className, children, disabled: disabled2 }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(className, label$3, { "d-disabled": disabled2 }), children });
};
const FormInput$1 = ({ className, children, disabled: disabled2, status, size }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(layout$6, className), children: React__default.Children.map(
    children,
    (child) => React__default.isValidElement(child) ? React__default.cloneElement(child, {
      disabled: disabled2,
      status,
      variant: status,
      size,
      ...(child == null ? void 0 : child.props) ?? {}
    }) : child
  ) });
};
FormInput$1.Label = Label;
FormInput$1.SystemMessage = SystemMessage;
FormInput$1.Description = Description$1;
const TooltipContext = createContext(null);
const useTooltipContext = () => {
  const ctx = useContext(TooltipContext);
  if (!ctx) {
    throw new Error("Tooltip.* must be used inside <Tooltip>");
  }
  return ctx;
};
var content$2 = "tooltip_content__15dj640";
var light = "tooltip_light__15dj641";
var dark = "tooltip_dark__15dj642";
var triggerContainer = "tooltip_triggerContainer__15dj644";
var top = "tooltip_top__15dj645 tooltip_positionBase__15dj643";
var right = "tooltip_right__15dj646 tooltip_positionBase__15dj643";
var bottom = "tooltip_bottom__15dj647 tooltip_positionBase__15dj643";
var left = "tooltip_left__15dj648 tooltip_positionBase__15dj643";
var fullWidth = "tooltip_fullWidth__15dj649";
const AUTO_CLOSE_DELAY = 2e3;
const Trigger = ({ children, fullWidth: fullWidth$12 }) => {
  const { setOpen, triggerRef, trigger } = useTooltipContext();
  const timeoutRef = useRef(null);
  const openWithDelay = useCallback(() => {
    setOpen(true);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => setOpen(false), AUTO_CLOSE_DELAY);
  }, [setOpen]);
  if (trigger === "click") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        style: { cursor: "pointer" },
        ref: triggerRef,
        onClick: openWithDelay,
        className: classNames({ [fullWidth]: fullWidth$12 }),
        children
      }
    );
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: classNames(triggerContainer, { [fullWidth]: fullWidth$12 }),
      ref: triggerRef,
      onMouseEnter: () => setOpen(true),
      onMouseLeave: () => setOpen(false),
      onTouchStart: () => setOpen(true),
      onTouchEnd: () => setOpen(false),
      children
    }
  );
};
Trigger.displayName = "Tooltip.Trigger";
const variants$1 = {
  light,
  dark
};
const positions = {
  top,
  right,
  bottom,
  left
};
const Content$3 = ({ children }) => {
  const { open, triggerRef, position: position2, variant } = useTooltipContext();
  const [actualPosition, setActualPosition] = React__default.useState(position2);
  const [coords, setCoords] = React__default.useState({ top: 0, left: 0 });
  const contentRef = React__default.useRef(null);
  React__default.useLayoutEffect(() => {
    if (!open || !triggerRef.current || !contentRef.current) {
      return;
    }
    const triggerRect = triggerRef.current.getBoundingClientRect();
    const contentRect = contentRef.current.getBoundingClientRect();
    const spacing = 16;
    let top2 = 0;
    let left2 = 0;
    const positions2 = {
      top: () => {
        top2 = triggerRect.top - contentRect.height - spacing;
        left2 = triggerRect.left + triggerRect.width / 2 - contentRect.width / 2;
      },
      bottom: () => {
        top2 = triggerRect.bottom + spacing;
        left2 = triggerRect.left + triggerRect.width / 2 - contentRect.width / 2;
      },
      left: () => {
        top2 = triggerRect.top + triggerRect.height / 2 - contentRect.height / 2;
        left2 = triggerRect.left - contentRect.width - spacing;
      },
      right: () => {
        top2 = triggerRect.top + triggerRect.height / 2 - contentRect.height / 2;
        left2 = triggerRect.right + spacing;
      }
    };
    positions2[position2]();
    const fitsTop = triggerRect.top >= contentRect.height + spacing;
    const fitsBottom = window.innerHeight - triggerRect.bottom >= contentRect.height + spacing;
    const fitsLeft = triggerRect.left >= contentRect.width + spacing;
    const fitsRight = window.innerWidth - triggerRect.right >= contentRect.width + spacing;
    setActualPosition(position2);
    if (position2 === "top" && !fitsTop && fitsBottom) {
      setActualPosition("bottom");
      positions2.bottom();
    }
    if (position2 === "bottom" && !fitsBottom && fitsTop) {
      setActualPosition("top");
      positions2.top();
    }
    if (position2 === "left" && !fitsLeft && fitsRight) {
      setActualPosition("right");
      positions2.right();
    }
    if (position2 === "right" && !fitsRight && fitsLeft) {
      setActualPosition("left");
      positions2.left();
    }
    top2 = Math.max(0, Math.min(top2, window.innerHeight - contentRect.height));
    left2 = Math.max(0, Math.min(left2, window.innerWidth - contentRect.width));
    setCoords({ top: top2 + window.scrollY, left: left2 + window.scrollX });
  }, [open, position2, triggerRef]);
  if (!open) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Portal, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: classNames(content$2, variants$1[variant], positions[actualPosition]),
      ref: contentRef,
      style: {
        top: coords.top,
        left: coords.left
      },
      children
    }
  ) });
};
Content$3.displayName = "Tooltip.Content";
const Tooltip = ({ children, variant = "light", position: position2 = "top", trigger = "hover" }) => {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef(null);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TooltipContext.Provider, { value: { open, setOpen, triggerRef, position: position2, variant, trigger }, children });
};
Tooltip.Trigger = Trigger;
Tooltip.Content = Content$3;
var layout$5 = "rating_layout__rhavmz0";
var icon$3 = "rating_icon__rhavmz1";
var iconContainer = "rating_iconContainer__rhavmz2";
var iconFilled = "rating_iconFilled__rhavmz3";
var hoverSelect = "rating_hoverSelect__rhavmz4";
var filledLow = "rating_filledLow__rhavmz5";
var filledMedium = "rating_filledMedium__rhavmz6";
var xlSize = "rating_xlSize__rhavmz7";
var largeSize = "rating_largeSize__rhavmz8";
var mediumSize = "rating_mediumSize__rhavmz9";
var smallSize = "rating_smallSize__rhavmza";
var disclaimer = "rating_disclaimer__rhavmzb";
var starContainer = "rating_starContainer__rhavmzc";
const sizes$2 = {
  xl: xlSize,
  large: largeSize,
  medium: mediumSize,
  small: smallSize
};
const DEFAULT_STARS_TOTAL = 5;
const Rating = ({
  className,
  size = "large",
  total: total2 = DEFAULT_STARS_TOTAL,
  value: value2 = 0,
  variant = "preview",
  ...rest
}) => {
  const containerRef = React__default.useRef(null);
  const [hoverNum, setHoverNum] = React__default.useState(0);
  const selectMode = variant === "select";
  const positionDisclaimer = React__default.useCallback(
    (element) => {
      if (containerRef.current && element && element.textContent) {
        const rect = element.getBoundingClientRect();
        const containerRect = containerRef.current.getBoundingClientRect();
        if (rect.left < containerRect.left) {
          element.style.left = "0px";
        } else if (rect.right > containerRect.right) {
          element.style.right = "0px";
        }
      }
    },
    [containerRef]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: containerRef, className: classNames(layout$5, className, { "d-smaller": size === "small" }), children: Array.from({ length: total2 }, (_2, i) => i + 1).map((num, index) => {
    var _a;
    const checkLowValue = (val) => val >= num && val <= Math.ceil(total2 * 0.2);
    const checkMediumValue = (val) => val <= Math.ceil(total2 * 0.6) && val > Math.ceil(total2 / 5) && val >= num;
    const low = selectMode && (checkLowValue(hoverNum) || hoverNum === 0 && checkLowValue(+value2));
    const medium2 = selectMode && (checkMediumValue(hoverNum) || hoverNum === 0 && checkMediumValue(+value2));
    const disclaimerText = selectMode && "starTitles" in rest ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      "div",
      {
        ref: (ref) => {
          positionDisclaimer(ref);
        },
        className: disclaimer,
        children: num === value2 && hoverNum === 0 || num === hoverNum ? (_a = rest.starTitles) == null ? void 0 : _a[index] : ""
      }
    ) : null;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: starContainer,
        style: {
          marginBottom: selectMode && "starTitles" in rest ? vars.spacing.space.xs : vars.spacing.space.none
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            "div",
            {
              onMouseOver: () => setHoverNum(num),
              onMouseLeave: () => setHoverNum(0),
              onClick: () => {
                var _a2;
                if (selectMode && "onSelect" in rest) {
                  (_a2 = rest == null ? void 0 : rest.onSelect) == null ? void 0 : _a2.call(rest, num);
                }
              },
              className: classNames(sizes$2[size], icon$3, {
                [iconContainer]: selectMode,
                [iconFilled]: num <= +value2 && (selectMode ? hoverNum === 0 : true),
                [hoverSelect]: selectMode && hoverNum >= num,
                [filledLow]: low,
                [filledMedium]: medium2
              }),
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { name: "star" })
            }
          ),
          disclaimerText
        ]
      },
      num
    );
  }) });
};
var container$d = "pagination_container__th91he0";
var defaultButton = "pagination_defaultButton__th91he2 pagination_baseButton__th91he1";
var activeButton = "pagination_activeButton__th91he3 pagination_baseButton__th91he1";
var disabledButton = "pagination_disabledButton__th91he4 pagination_baseButton__th91he1";
var ellipsis = "pagination_ellipsis__th91he5";
const PaginationContext = createContext(null);
function usePagination() {
  const ctx = useContext(PaginationContext);
  if (!ctx) {
    throw new Error("Pagination.* must be used inside <Pagination>");
  }
  return ctx;
}
const PageItemBefore = ({ children }) => {
  const { currentPage, onPageChange, startIndex, totalPages } = usePagination();
  const index = startIndex.current++;
  const page = React__default.useMemo(() => {
    if (index === 0) {
      return 1;
    } else {
      const dynamicOffset = index - 1;
      const slidingStart = Math.max(currentPage - 1, 2);
      return slidingStart + dynamicOffset;
    }
  }, [index, currentPage]);
  const active2 = currentPage === page;
  const content2 = React__default.useMemo(() => {
    if (typeof children === "function") {
      return children({ page });
    } else if (React__default.isValidElement(children)) {
      return React__default.cloneElement(children, { page });
    } else {
      return page;
    }
  }, [children, page]);
  return page > 0 && page <= totalPages ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    "span",
    {
      className: classNames({ [activeButton]: active2, [defaultButton]: !active2 }),
      onClick: () => !active2 && (onPageChange == null ? void 0 : onPageChange(page)),
      children: content2
    }
  ) : null;
};
PageItemBefore.displayName = "Pagination.PageItemBefore";
const PageItemAfter = ({ children }) => {
  const { currentPage, totalPages, onPageChange, endIndex, startItemCount } = usePagination();
  const index = endIndex.current++;
  const page = totalPages;
  const slidingStart = React__default.useMemo(() => Math.max(currentPage - 1, 2), [currentPage]);
  const slidingEnd = React__default.useMemo(() => slidingStart + (startItemCount - 2), [slidingStart, startItemCount]);
  const active2 = currentPage === page;
  const content2 = React__default.useMemo(() => {
    if (typeof children === "function") {
      return children({ page });
    } else if (React__default.isValidElement(children)) {
      return React__default.cloneElement(children, { page });
    } else {
      return page;
    }
  }, [children, page]);
  if (index > 0) {
    return null;
  }
  if (page <= slidingEnd) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "span",
    {
      className: classNames({ [activeButton]: active2, [defaultButton]: !active2 }),
      onClick: () => !active2 && (onPageChange == null ? void 0 : onPageChange(page)),
      children: content2
    }
  );
};
PageItemAfter.displayName = "Pagination.PageItemAfter";
const PrevButton = ({ children }) => {
  const { currentPage, onPageChange } = usePagination();
  const disabled2 = currentPage === 1;
  const content2 = React__default.useMemo(() => {
    if (typeof children === "function") {
      return children({ page: currentPage - 1 });
    } else if (React__default.isValidElement(children)) {
      return React__default.cloneElement(children, { page: currentPage - 1 });
    } else {
      return null;
    }
  }, [children, currentPage]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "span",
    {
      className: classNames({ [disabledButton]: disabled2, [defaultButton]: !disabled2 }),
      onClick: () => !disabled2 && (onPageChange == null ? void 0 : onPageChange(currentPage - 1)),
      children: content2 && !disabled2 ? content2 : /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { name: "chevron_left" })
    }
  );
};
PrevButton.displayName = "Pagination.PrevButton";
const NextButton = ({ children }) => {
  const { currentPage, totalPages, onPageChange } = usePagination();
  const disabled2 = currentPage === totalPages;
  const content2 = React__default.useMemo(() => {
    if (typeof children === "function") {
      return children({ page: currentPage + 1 });
    } else if (React__default.isValidElement(children)) {
      return React__default.cloneElement(children, { page: currentPage + 1 });
    } else {
      return null;
    }
  }, [children, currentPage]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "span",
    {
      className: classNames({ [disabledButton]: disabled2, [defaultButton]: !disabled2 }),
      onClick: () => !disabled2 && (onPageChange == null ? void 0 : onPageChange(currentPage + 1)),
      children: content2 && !disabled2 ? content2 : /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { name: "chevron_right" })
    }
  );
};
NextButton.displayName = "Pagination.NextButton";
const Ellipsis = ({}) => {
  const { currentPage, totalPages, ellipsisIndex } = usePagination();
  const which = ellipsisIndex.current++;
  const middleStart = currentPage - 1;
  const middleEnd = currentPage + 1;
  const showStartEllipsis = middleStart > 2;
  const showEndEllipsis = totalPages - middleEnd > 1;
  const shouldRender = which === 0 && showStartEllipsis || which === 1 && showEndEllipsis;
  return shouldRender ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: ellipsis, children: "…" }) : null;
};
Ellipsis.displayName = "Pagination.Ellipsis";
const Pagination = ({ currentPage, totalPages, onPageChange, className, children }) => {
  const startIndex = React__default.useRef(0);
  const endIndex = React__default.useRef(0);
  const ellipsisIndex = React__default.useRef(0);
  startIndex.current = 0;
  endIndex.current = 0;
  ellipsisIndex.current = 0;
  const startItemCount = React__default.Children.toArray(children).filter(
    (child) => {
      var _a;
      return React__default.isValidElement(child) && ((_a = child.type) == null ? void 0 : _a.displayName) === PageItemBefore.displayName;
    }
  ).length;
  const endItemCount = React__default.Children.toArray(children).filter(
    (child) => {
      var _a;
      return React__default.isValidElement(child) && ((_a = child.type) == null ? void 0 : _a.displayName) === PageItemAfter.displayName;
    }
  ).length;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    PaginationContext.Provider,
    {
      value: {
        currentPage,
        totalPages,
        onPageChange,
        startIndex,
        endIndex,
        startItemCount,
        endItemCount,
        ellipsisIndex
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(container$d, className), children })
    }
  );
};
Pagination.PageItemBefore = PageItemBefore;
Pagination.PageItemAfter = PageItemAfter;
Pagination.PrevButton = PrevButton;
Pagination.NextButton = NextButton;
Pagination.Ellipsis = Ellipsis;
var layout$4 = "avatar_layout__1gd3cvn0";
var square = "avatar_square__1gd3cvn1";
var circle = "avatar_circle__1gd3cvn2";
var fakeAvatar = "avatar_fakeAvatar__1gd3cvn3";
var defaultImage = "avatar_defaultImage__1gd3cvn4";
var xl = "avatar_xl__1gd3cvn5";
var large$1 = "avatar_large__1gd3cvn6";
var medium$1 = "avatar_medium__1gd3cvn7";
var small$1 = "avatar_small__1gd3cvn8";
var xs = "avatar_xs__1gd3cvn9";
const sizes$1 = {
  xl,
  large: large$1,
  medium: medium$1,
  small: small$1,
  xs
};
const variants = {
  square,
  circle
};
const Avatar = ({
  className,
  size = "medium",
  variant = "square",
  src,
  claimed = true,
  initials,
  type = "specialist",
  CustomImageComponent,
  dataTestId
}) => {
  const [loadFailed, setLoadFailed] = React__default.useState(false);
  const handleError = React__default.useCallback(() => setLoadFailed(true), []);
  const content2 = React__default.useMemo(() => {
    if (claimed && src && !loadFailed) {
      if (CustomImageComponent) {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(CustomImageComponent, { alt: "avatar-image", src, onError: handleError });
      }
      return /* @__PURE__ */ jsxRuntimeExports.jsx("img", { alt: "avatar-image", src, draggable: false, onError: handleError });
    }
    if (initials) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: fakeAvatar, children: initials });
    }
    if (type === "specialist") {
      return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(fakeAvatar, defaultImage), children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { name: "avatar" }) });
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(fakeAvatar, defaultImage), children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { name: "clinics-mobile" }) });
  }, [loadFailed, src, claimed, initials, type, CustomImageComponent, handleError]);
  React__default.useLayoutEffect(() => setLoadFailed(false), [src]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(layout$4, sizes$1[size], variants[variant], className), "data-testid": dataTestId, children: content2 });
};
const Description = ({ className, content: content2, children, placeholderSize = 0 }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className, children: [
    content2,
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: { display: "flex" }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: { minWidth: placeholderSize, width: placeholderSize } }),
      children
    ] })
  ] });
};
var small = "phoneInput_small__dk9izn0";
var medium = "phoneInput_medium__dk9izn1";
var large = "phoneInput_large__dk9izn2";
var error = "phoneInput_error__dk9izn3";
var layout$3 = "phoneInput_layout__dk9izn4";
const sizes = {
  small,
  medium,
  large
};
class ErrorBoundary extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(error2) {
    return { hasError: true, error: error2 };
  }
  componentDidCatch(error2, errorInfo) {
    console.error("Caught by Error Boundary:", error2, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      return this.props.fallback || /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: "Something went wrong." });
    }
    return this.props.children;
  }
}
const LazyPhoneInput = React__default.lazy(() => import("./ClientSide-BmXhv4j5.mjs"));
const PhoneInput = ({ size = "medium", ...props }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { fallback: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: "Oops! Something broke." }), children: /* @__PURE__ */ jsxRuntimeExports.jsx(Suspense, { fallback: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: sizes[size], children: "Loading phone input…" }), children: /* @__PURE__ */ jsxRuntimeExports.jsx(LazyPhoneInput, { ...props, size }) }) });
};
var container$c = "alphabetSorting_container__zdufqo0";
var letterItem = "alphabetSorting_letterItem__zdufqo1";
var activeLetterItem = "alphabetSorting_activeLetterItem__zdufqo2";
const LAST_KEYWORD_IN_LIST = "last-keyword-in-list";
const AlphabetSorting = ({ sortingList, onSelect, className }) => {
  const [selectedLetter, setSelectedLetter] = useState(null);
  const letters = useMemo(() => {
    const letterMap = /* @__PURE__ */ new Map();
    const filteredSortingList = sortingList.filter((keyword) => !!keyword.letter && !!keyword.id);
    filteredSortingList.forEach((item, index) => {
      letterMap.set(index === filteredSortingList.length - 1 ? LAST_KEYWORD_IN_LIST : item.id, {
        label: item.letter,
        value: item.id
      });
    });
    return Array.from(letterMap.values()).sort((a, b) => a.label.localeCompare(b.label));
  }, [sortingList]);
  const onClick = (id) => {
    setSelectedLetter(id);
    onSelect(id);
  };
  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onClick(e.currentTarget.id);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(container$c, className), children: letters.map((letter, index) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    "span",
    {
      onClick: () => onClick(index === letters.length - 1 ? LAST_KEYWORD_IN_LIST : letter.value),
      className: classNames(letterItem, {
        [activeLetterItem]: selectedLetter === letter.value
      }),
      role: "button",
      tabIndex: 0,
      onKeyDown,
      children: letter.label
    },
    letter.value || index
  )) });
};
var image = "gallery_image__4qq4nv0";
var container$b = "gallery_container__4qq4nv1 commonStyles_scrollBar__e0bve42";
const Gallery = ({ images }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: container$b, children: images.map((src, idx) => /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src, alt: `gallery image ${idx + 1}`, className: classNames(image) }, idx)) });
};
const breakpoints = {
  xl: 1440,
  lg: 1056,
  md: 992,
  sm: 610,
  xsm: 481,
  xs: 0
};
const useBreakpoint = () => {
  const [current, setCurrent] = useState("unknown");
  useEffect(() => {
    const queries = {
      xsm: window.matchMedia(`(max-width: ${breakpoints.xsm - 1}px)`),
      sm: window.matchMedia(`(min-width: ${breakpoints.xsm}px) and (max-width: ${breakpoints.sm - 1}px)`),
      md: window.matchMedia(`(min-width: ${breakpoints.sm}px) and (max-width: ${breakpoints.md - 1}px)`),
      lg: window.matchMedia(`(min-width: ${breakpoints.md}px) and (max-width: ${breakpoints.lg - 1}px)`),
      xl: window.matchMedia(`(min-width: ${breakpoints.lg}px)`)
    };
    const getMatch = () => {
      if (queries.xsm.matches) {
        return "xsm";
      }
      if (queries.sm.matches) {
        return "sm";
      }
      if (queries.md.matches) {
        return "md";
      }
      if (queries.lg.matches) {
        return "lg";
      }
      if (queries.xl.matches) {
        return "xl";
      }
      return "unknown";
    };
    const handler = () => setCurrent(getMatch());
    Object.values(queries).forEach((q) => q.addEventListener("change", handler));
    handler();
    return () => {
      Object.values(queries).forEach((q) => q.removeEventListener("change", handler));
    };
  }, []);
  return current;
};
var tableWrapper = "table_tableWrapper__1jrlejd0";
var tableCell = "table_tableCell__1jrlejd1";
var tableCellContent = "table_tableCellContent__1jrlejd2";
var tableRow = "table_tableRow__1jrlejd3";
var tableHeaderCell = "table_tableHeaderCell__1jrlejd4";
var tableHeaderRow = "table_tableHeaderRow__1jrlejd5";
var mobileHeaderLabel = "table_mobileHeaderLabel__1jrlejd6";
var mobileHeaderHighlight = "table_mobileHeaderHighlight__1jrlejd7";
var mobileChevron = "table_mobileChevron__1jrlejd8";
function getTextFromChildren(children) {
  if (typeof children === "string" || typeof children === "number") {
    return String(children);
  }
  if (Array.isArray(children)) {
    return children.map(getTextFromChildren).join("");
  }
  if (React__default.isValidElement(children)) {
    return getTextFromChildren(children.props.children);
  }
  return "";
}
const TableContext = React__default.createContext({ headers: [], mobileHeadersOrder: [], mobileHeadersHighlight: [], mobileHeadersHidden: [] });
const HeaderRow = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(tableHeaderRow, className), children });
};
const HeaderCell = ({ className, children }) => {
  const { registerHeader } = React__default.useContext(TableContext);
  const text = getTextFromChildren(children);
  React__default.useEffect(() => {
    if (registerHeader) {
      registerHeader(text);
    }
  }, [text, registerHeader]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(tableHeaderCell, className), children });
};
const Row = ({ className, children }) => {
  const { headers, mobileHeadersOrder } = React__default.useContext(TableContext);
  const [open, setOpen] = React__default.useState(false);
  const cells = React__default.Children.toArray(children);
  const breakpoint = useBreakpoint();
  const smDown2 = React__default.useMemo(() => ["sm", "xsm"].some((bp) => bp === breakpoint), [breakpoint]);
  const cellsMeta = React__default.useMemo(
    () => cells.map((cell, index) => {
      const headerName = headers[index] ?? "";
      const desiredIndex = mobileHeadersOrder == null ? void 0 : mobileHeadersOrder.indexOf(headerName);
      return { cell, headerName, index: desiredIndex === -1 ? cells.length : desiredIndex };
    }).sort(({ index: indexA }, { index: indexB }) => {
      if (smDown2) {
        return indexA - indexB;
      }
      return 0;
    }),
    [cells, headers, mobileHeadersOrder, smDown2]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames(tableRow, className, { "d-open": smDown2 && open }), children: [
    smDown2 ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(mobileChevron, { "d-open": open }), onClick: () => setOpen((p) => !p), children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { name: "chevron_down" }) }) : null,
    cellsMeta.map(({ cell, headerName }) => {
      if (React__default.isValidElement(cell) && cell.type === Cell) {
        return React__default.cloneElement(cell, { headerName });
      }
      return cell;
    })
  ] });
};
const Cell = ({ className, children, headerName }) => {
  const { mobileHeadersHidden, mobileHeadersHighlight } = React__default.useContext(TableContext);
  const shouldHighlightHeader = React__default.useMemo(
    () => headerName ? mobileHeadersHighlight == null ? void 0 : mobileHeadersHighlight.includes(headerName) : false,
    [mobileHeadersHighlight, headerName]
  );
  const shouldHideHeader = React__default.useMemo(
    () => headerName ? mobileHeadersHidden == null ? void 0 : mobileHeadersHidden.includes(headerName) : false,
    [mobileHeadersHidden, headerName]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(tableCell, className), children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: tableCellContent, children: [
    headerName && !shouldHideHeader ? /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: mobileHeaderLabel, children: [
      headerName,
      ":"
    ] }) : null,
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "span",
      {
        className: classNames(tableCellContent, {
          [mobileHeaderHighlight]: shouldHighlightHeader
        }),
        children
      }
    )
  ] }) });
};
const Table = ({
  className,
  children,
  mobileHeadersOrder,
  mobileHeadersHighlight,
  mobileHeadersHidden
}) => {
  const [headers, setHeaders] = React__default.useState([]);
  const headerRef = React__default.useRef([]);
  const registerHeader = React__default.useCallback((text) => {
    headerRef.current.push(text);
    setHeaders([...headerRef.current]);
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    TableContext.Provider,
    {
      value: { headers, registerHeader, mobileHeadersOrder, mobileHeadersHighlight, mobileHeadersHidden },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(tableWrapper, className), children })
    }
  );
};
Table.HeaderRow = HeaderRow;
Table.HeaderCell = HeaderCell;
Table.Row = Row;
Table.Cell = Cell;
var container$a = "link_container__10mod2q0";
var disabled$3 = "link_disabled__10mod2q1";
const Link = ({ className, children, CustomLinkComponent, disabled: disabled2, onClick, ...props }) => {
  const consolidatedClassName = React__default.useMemo(
    () => classNames(container$a, className, { [disabled$3]: disabled2 }),
    [className, disabled2]
  );
  if (CustomLinkComponent) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(CustomLinkComponent, { className: consolidatedClassName, ...props, children });
  }
  if (onClick) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: consolidatedClassName, onClick, ...props, children });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("a", { className: consolidatedClassName, ...props, children });
};
var overlay = "popup_overlay__1dmd2mn2";
var popupContainer = "popup_popupContainer__1dmd2mn3";
var popupContainerFullHeight = "popup_popupContainerFullHeight__1dmd2mn4";
var header$1 = "popup_header__1dmd2mn5";
var headerContent = "popup_headerContent__1dmd2mn6";
var closeButton$1 = "popup_closeButton__1dmd2mn7";
var body = "popup_body__1dmd2mn8";
var footer$1 = "popup_footer__1dmd2mn9";
var backButton = "popup_backButton__1dmd2mna";
const PopupContext = React__default.createContext(null);
const usePopup = () => {
  const context = React__default.useContext(PopupContext);
  if (!context) {
    throw new Error("Popup components must be used within <Popup />");
  }
  return context;
};
const Header = ({ className, children }) => {
  const { close } = usePopup();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames(header$1, className), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: headerContent, children }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick: close, className: closeButton$1, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { name: "close" }) })
  ] });
};
Header.displayName = "Popup.Header";
const Body = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(body, className), children });
};
Body.displayName = "Popup.Body";
const Footer$2 = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(footer$1, className), children });
};
Footer$2.displayName = "Popup.Footer";
const BackButton = ({ className, onClick }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(backButton, className), onClick, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { name: "arrow-left" }) });
};
BackButton.displayName = "Popup.BackButton";
const Popup = ({ className, isOpen, onClose, children, mode = "fit-content" }) => {
  const containerRef = React__default.useRef(null);
  React__default.useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("keydown", handleKey);
    };
  }, [onClose]);
  const handleOverlayClick = React__default.useCallback(
    (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        onClose();
      }
    },
    [containerRef, onClose]
  );
  return isOpen ? /* @__PURE__ */ jsxRuntimeExports.jsx(Portal, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: overlay, onMouseDown: handleOverlayClick, children: /* @__PURE__ */ jsxRuntimeExports.jsx(PopupContext.Provider, { value: { close: onClose }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      ref: containerRef,
      className: classNames(popupContainer, className, {
        [popupContainerFullHeight]: mode === "full-height"
      }),
      children
    }
  ) }) }) }) : null;
};
Popup.Header = Header;
Popup.Body = Body;
Popup.Footer = Footer$2;
Popup.BackButton = BackButton;
const Search = ({ onChange, size = "medium", disabled: disabled2, loading, skeleton: skeleton2, placeholder }) => {
  return skeleton2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Search$1.Skeleton, { size }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(Search$1, { onChange, placeholder, size, disabled: disabled2, loading, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Search$1.Icon, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Search$1.Input, {})
  ] });
};
const Accordion2 = ({ items, size, disabled: disabled2, skeleton: skeleton2, variant, className }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion$1, { className, size, variant, disabled: disabled2 || skeleton2, children: items.map((item, key) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Accordion$1.Item, { expandedDefault: key === 0, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion$1.Header, { children: skeleton2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion$1.Skeleton, {}) : item == null ? void 0 : item.head }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion$1.Content, { children: skeleton2 ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion$1.Skeleton, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion$1.Skeleton, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion$1.Skeleton, {})
    ] }) : item == null ? void 0 : item.content })
  ] }, key)) });
};
const FormInput = ({
  className,
  children,
  disabled: disabled2,
  status,
  size,
  label: label2,
  required,
  systemMessageProps = {},
  description: description2,
  placeholder
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormInput$1, { className, disabled: disabled2, children: [
    label2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(FormInput$1.Label, { required, children: label2 }) : null,
    React__default.Children.map(
      children,
      (child) => React__default.isValidElement(child) ? React__default.cloneElement(child, {
        disabled: disabled2,
        status,
        size,
        placeholder,
        ...(child == null ? void 0 : child.props) ?? {}
      }) : child
    ),
    status && !disabled2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(FormInput$1.SystemMessage, { ...systemMessageProps, variant: status }) : null,
    description2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(FormInput$1.Description, { children: description2 }) : null
  ] });
};
var label$2 = "checkbox_label__1chry0s0";
var description$2 = "checkbox_description__1chry0s1";
var disabled$2 = "checkbox_disabled__1chry0s2";
const CheckboxComponent = ({
  className,
  label: label2,
  description: description2,
  size,
  skeleton: skeleton2,
  disabled: disabled2,
  ...rest
}) => {
  const placeholderSize = React__default.useMemo(() => {
    switch (size) {
      case "i16": {
        return 26;
      }
      case "i24": {
        return 34;
      }
    }
  }, [size]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Description,
    {
      className,
      placeholderSize,
      content: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox, { ...rest, size, skeleton: skeleton2, disabled: disabled2, children: label2 ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: classNames(label$2, { [disabled$2]: disabled2 }), children: label2 }) : null }) }),
      children: description2 && !skeleton2 ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: classNames(description$2, { [disabled$2]: disabled2 }), children: description2 }) : null
    }
  );
};
var label$1 = "radio_label__o1ac450";
var description$1 = "radio_description__o1ac451";
var disabled$1 = "radio_disabled__o1ac452";
const RadioComponent = ({
  className,
  label: label2,
  description: description2,
  size,
  disabled: disabled2,
  ...rest
}) => {
  const placeholderSize = React__default.useMemo(() => {
    switch (size) {
      case "large": {
        return 34;
      }
      case "small": {
        return 26;
      }
    }
  }, [size]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Description,
    {
      className,
      placeholderSize,
      content: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Radio, { ...rest, size, disabled: disabled2, children: label2 ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: classNames(label$1, { [disabled$1]: disabled2 }), children: label2 }) : null }) }),
      children: description2 ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: classNames(description$1, { [disabled$1]: disabled2 }), children: description2 }) : null
    }
  );
};
var layout$2 = "radioGroup_layout__1cofbtl0";
const RadioGroup = ({
  className,
  size = "large",
  disabled: disabled2,
  onChange,
  options = [],
  selected: _selected
}) => {
  const [selected, setSelected] = React__default.useState(_selected);
  const handleChange = React__default.useCallback(
    (value2) => {
      setSelected(value2);
      onChange == null ? void 0 : onChange(value2);
    },
    [onChange]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(layout$2, className), children: options.map((option, key) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      RadioComponent,
      {
        size,
        value: option.value,
        selected: option.value === selected,
        disabled: disabled2,
        onChange: () => handleChange(option.value),
        label: option.label,
        description: option.description
      },
      key
    );
  }) });
};
var label = "toggle_label__orhtbg0";
var description = "toggle_description__orhtbg1";
var disabled = "toggle_disabled__orhtbg2";
const ToggleComponent = ({
  className,
  label: label$12,
  description: description$12,
  size,
  disabled: disabled$12,
  ...rest
}) => {
  const placeholderSize = React__default.useMemo(() => {
    switch (size) {
      case "large": {
        return 48;
      }
      case "small": {
        return 32;
      }
    }
  }, [size]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Description,
    {
      className,
      placeholderSize,
      content: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Toggle, { ...rest, size, disabled: disabled$12, children: label$12 ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: classNames(label, { [disabled]: disabled$12 }), children: label$12 }) : null }) }),
      children: description$12 ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: classNames(description, { [disabled]: disabled$12 }), children: description$12 }) : null
    }
  );
};
var layout$1 = "avatarBlock_layout__1ht1vp70";
var content$1 = "avatarBlock_content__1ht1vp71";
const sizesMapping = {
  large: "large",
  small: "medium"
};
const AvatarBlock = ({ className, size = "small", children, ...rest }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames(layout$1, className), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Avatar, { size: sizesMapping[size], ...rest }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: content$1, children })
  ] });
};
var logo$1 = "footer_logo__1m887300";
var layout = "footer_layout__1m887301";
var contentSection = "footer_contentSection__1m887302";
var linksContainer = "footer_linksContainer__1m887303";
var socialsContainer = "footer_socialsContainer__1m887304";
var socialsContent = "footer_socialsContent__1m887305";
var linksBlock = "footer_linksBlock__1m887306";
var linksBlockTitle = "footer_linksBlockTitle__1m887307";
var linksBlockContent = "footer_linksBlockContent__1m887308";
var copyrightSection = "footer_copyrightSection__1m887309";
const LinksContainer = ({ children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: linksContainer, children });
};
const SocialsContainer = ({ children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: socialsContainer, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { className: logo$1, name: "logo" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: socialsContent, children })
  ] });
};
const LinksBlock = ({ title: title2, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: linksBlock, children: [
    title2 ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: linksBlockTitle, children: title2 }) : null,
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: linksBlockContent, children })
  ] });
};
const Footer$1 = ({ className, children, copyrights }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("footer", { className: classNames(layout, className), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: contentSection, children }),
    copyrights ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: copyrightSection, children: copyrights }) : null
  ] });
};
Footer$1.LinksContainer = LinksContainer;
Footer$1.SocialsContainer = SocialsContainer;
Footer$1.LinksBlock = LinksBlock;
var container$9 = "ratingBadge_container__1ew1dbn0";
var icon$2 = "ratingBadge_icon__1ew1dbn1";
const RatingBadge = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames(container$9, className), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { className: icon$2, name: "star" }),
    children
  ] });
};
var container$8 = "connectCard_container__1s6otc10";
var avatarContainer$1 = "connectCard_avatarContainer__1s6otc11";
var rating = "connectCard_rating__1s6otc12";
var contentContainer$2 = "connectCard_contentContainer__1s6otc13";
var contentContainerSpacing = "connectCard_contentContainerSpacing__1s6otc14";
var panelContainer = "connectCard_panelContainer__1s6otc15";
var title = "connectCard_title__1s6otc16";
var primaryText$2 = "connectCard_primaryText__1s6otc17";
var secondaryText$2 = "connectCard_secondaryText__1s6otc18";
var tertiaryText$2 = "connectCard_tertiaryText__1s6otc19";
var buttonIcon = "connectCard_buttonIcon__1s6otc1a";
var closeButton = "connectCard_closeButton__1s6otc1b";
const AvatarComponent = ({ className, rating: rating$1, ...avatarRest }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames(avatarContainer$1, className), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Avatar, { variant: "circle", size: "xl", ...avatarRest }),
    rating$1 && (avatarRest.claimed ?? true) ? /* @__PURE__ */ jsxRuntimeExports.jsx(RatingBadge, { className: rating, children: rating$1 }) : null
  ] });
};
AvatarComponent.displayName = "ConnectCard.Avatar";
const Content$2 = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(contentContainer$2, contentContainerSpacing, className), children });
};
Content$2.displayName = "ConnectCard.Content";
const Panel$1 = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(panelContainer, className), children });
};
Panel$1.displayName = "ConnectCard.Panel";
const Title = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: classNames(title, className), children });
};
Title.displayName = "ConnectCard.Title";
const PrimaryText$2 = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: classNames(primaryText$2, className), children });
};
PrimaryText$2.displayName = "ConnectCard.PrimaryText";
const SecondaryText$2 = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: classNames(secondaryText$2, className), children });
};
SecondaryText$2.displayName = "ConnectCard.SecondaryText";
const TertiaryText$2 = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: classNames(tertiaryText$2, className), children });
};
TertiaryText$2.displayName = "ConnectCard.TertiaryText";
const Button$1 = ({ className, type, children }) => {
  const variant = type === "pending" ? "tertiary" : "primary";
  const iconName = type === "pending" ? "share-alt" : "";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Button$2, { className, variant, size: "small", children: [
    children,
    iconName ? /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { className: buttonIcon, name: iconName }) : null
  ] });
};
Button$1.displayName = "ConnectCard.Button";
const ConnectCard = ({ className, children, onClose }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames(container$8, className), children: [
    onClose ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: closeButton, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { name: "close" }) }) : null,
    children
  ] });
};
ConnectCard.Avatar = AvatarComponent;
ConnectCard.Content = Content$2;
ConnectCard.Panel = Panel$1;
ConnectCard.Title = Title;
ConnectCard.PrimaryText = PrimaryText$2;
ConnectCard.SecondaryText = SecondaryText$2;
ConnectCard.TertiaryText = TertiaryText$2;
ConnectCard.Button = Button$1;
var container$7 = "profileSearchResultCard_container__1rp4px60";
var primaryText$1 = "profileSearchResultCard_primaryText__1rp4px61";
var secondaryText$1 = "profileSearchResultCard_secondaryText__1rp4px62";
var tertiaryText$1 = "profileSearchResultCard_tertiaryText__1rp4px63";
var contentContainer$1 = "profileSearchResultCard_contentContainer__1rp4px64";
var panel = "profileSearchResultCard_panel__1rp4px65";
const PrimaryText$1 = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: classNames(primaryText$1, className), children });
};
PrimaryText$1.displayName = "ProfileSearchResultCard.PrimaryText";
const SecondaryText$1 = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: classNames(secondaryText$1, className), children });
};
SecondaryText$1.displayName = "ProfileSearchResultCard.SecondaryText";
const TertiaryText$1 = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: classNames(tertiaryText$1, className), children });
};
TertiaryText$1.displayName = "ProfileSearchResultCard.TertiaryText";
const Content$1 = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(contentContainer$1, className), children });
};
Content$1.displayName = "ProfileSearchResultCard.Content";
const Panel = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(panel, className), children });
};
Panel.displayName = "ProfileSearchResultCard.Panel";
const ProfileSearchResultCard = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(container$7, className), children });
};
ProfileSearchResultCard.PrimaryText = PrimaryText$1;
ProfileSearchResultCard.SecondaryText = SecondaryText$1;
ProfileSearchResultCard.TertiaryText = TertiaryText$1;
ProfileSearchResultCard.Content = Content$1;
ProfileSearchResultCard.Panel = Panel;
var container$6 = "notifications_container__yrmxt60";
var active = "notifications_active__yrmxt61";
var count = "notifications_count__yrmxt62";
var icon$1 = "notifications_icon__yrmxt63";
const Notifications = ({ className, count: count$1, onClick }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames(container$6, className, { [active]: count$1 > 0 }), onClick, children: [
    count$1 ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: count, children: count$1 }) : null,
    /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { className: icon$1, name: "bell" })
  ] });
};
var container$5 = "tabsNavigation_container__1f2796a0";
var content = "tabsNavigation_content__1f2796a1";
var itemContainer = "tabsNavigation_itemContainer__1f2796a2";
var notificationContainer = "tabsNavigation_notificationContainer__1f2796a3";
var arrowButton = "tabsNavigation_arrowButton__1f2796a4";
var arrowBack = "tabsNavigation_arrowBack__1f2796a5";
var arrowForward = "tabsNavigation_arrowForward__1f2796a6";
const Item = ({ className, children, active: active2, onClick }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(itemContainer, className, { "d-active": active2 }), onClick, children });
};
Item.displayName = "TabsNavigation.Item";
const Notification = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Tag.Notification, { className: classNames(notificationContainer, className), size: "mobile", children });
};
Notification.displayName = "TabsNavigation.Notification";
const throttle = (func, ms) => {
  let isThrottled = false;
  let savedArgs = null;
  let savedThis = null;
  function wrapper2(...args) {
    if (isThrottled) {
      savedArgs = args;
      savedThis = this;
      return;
    }
    func.apply(this, args);
    isThrottled = true;
    setTimeout(() => {
      isThrottled = false;
      if (savedArgs) {
        wrapper2.apply(savedThis, savedArgs);
        savedArgs = savedThis = null;
      }
    }, ms);
  }
  return wrapper2;
};
const TabsNavigation = ({ className, children }) => {
  const scrollRef = React__default.useRef(null);
  const [showBackButton, setShowBackButton] = React__default.useState(false);
  const [showForwardButton, setShowForwardButton] = React__default.useState(false);
  React__default.useEffect(() => {
    const element = scrollRef.current;
    const handleScroll = throttle(() => {
      if (!element) {
        return;
      }
      setShowBackButton(element.scrollLeft > 0);
      setShowForwardButton(element.scrollLeft + element.clientWidth < element.scrollWidth);
    }, 300);
    if (element) {
      element.addEventListener("scroll", handleScroll);
      handleScroll();
    }
    return () => element == null ? void 0 : element.removeEventListener("scroll", handleScroll);
  }, []);
  const scrollHorizontally = React__default.useCallback((step) => {
    var _a;
    (_a = scrollRef.current) == null ? void 0 : _a.scrollBy({ left: step, behavior: "smooth" });
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames(container$5, className), children: [
    showBackButton ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(arrowButton, arrowBack), onClick: () => scrollHorizontally(-100), children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { name: "arrow-left" }) }) : null,
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: scrollRef, className: content, children }),
    showForwardButton ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(arrowButton, arrowForward), onClick: () => scrollHorizontally(100), children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { name: "arrow-right" }) }) : null
  ] });
};
TabsNavigation.Item = Item;
TabsNavigation.Notification = Notification;
var container$4 = "appFooter_container__1yprtkx0";
var buttonContainer = "appFooter_buttonContainer__1yprtkx1";
var icon = "appFooter_icon__1yprtkx2";
var notificationBubble = "appFooter_notificationBubble__1yprtkx3";
var homeActive = "appFooter_homeActive__1yprtkx4";
var networkActive = "appFooter_networkActive__1yprtkx5";
var reviewsActive = "appFooter_reviewsActive__1yprtkx6";
var bookingsActive = "appFooter_bookingsActive__1yprtkx7";
var menuActive = "appFooter_menuActive__1yprtkx8";
var mediaActive = "appFooter_mediaActive__1yprtkx9";
const iconClasses = {
  home: homeActive,
  network: networkActive,
  reviews: reviewsActive,
  bookings: bookingsActive,
  menu: menuActive,
  media: mediaActive
};
const AppFooter = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(container$4, className), children });
};
const Button = ({ className, children, type, active: active2, notifications, onClick }) => {
  const icon$12 = React__default.useMemo(() => {
    switch (type) {
      case "home": {
        return "home-mobile";
      }
      case "network": {
        return "my-network-mobile";
      }
      case "reviews": {
        return "reviews-mobile";
      }
      case "bookings": {
        return "booking-calendar";
      }
      case "menu": {
        return "nav";
      }
      case "media": {
        return "media-centre-mobile";
      }
    }
  }, [type]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames(buttonContainer, className, { "d-active": active2 }), onClick, children: [
    icon$12 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { className: classNames(icon, { [iconClasses[type]]: active2 }), name: icon$12 }) : null,
    notifications ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: notificationBubble }) : null,
    children
  ] });
};
Button.displayName = "AppFooter.Button";
AppFooter.Button = Button;
const SideMenuContext = createContext({});
var container$3 = "dashboardSideMenu_container__1rund0e0 commonStyles_scrollBar__e0bve42";
var header = "dashboardSideMenu_header__1rund0e1";
var closeIcon = "dashboardSideMenu_closeIcon__1rund0e2";
var logo = "dashboardSideMenu_logo__1rund0e3";
var profileSelectorContainer = "dashboardSideMenu_profileSelectorContainer__1rund0e4";
var nameContent = "dashboardSideMenu_nameContent__1rund0e5";
var profileName = "dashboardSideMenu_profileName__1rund0e6";
var profileSpecialty = "dashboardSideMenu_profileSpecialty__1rund0e7";
var expandIcon = "dashboardSideMenu_expandIcon__1rund0e8";
var avatar$1 = "dashboardSideMenu_avatar__1rund0e9";
var navigationItemContainer = "dashboardSideMenu_navigationItemContainer__1rund0ea";
var footer = "dashboardSideMenu_footer__1rund0eb";
var subscriptionPlan = "dashboardSideMenu_subscriptionPlan__1rund0ec";
var subscriptionPlanIcon = "dashboardSideMenu_subscriptionPlanIcon__1rund0ed";
function getInitials(name2) {
  if (!name2) {
    return "";
  }
  const words = name2.trim().split(/\s+/);
  if (words.length === 0) {
    return "";
  }
  const firstInitial = words[0][0] || "";
  const secondInitial = words.length > 1 ? words[1][0] : "";
  return (firstInitial + secondInitial).toUpperCase();
}
const ProfileSelector = ({ className, name: name2, specialty }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames(profileSelectorContainer, className), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Avatar, { className: avatar$1, variant: "circle", size: "medium", initials: getInitials(name2) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { className: expandIcon, name: "chevron_right" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: nameContent, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: profileName, children: name2 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: profileSpecialty, children: specialty })
    ] })
  ] });
};
ProfileSelector.displayName = "DashboardSideMenu.ProfileSelector";
const NavigationItem = ({ className, children, active: active2, onClick }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick, className: classNames(navigationItemContainer, className, { "d-active": active2 }), children });
};
NavigationItem.displayName = "DashboardSideMenu.NavigationItem";
const Footer = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(footer, className), children });
};
Footer.displayName = "DashboardSideMenu.Footer";
const SubscriptionPlan = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames(subscriptionPlan, className), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: subscriptionPlanIcon, children: "👑️" }),
    children
  ] });
};
SubscriptionPlan.displayName = "DashboardSideMenu.SubscriptionPlan";
const DashboardSideMenu = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SideMenuContext.Provider, { value: {}, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames(container$3, className), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: header, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { className: closeIcon, name: "close" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { className: logo, name: "logo" })
    ] }),
    children
  ] }) });
};
DashboardSideMenu.ProfileSelector = ProfileSelector;
DashboardSideMenu.NavigationItem = NavigationItem;
DashboardSideMenu.Footer = Footer;
DashboardSideMenu.SubscriptionPlan = SubscriptionPlan;
var container$2 = "publicProfileTitle_container__6lu8z0";
var name = "publicProfileTitle_name__6lu8z1";
var nameWithIcon = "publicProfileTitle_nameWithIcon__6lu8z2";
var iconWrap = "publicProfileTitle_iconWrap__6lu8z3";
var claimIcon = "publicProfileTitle_claimIcon__6lu8z4";
var verifiedIcon = "publicProfileTitle_verifiedIcon__6lu8z5";
var unverifiedIcon = "publicProfileTitle_unverifiedIcon__6lu8z6";
var suffix = "publicProfileTitle_suffix__6lu8z7";
const PublicProfileTitle = ({
  className,
  name: name$1,
  suffix: suffix$1,
  claimed = true,
  iconTooltipContent
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames(container$2, className), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: nameWithIcon, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: name, children: name$1 }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: iconWrap, children: [
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Tooltip, { position: "bottom", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip.Trigger, { children: claimed ? /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { className: classNames(claimIcon, verifiedIcon), name: "verified" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { className: classNames(claimIcon, unverifiedIcon), name: "unverified" }) }),
          iconTooltipContent ? /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip.Content, { children: iconTooltipContent }) : null
        ] })
      ] })
    ] }),
    " ",
    suffix$1 ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: suffix, children: suffix$1 }) : null
  ] });
};
var container$1 = "publicProfileReview_container__xw7ym80";
var block = "publicProfileReview_block__xw7ym81";
var link = "publicProfileReview_link__xw7ym82";
var total = "publicProfileReview_total__xw7ym83";
var value = "publicProfileReview_value__xw7ym84";
const PublicProfileReview = ({
  className,
  value: value$1,
  size,
  reviewsTotal,
  reviewsTotalLabel,
  total: total$1 = 5,
  claimed = true,
  children,
  link: link$1,
  ...restRatingProps
}) => {
  const displayValue = React__default.useMemo(() => claimed ? value$1 : 0, [claimed, value$1]);
  const ratingValue = React__default.useMemo(() => claimed ? Math.round(Number(value$1) || 0) : 0, [claimed, value$1]);
  const displayReviewsTotal = React__default.useMemo(() => claimed ? reviewsTotal : 0, [claimed, reviewsTotal]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames(container$1, className), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: block, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: value, children: displayValue === 0 ? "-" : displayValue }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: `/${total$1}` })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Rating, { value: ratingValue, size, ...restRatingProps }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: link$1, className: link, children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: total, children: `(${displayReviewsTotal}${reviewsTotalLabel ? ` ${reviewsTotalLabel}` : null})` }) })
    ] }),
    children
  ] });
};
var avatarContainer = "publicProfileAvatar_avatarContainer__n3a8nn0";
var avatar = "publicProfileAvatar_avatar__n3a8nn1";
var playButton = "publicProfileAvatar_playButton__n3a8nn2";
const PublicProfileAvatar = ({ className, onPlayButtonClick, ...rest }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classNames(avatarContainer, className), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Avatar, { className: avatar, ...rest }),
    onPlayButtonClick && (rest.claimed ?? true) ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: playButton, onClick: onPlayButtonClick, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { name: "play-triangle" }) }) : null
  ] });
};
var container = "profileHero_container__d80u7y0";
var primaryText = "profileHero_primaryText__d80u7y1";
var secondaryText = "profileHero_secondaryText__d80u7y2";
var tertiaryText = "profileHero_tertiaryText__d80u7y3";
var contentContainer = "profileHero_contentContainer__d80u7y4";
const PrimaryText = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: classNames(primaryText, className), children });
};
PrimaryText.displayName = "ProfileHero.PrimaryText";
const SecondaryText = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: classNames(secondaryText, className), children });
};
SecondaryText.displayName = "ProfileHero.SecondaryText";
const TertiaryText = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: classNames(tertiaryText, className), children });
};
TertiaryText.displayName = "ProfileHero.TertiaryText";
const Content = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(contentContainer, className), children });
};
Content.displayName = "ProfileHero.Content";
const ProfileHero = ({ className, children }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classNames(container, className), children });
};
ProfileHero.PrimaryText = PrimaryText;
ProfileHero.SecondaryText = SecondaryText;
ProfileHero.TertiaryText = TertiaryText;
ProfileHero.Content = Content;
function usePhoneViewPortHack() {
  useEffect(() => {
    const refineVhValue = throttle(() => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    }, 10);
    refineVhValue();
    window.addEventListener("resize", refineVhValue);
    return () => {
      window.removeEventListener("resize", refineVhValue);
    };
  }, []);
}
const useOnClickOutside = (ref, handler) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && event.target instanceof Node && !ref.current.contains(event.target)) {
        handler == null ? void 0 : handler();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handler, ref]);
};
var __default__$1 = "doctify_theme__17ridcp0";
var __default__ = "wpa_theme__11fb4ls0";
const ThemeProvider = ({
  children,
  theme,
  spritePath
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider$1, { theme: createTheme({}), children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: "d-portal-root", className: theme, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SpriteContext.Provider, { value: spritePath || "", children }) }) });
};
const commonStyles = styles;
export {
  Accordion$1 as Accordion,
  Accordion2 as Accordion$1,
  AlphabetSorting,
  AppFooter,
  Avatar,
  AvatarBlock,
  Button$2 as Button,
  Checkbox,
  CheckboxComponent,
  ConnectCard,
  DashboardSideMenu,
  Description,
  Dropdown,
  ErrorBoundary,
  Footer$1 as Footer,
  FormInput$1 as FormInput,
  FormInput as FormInput$1,
  Gallery,
  Hidden,
  Icon$1 as Icon,
  Input,
  Link,
  Notifications,
  Pagination,
  PhoneInput,
  Popup,
  Portal,
  ProfileHero,
  ProfileSearchResultCard,
  ProgressBar,
  PublicProfileAvatar,
  PublicProfileReview,
  PublicProfileTitle,
  Radio,
  RadioComponent,
  RadioGroup,
  Rating,
  RatingBadge,
  Search$1 as Search,
  Search as Search$1,
  SystemMessage$1 as SystemMessage,
  SystemMessage as SystemMessage$1,
  Table,
  TabsNavigation,
  Tag,
  ThemeProvider,
  Toggle,
  ToggleComponent,
  Tooltip,
  Typography2 as Typography,
  __default__$1 as __default__,
  __default__ as __default__$1,
  breakpoints,
  commonStyles,
  error,
  getPortalDomElement,
  jsxRuntimeExports,
  layout$3 as layout,
  sizes,
  useBreakpoint,
  useOnClickOutside,
  usePhoneViewPortHack,
  vars
};
//# sourceMappingURL=index-DKu8ZaA3.mjs.map
